const _ = {
  BR_ACCESS_TOKEN_INVALID: "登入帳號無效",
  BR_ACCOUNT_BANNED: "帳號被封禁",
  BR_ACCOUNT_NOT_EXIST: "帳號不存在",
  BR_ACCOUNT_NOT_FOUND: "帳號不存在",
  BR_ACCUMULATED_DATA_LENGTH_LIMIT: "錯誤，名稱不得超過30個字元",
  BR_ACTIVATION_CODE_NOT_EXIST: "啟用碼不存在",
  BR_ACTIVATION_CODE_USED: "該啟用碼已被使用",
  BR_ACTIVATION_INVALIDE_FORMAT: "啟用碼格式不正確",
  BR_ACTIVATION_INVALIDE_LENGHTH: "啟用碼長度不正確",
  BR_BINDINGING_FAILURE: "帳號綁定失敗，請重新綁定",
  BR_CONTAINS_DIRTY_WORDS: "字符串包含敏感詞",
  BR_CONTAINS_SPECIAL_CHARS: "字符組合不符合要求",
  BR_DISABLE_LOGIN: "不允許登入",
  BR_DRECTORY_NOT_PREPARED: "目錄創建失敗",
  BR_DUPLICATE_LEADERBOARD_NAME: "排行榜名重複，請修改",
  BR_DUPLICATE_NICKNAME: "暱稱重複",
  BR_DUPLICATE_SHEET_NAME: "名稱重複，請修改",
  BR_EXTENSION_DULICATED_NAME: "重複的插件標示",
  BR_EXTENSION_NOT_FOUND: "未找到插件",
  BR_FF_COST_OVERFLOW: "達到最大cost上限",
  BR_FF_EXPORT_INVALID_ENTITY: "輸出場景物件失敗",
  BR_FF_EXPORT_NO_SCENE: "未找到主場景",
  BR_FF_EXPORT_NO_WORKFLOW: "未找到全局設置",
  BR_FF_LEADERBOARD_COUNT_LIMIT: "排行榜數量上限",
  BR_FF_SHEET_COUNT_LIMIT: "數據表數量達到上限",
  BR_FF_TELEPORTER_UNPAIRED: "傳送物件不匹配",
  BR_FF_WEB_PROXY_HTTP_FAILED: "回傳伺服器失敗",
  BR_FF_WORKSHOP_INVALID_EXPORT_SETTINGS_LENGTH: "導出的地圖檔案大小超過 2.5 MB。 請編輯後重試。",
  BR_FF_WORKSHOP_INVALID_MAP_COVER_LENGTH: "地圖封面檔案大小超過 10 MB。 請編輯後重試。",
  BR_FF_WORKSHOP_INVALID_MAX_MEMBER_NUM: "地圖最大玩家人數超過30人，請編輯後重試。",
  BR_FF_WORKSHOP_INVALID_OPEN_ATTRIBUTES_EXT_LENGTH: "地圖的參數檔大小超過2 MB。 請編輯後重試。",
  BR_FF_WORKSHOP_INVALID_PROJECT_SETTINGS_LENGTH: "地圖的項目檔案大小超過 2 MB。 請編輯後重試。",
  BR_FILE_EXISTED: "檔案已存在",
  BR_FILE_IMPORT_ERROR: "檔案導入失敗",
  BR_FILE_NOT_FOUND: "未找到檔案",
  BR_FILE_OUT_OF_ASSET_FOLDER: "檔案不能儲存於Assets目錄外",
  BR_FILE_OUT_OF_PROJECT_FOLDER: "檔案不能儲存於專案目錄外",
  BR_GAME_ACCOUNT_ALREADY_BOUND: "遊戲帳號已綁定",
  BR_GAME_ACCOUNT_NOT_BOUND: "遊戲帳號未綁定",
  BR_GAME_ACCOUNT_NOT_FOUND: "遊戲帳號不存在",
  BR_INVALID_ARGUMENTS: "參數無效",
  BR_INVALID_FILE: "檔案損毀",
  BR_IPC_CLOSED: "IPC伺服器已關閉",
  BR_IPC_CONNECTED: "IPC伺服器已連接",
  BR_IPC_CREATE_CLIENT_FAILED: "IPC伺服器創建用戶端失敗",
  BR_IPC_IN_PROGRESS: "IPC伺服器連接中",
  BR_IPC_SAME_ADDR_NOT_ALLOWED: "IPC伺服器地址重複",
  BR_LEADERBOARD_NAME_LENGTH_LIMIT: "錯誤，名稱不得超過30個字元",
  BR_NICKNAME_ILLEGAL: "暱稱不合法，請重新修改",
  BR_NICKNAME_OCCUPIED: "暱稱已被使用，請重新修改",
  BR_NOT_IMPLEMENTED: "未執行方式",
  BR_NOT_IN_FOLDER: "檔案不在專案中",
  BR_OK: "無錯誤",
  BR_PROJECT_CORRUPTED: "檔案已損壞",
  BR_PROJECT_EXISTED: "專案已存在",
  BR_PROJECT_FOLDER_NOT_EMPTY: "專案目錄不為空",
  BR_PROJECT_INTERNAL_ONLY: "僅限內部使用",
  BR_PROJECT_NOT_FOUND: "專案不存在",
  BR_PROJECT_NOT_OPENED: "專案未開啟",
  BR_SETTINGS_SIZE_INVALID: "設置文件長度不合法",
  BR_SHAREDATA_KEY_NOT_EXIST: "共享數據索引不存在",
  BR_SHEET_NAME_LENGTH_LIMIT: "錯誤，名稱不得超過30個字元",
  BR_STR_ENCODE_INVALID: "字符串編碼不合法",
  BR_STR_LENGTH_INVALID: "長度錯誤",
  BR_USER_CANCEL: "用戶取消",
  ECA_DES: "自訂指定UI的開啟/關閉",
  ECA_DES_1: "為玩家添加任意數量的武器、物品或防具",
  ECA_NAME: "UI開啟/關閉",
  ECA_NAME_1: "添加物件",
  FE_00_LOOT_SIGHT_TYPE: "Loot點倍鏡類型",
  FE_00_LOOT_WEAPON_TYPE: "Loot點武器類型",
  FE_00_MOVEOBJECT_MOTION_TYPE: "移動物件的移動方式",
  FE_00_M_WS_AITYPE: "AI實體",
  FE_00_ONCLICK: "當按鈕被點擊時",
  FE_00_RESETABLE_ENTITY: "可重置實體",
  FE_00_T_WS_MUSICTYPE_DRUM_TITLE: "鼓鍵類型",
  FE_00_T_WS_MUSICTYPE_L1_TITLE: "合成器鍵類型A",
  FE_00_T_WS_MUSICTYPE_L2_TITLE: "合成器鍵類型B",
  FE_00_T_WS_MUSICTYPE_L3_TITLE: "合成器鍵類型C",
  FE_00_T_WS_MUSICTYPE_PIANO_TITLE: "音樂按鍵類型",
  FE_0_B_BORDER_COLOR: "邊框顏色",
  FE_0_B_BORDER_TEXTURE: "邊框材質",
  FE_0_B_BUILD_FAILED_CONTENT: "生成專案失敗",
  FE_0_B_BUILD_SUCCESS_CONTENT: "創建成功",
  FE_0_B_BUTTON_PUBLISH: "發佈",
  FE_0_B_CUSTOMPROP_COLOR_SELECTED: "顏色",
  FE_0_B_CUSTOMPROP_NOTADDED: "暫未添加屬性",
  FE_0_B_CUSTOMPROP_OPTION: "選項設置",
  FE_0_B_CUSTOMPROP_TYPE_SELECTED: "請選擇類型",
  FE_0_B_ECA_MORE: "更多...",
  FE_0_B_ECA_TIP_SAVE_SELECT: "場景尚未保存，無法選擇物件",
  FE_0_B_ECA_TIP_SELECT: "此物件無法選擇",
  FE_0_B_ENSURE_CLOSE_PUBLISH: "確認退出發佈程序？",
  FE_0_B_ITEM_HIDE: "躲貓貓",
  FE_0_B_PGC_IN: "設計者專用",
  FE_0_B_PGC_INTERNAL: "PGCInternal",
  FE_0_B_POINT_ADD: "添加斷點",
  FE_0_B_POINT_CLEAR: "刪除所有斷點",
  FE_0_B_POINT_DELETE: "刪除斷點",
  FE_0_B_POINT_DISABLE: "停用斷點",
  FE_0_B_POINT_DISABLEALL: "停用所有斷點",
  FE_0_B_POINT_ENABLE: "啟用斷點",
  FE_0_B_POINT_ENABLEALL: "啟用所有斷點",
  FE_0_B_ROUND_DOING: "階段進行",
  FE_0_B_ROUND_END: "階段結束",
  FE_0_B_ROUND_START: "階段開始",
  FE_0_B_SURFACE_COLOR: "貼圖顏色",
  FE_0_B_SURFACE_TEXTURE: "貼圖材質",
  FE_0_B_TIP_CUSTOMPROP_COPIED: "已複製到剪貼簿",
  FE_0_B_TOOL_BUILD: "用戶端",
  FE_0_B_UI_ANCHOR_MAX: "錨點最大值",
  FE_0_B_UI_ANCHOR_MIN: "錨點最小值",
  FE_0_B_UI_BACKGROUNDCOLOR: "背景顏色",
  FE_0_B_UI_BOTTOM: "下",
  FE_0_B_UI_CENTER: "中心點",
  FE_0_B_UI_CUSTOM: "自訂",
  FE_0_B_UI_HEIGHT: "高度",
  FE_0_B_UI_LETF: "左",
  FE_0_B_UI_MIDDLE: "中央",
  FE_0_B_UI_PIVOT: "樞軸",
  FE_0_B_UI_RATIO: "比例",
  FE_0_B_UI_RIGHT: "右",
  FE_0_B_UI_STRETCH: "伸展",
  FE_0_B_UI_TOP: "上",
  FE_0_B_UI_TRANSFORM: "UI變換",
  FE_0_B_UI_WIDTH: "寬度",
  FE_0_B_UI_X: "PosX",
  FE_0_B_UI_Y: "PosY",
  FE_0_B_WORK_EDIT_VARIABLE: "編輯變量",
  FE_0_F_ACTIVATION_ACCOUNT: "退出啟用",
  FE_0_F_ACTIVATION_ENTERCODE: "請輸入啟用碼",
  FE_0_F_ACTIVATION_TITLE: "啟用你的帳號",
  FE_0_F_ACTIVATION_WARNING: "確認退出啟用？",
  FE_0_F_ATTENTION: "注意",
  FE_0_F_BINDING_BUTTON1: "綁定",
  FE_0_F_BINDING_BUTTON2: "前往綁定",
  FE_0_F_BINDING_BUTTON3: "解除綁定",
  FE_0_F_BINDING_CHANGE: "綁定其他帳號",
  FE_0_F_BINDING_CONFIRMINFO: "檢測到您的 Free Fire 帳號資訊，確認綁定此帳號？",
  FE_0_F_BINDING_NICKNAME: "暱稱：{0}",
  FE_0_F_BINDING_NOTICE: "使用 Craftland Studio 須綁定 Free Fire 遊戲帳號，以加載該遊戲項目檔案。",
  FE_0_F_BINDING_NULL: "未綁定帳號",
  FE_0_F_BINDING_NULL_NOTICE: "尚未綁定帳號",
  FE_0_F_BINDING_SUCCESS: "帳號綁定成功！",
  FE_0_F_BINDING_TIPS: "帳號綁定中...",
  FE_0_F_BINDING_TITLE: "請選擇您的 Free Fire 登入方式",
  FE_0_F_BINDING_UNBIND: "帳號已解除綁定",
  FE_0_F_BINDING_UNBIND_TIPS: "解除綁定中...",
  FE_0_F_BINDING_WARNING: "Craftland Studio 需綁定 Free Fire 帳號才能使用，請先完成帳號綁定",
  FE_0_F_BUTTON_CANCEL: "取消",
  FE_0_F_BUTTON_CONFIRM: "確認",
  FE_0_F_ECA_SCRIPT: "ECA 腳本",
  FE_0_F_INSTALL_INSERVICE: "Craftland Studio 正在運行，點擊“確定”關閉",
  FE_0_F_INSTALL_INSTALLING: "安裝中，請稍候...",
  FE_0_F_INSTALL_SETUPLOADING: "安裝程序啟動中，請稍候...",
  FE_0_F_INSTALL_TITLE: "安裝 Craftland Studio",
  FE_0_F_INSTALL_VERIFING: "正在驗證安裝包：{0}",
  FE_0_F_ITEM_BARRIER: "障礙物",
  FE_0_F_ITEM_BASIC_STRUCTURE: "基礎結構",
  FE_0_F_ITEM_BUILDING: "建築",
  FE_0_F_ITEM_CAR: "載具",
  FE_0_F_ITEM_COMMON: "常用",
  FE_0_F_ITEM_COMMON_NOTI: "無常用物件，點擊右鍵添加",
  FE_0_F_ITEM_CONTAINER: "箱型物件",
  FE_0_F_ITEM_DECORATION: "裝飾物",
  FE_0_F_ITEM_FENCE: "圍欄與圍牆",
  FE_0_F_ITEM_FURNITURE: "家具電器",
  FE_0_F_ITEM_GAMEPLAY: "玩法物件",
  FE_0_F_ITEM_HISTORY: "最近使用",
  FE_0_F_ITEM_HISTORY_DELETENOTI: "確定清空最近使用列表？",
  FE_0_F_ITEM_HISTORY_NOTI: "無最近使用物件，點擊右鍵添加",
  FE_0_F_ITEM_HUGEHOUSE: "大型房屋",
  FE_0_F_ITEM_INTERACTIVE: "互動物件",
  FE_0_F_ITEM_LOOT_AMMO: "子彈",
  FE_0_F_ITEM_LOOT_AR: "步槍",
  FE_0_F_ITEM_LOOT_ARMOR: "防具及背包",
  FE_0_F_ITEM_LOOT_BAG: "背包",
  FE_0_F_ITEM_LOOT_FRESH: "刷新項數量",
  FE_0_F_ITEM_LOOT_GROUP: "物品組{0}",
  FE_0_F_ITEM_LOOT_GROUPFRESH: "刷新組數量",
  FE_0_F_ITEM_LOOT_HELMET: "頭盔",
  FE_0_F_ITEM_LOOT_HG: "手槍",
  FE_0_F_ITEM_LOOT_MAGEZINE: "彈匣",
  FE_0_F_ITEM_LOOT_MELEE: "近戰武器",
  FE_0_F_ITEM_LOOT_MUZZLE: "槍口",
  FE_0_F_ITEM_LOOT_NOTRANDOM: "必出",
  FE_0_F_ITEM_LOOT_PARTS: "武器配件",
  FE_0_F_ITEM_LOOT_SG: "霰彈槍",
  FE_0_F_ITEM_LOOT_SMG: "衝鋒槍",
  FE_0_F_ITEM_LOOT_SNG: "狙擊槍",
  FE_0_F_ITEM_LOOT_VEST: "防彈衣",
  FE_0_F_ITEM_LOOT_WEAPON: "武器",
  FE_0_F_ITEM_MIDHOUSE: "中型房屋",
  FE_0_F_ITEM_MODENEED: "模式必需",
  FE_0_F_ITEM_MUSICKEY: "音樂物件",
  FE_0_F_ITEM_OTHERS: "其他",
  FE_0_F_ITEM_PAD_NUM: "共{0}個",
  FE_0_F_ITEM_PIPE: "管道",
  FE_0_F_ITEM_PLANT: "植物",
  FE_0_F_ITEM_PORTAL_PROPERTY: "連結傳送門",
  FE_0_F_ITEM_SPAWN_PROPERTY: "傳送門生成最多人數",
  FE_0_F_ITEM_STREETSCAPE: "街景裝飾",
  FE_0_F_ITEM_STRUCTURE: "結構物件",
  FE_0_F_ITEM_TRIGGER: "觸發器",
  FE_0_F_ITEM_TYRE_PROPERTY: "擊飛距離",
  FE_0_F_LANGUAGE_CNTRA: "繁體中文",
  FE_0_F_LANGUAGE_EN: "English",
  FE_0_F_LAUNCH_ACCOUNTCHECK: "檢查帳號資訊中",
  FE_0_F_LAUNCH_SETTING: "設置初始化中",
  FE_0_F_LAUNCH_UPDATE: "版本更新中",
  FE_0_F_LAUNCH_VERSIONCHECK: "版本檢查中",
  FE_0_F_LOGIN: "用戶登入",
  FE_0_F_LOGIN_CANCEL: "登錄失敗，用戶取消登錄",
  FE_0_F_LOGIN_PRIVACY_POLICY: "隱私政策",
  FE_0_F_LOGIN_SERVICE: "服務條款",
  FE_0_F_LOGIN_TITLE: "請選擇您的Free Fire 我的戰場編輯器 (PC)登錄方式",
  FE_0_F_LOGOUT_WRANING: "確認登出？",
  FE_0_F_NAME: "名稱",
  FE_0_F_NAME_PROPERTY: "物件屬性",
  FE_0_F_NICKNAME_TIPS1: "暱稱修改成功",
  FE_0_F_NOT_ADDED: "未添加",
  FE_0_F_NO_CONTENT_ADDED: "未添加內容",
  FE_0_F_PROGRESS: "進度{0}%",
  FE_0_F_PROJECT_ABOUT: "關於",
  FE_0_F_PROJECT_ALL: "全部",
  FE_0_F_PROJECT_AMEND_DATE: "修改日期",
  FE_0_F_PROJECT_BIND: "帳號綁定",
  FE_0_F_PROJECT_CLOSE: "確認退出嗎？",
  FE_0_F_PROJECT_DECREMENT: "遞減",
  FE_0_F_PROJECT_DELETE_LOCAL: "同時刪除本機檔案",
  FE_0_F_PROJECT_DELETE_TITLE: "刪除專案",
  FE_0_F_PROJECT_DELETE_WARNING: "確認刪除專案{0}？",
  FE_0_F_PROJECT_ECA: "ECA 檔案",
  FE_0_F_PROJECT_FAVORITE: "收藏",
  FE_0_F_PROJECT_FITEM: "fItem 檔案",
  FE_0_F_PROJECT_FOLDER: "資料夾",
  FE_0_F_PROJECT_FSCENEPREFAB: "fScenePrefab 檔案",
  FE_0_F_PROJECT_IMPORT: "輸入",
  FE_0_F_PROJECT_INCREMENT: "遞增",
  FE_0_F_PROJECT_IN_SEARCH: "搜尋中",
  FE_0_F_PROJECT_LANSET: "語言",
  FE_0_F_PROJECT_LARGE: "大",
  FE_0_F_PROJECT_LASTOPEN: "最近開始時間: {0}",
  FE_0_F_PROJECT_LIST: "列表",
  FE_0_F_PROJECT_LOADING: "專案加載中",
  FE_0_F_PROJECT_LOCAL: "開啟本機檔案",
  FE_0_F_PROJECT_LOGOUT: "登出",
  FE_0_F_PROJECT_MANAGE: "創建遊戲",
  FE_0_F_PROJECT_MEDIUM: "中",
  FE_0_F_PROJECT_MODE: "模式選擇",
  FE_0_F_PROJECT_MYPRO: "我的專案",
  FE_0_F_PROJECT_NAME: "專案名稱",
  FE_0_F_PROJECT_NEW: "開新專案",
  FE_0_F_PROJECT_NEW_ECA: "新建 ECA",
  FE_0_F_PROJECT_NEW_FOLDER: "新建資料夾",
  FE_0_F_PROJECT_NEW_UI: "新建UI",
  FE_0_F_PROJECT_NEW_WARNING: "專案名稱不得為空",
  FE_0_F_PROJECT_NULL_NOTICE: "專案名稱不能為空",
  FE_0_F_PROJECT_PATH: "檔案位置",
  FE_0_F_PROJECT_PIC: "圖示",
  FE_0_F_PROJECT_PREFAB: "Prefab 檔案",
  FE_0_F_PROJECT_RENAME_NOTICE: "名稱請勿包含*, /, \\等字元",
  FE_0_F_PROJECT_RENAME_WARNING: "名稱包含敏感字元",
  FE_0_F_PROJECT_SCENE: "Scene 檔案",
  FE_0_F_PROJECT_SCRIPT: "腳本檔案",
  FE_0_F_PROJECT_SIZE: "大小",
  FE_0_F_PROJECT_SMALL: "小",
  FE_0_F_PROJECT_SORT_BY: "排序方式",
  FE_0_F_PROJECT_TEXT: "文字檔案",
  FE_0_F_PROJECT_TEXTURE: "紋理檔案",
  FE_0_F_PROJECT_TREE_VIEW: "顯示樹狀圖",
  FE_0_F_PROJECT_UI: "UI 檔案",
  FE_0_F_PROJECT_UPDATE: "檢查更新",
  FE_0_F_RUNTIME_ADDBOT: "添加人機",
  FE_0_F_RUNTIME_CLIENT: "用戶端",
  FE_0_F_RUNTIME_COMMAND: "控制指令",
  FE_0_F_RUNTIME_CONSOLE_COMMAND: "執行{0}指令中",
  FE_0_F_RUNTIME_END_BACK: "回到編輯器",
  FE_0_F_RUNTIME_END_NOTICE: "當前遊戲進程出現異常",
  FE_0_F_RUNTIME_END_RESTART: "重新開始",
  FE_0_F_RUNTIME_END_TITLE: "退出運行",
  FE_0_F_RUNTIME_GODMODE: "無敵",
  FE_0_F_RUNTIME_KEYBOARD: "鍵位提示",
  FE_0_F_RUNTIME_LOADING: "遊戲加載中",
  FE_0_F_RUNTIME_PAUSE: "暫停",
  FE_0_F_RUNTIME_RECORD: "日誌",
  FE_0_F_RUNTIME_RECOVER: "恢復血量",
  FE_0_F_RUNTIME_RUN: "運行",
  FE_0_F_RUNTIME_STOP: "停止",
  FE_0_F_RUNTIME_SUICIDE: "自殺",
  FE_0_F_RUNTIME_TELEPORT: "傳送至出生點",
  FE_0_F_SCENE: "場景{0}",
  FE_0_F_SCENE_AUTOFILL: "自動填滿",
  FE_0_F_SCENE_EDITOR_ISO: "透視投影",
  FE_0_F_SCENE_EDITOR_PERSP: "正交投影",
  FE_0_F_SCENE_ITEM_COMMON: "設為常用物件",
  FE_0_F_SCENE_ITEM_COMMON_REMOVE: "從常用物件移除",
  FE_0_F_SCENE_ITEM_NEW: "在場景中創建",
  FE_0_F_SCENE_LOADING: "地圖讀取中",
  FE_0_F_SCENE_NEW: "新建場景",
  FE_0_F_SCENE_SAVE: "儲存場景",
  FE_0_F_SCENE_SAVE_ALL: "儲存全部場景",
  FE_0_F_SCENE_TYPE: "地圖類型",
  FE_0_F_SEARCH_NOTI: "輸入關鍵字搜尋",
  FE_0_F_SEARCH_NULL: "未找到相關結果",
  FE_0_F_TRANSFORM: "變換",
  FE_0_F_TRANSFORM_POSITION: "位置",
  FE_0_F_TRANSFORM_ROTATION: "旋轉",
  FE_0_F_TRANSFORM_SCALE: "縮放",
  FE_0_F_UNDO_DELETE: "繼續操作會刪除{0}資料夾，確認刪除？",
  FE_0_F_UNINSTALL_CONFIRM: "確認解除安裝 Craftland Studio 嗎？",
  FE_0_F_UNINSTALL_TITLE: "解除安裝 Craftland Studio",
  FE_0_F_UPDATE: "更新",
  FE_0_F_UPDATE_FAILURE: "更新失敗",
  FE_0_F_UPDATE_RETRY: "重試",
  FE_0_F_VIEW: "瀏覽",
  FE_0_HW_BUTTON_CANCEL: "取消",
  FE_0_HW_BUTTON_COPY: "複製",
  FE_0_HW_BUTTON_NO: "否",
  FE_0_HW_BUTTON_OK: "確認",
  FE_0_HW_BUTTON_SAVE: "儲存",
  FE_0_HW_BUTTON_UNSAVE: "不儲存",
  FE_0_HW_BUTTON_YES: "是",
  FE_0_HW_CAMERA_DISTANCE: "距離",
  FE_0_HW_CAMERA_FOV: "視野範圍",
  FE_0_HW_CAMERA_HORIZONTALANGLE: "水平角",
  FE_0_HW_CAMERA_MODE: "相機模式",
  FE_0_HW_CAMERA_MODE_1: "經典 FF (射擊)",
  FE_0_HW_CAMERA_MODE_2: "第三人稱",
  FE_0_HW_CAMERA_MODE_3: "第一人稱 (射擊)",
  FE_0_HW_CAMERA_MODE_4: "俯視角",
  FE_0_HW_CAMERA_OFFSET: "偏移量",
  FE_0_HW_CAMERA_TITLE: "相機設置",
  FE_0_HW_CAMERA_VERTICALANGLE: "俯仰角",
  FE_0_HW_CANNOT_PREVIEW: "無預覽效果",
  FE_0_HW_CATEGORY_COMMON: "常用",
  FE_0_HW_CATEGORY_DATA: "數據",
  FE_0_HW_CATEGORY_ENTITY: "實體",
  FE_0_HW_CATEGORY_EVENT: "事件",
  FE_0_HW_CATEGORY_EXTERNALFUNCTION: "外部函數",
  FE_0_HW_CATEGORY_FUNCTION: "函數",
  FE_0_HW_CATEGORY_GAME: "遊戲",
  FE_0_HW_CATEGORY_LOGIC: "邏輯",
  FE_0_HW_CATEGORY_SEARCH: "搜尋",
  FE_0_HW_CATEGORY_VARIBLE: "變量",
  FE_0_HW_CTRL_BUTTON: "按鈕",
  FE_0_HW_CTRL_GRAPH: "圖片",
  FE_0_HW_CTRL_INPUT: "文字圖塊",
  FE_0_HW_CTRL_LAYOUT: "版面佈局",
  FE_0_HW_CTRL_PANEL: "面板",
  FE_0_HW_CTRL_TEXT: "文字",
  FE_0_HW_CUSTOMPROP_HINT: "注意：所有修改會套用於同類型的實例",
  FE_0_HW_CUSTOMPROP_NAME: "屬性名稱",
  FE_0_HW_CUSTOMPROP_NAMEHINT: "請輸入屬性名稱",
  FE_0_HW_CUSTOMPROP_SUBTITLE: "設置{0}的自訂屬性",
  FE_0_HW_CUSTOMPROP_TITLE: "自訂屬性",
  FE_0_HW_CUSTOMPROP_TYPE: "類型",
  FE_0_HW_CUSTOMPROP_TYPEHINT: "請輸入屬性初始值",
  FE_0_HW_CUSTOMPROP_VALUE: "初始值",
  FE_0_HW_DATA_ALL_COMMENT: "全部評論",
  FE_0_HW_EDITOR_FLOW: "遊戲編輯器",
  FE_0_HW_EDITOR_LOGIC: "邏輯編輯器",
  FE_0_HW_EDITOR_SCENE: "場景編輯器",
  FE_0_HW_EDITOR_UI: "UI編輯器",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_END: "遊戲結束",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_FLOW: "程序設置",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PHASE: "遊戲階段",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PLAYER: "玩家設置",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PREPARE: "遊戲準備",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_ROUND: "遊戲回合",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_START: "遊戲開始",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_TEAM: "隊伍設置",
  FE_0_HW_GAME_EDITOR_FLOWSETTING: "程序設置",
  FE_0_HW_GAME_EDITOR_FLOW_END: "遊戲結束",
  FE_0_HW_GAME_EDITOR_FLOW_PHASE: "遊戲階段",
  FE_0_HW_GAME_EDITOR_FLOW_PREPARE: "遊戲準備",
  FE_0_HW_GAME_EDITOR_FLOW_ROUND: "遊戲回合",
  FE_0_HW_GAME_EDITOR_FLOW_START: "遊戲開始",
  FE_0_HW_GAME_EDITOR_INSPECT_ACTIVESKILL: "主動技能",
  FE_0_HW_GAME_EDITOR_INSPECT_DAMAGEINFLICTED: "傷害倍率",
  FE_0_HW_GAME_EDITOR_INSPECT_DAMAGETAKEN: "承受傷害倍率",
  FE_0_HW_GAME_EDITOR_INSPECT_DEFAULTEPPERCENT: "初始EP比例",
  FE_0_HW_GAME_EDITOR_INSPECT_ECA: "邏輯編輯",
  FE_0_HW_GAME_EDITOR_INSPECT_EPQUICKRESTORE: "EP快速轉換",
  FE_0_HW_GAME_EDITOR_INSPECT_ID: "ID",
  FE_0_HW_GAME_EDITOR_INSPECT_JUMPHEIGHT: "跳躍高度",
  FE_0_HW_GAME_EDITOR_INSPECT_MAXEP: "最大EP",
  FE_0_HW_GAME_EDITOR_INSPECT_MAXHP: "生命上限",
  FE_0_HW_GAME_EDITOR_INSPECT_MOVESPEED: "移動速度",
  FE_0_HW_GAME_EDITOR_INSPECT_NAME: "名稱",
  FE_0_HW_GAME_EDITOR_INSPECT_PASSIVESKILL: "被動技能",
  FE_0_HW_GAME_EDITOR_INSPECT_PLAYERNUMPERTEAM: "每隊玩家數量",
  FE_0_HW_GAME_EDITOR_INSPECT_ROUNDCOUNT: "回合數",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET10: "Chrono",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET11: "斯凱伊爾",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET12: "夏涅",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET13: "Dimitri",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET4: "悟空",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET5: "A124",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET6: "Alok",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET7: "史黛菲",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET8: "克露",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET9: "K",
  FE_0_HW_GAME_EDITOR_INSPECT_TEAMNUM: "隊伍數量",
  FE_0_HW_GAME_EDITOR_INSPECT_TIME: "時間",
  FE_0_HW_GAME_EDITOR_INSPECT_TITLE_BASIC: "基礎設置",
  FE_0_HW_GAME_EDITOR_INSPECT_TITLE_SKILL: "技能設置",
  FE_0_HW_GAME_EDITOR_INSPECT_UNLIMITEDAMMO: "彈藥限制",
  FE_0_HW_GAME_EDITOR_PLAYERSETTING: "玩家設置",
  FE_0_HW_GAME_EDITOR_TEAMSETTING: "隊伍設置",
  FE_0_HW_GENERAL_TEMPLATE: "模板",
  FE_0_HW_GRAPH_ANYTYPE: "任意類型",
  FE_0_HW_GRAPH_AS_TYPE: "為",
  FE_0_HW_GRAPH_BREAK: "中斷循環",
  FE_0_HW_GRAPH_CALLRETURN: "返回",
  FE_0_HW_GRAPH_CONTINUE: "繼續下一個",
  FE_0_HW_GRAPH_CREATELIST: "定義數組",
  FE_0_HW_GRAPH_ELSE: "否則",
  FE_0_HW_GRAPH_ELSEIF: "否則如果",
  FE_0_HW_GRAPH_EXTERNALCALL: "外部調用",
  FE_0_HW_GRAPH_EXTERNAL_GET: "獲取外部",
  FE_0_HW_GRAPH_EXTERNAL_GET_2: "從",
  FE_0_HW_GRAPH_EXTERNAL_SET: "設置外部",
  FE_0_HW_GRAPH_EXTERNAL_SET_3: "為",
  FE_0_HW_GRAPH_FLOAT: "小數",
  FE_0_HW_GRAPH_FOREACH: "對於每個",
  FE_0_HW_GRAPH_FOREACH_2: "取自",
  FE_0_HW_GRAPH_FOR_INDEX: "索引",
  FE_0_HW_GRAPH_FOR_INDEX_1: "從",
  FE_0_HW_GRAPH_FOR_INDEX_2: "至",
  FE_0_HW_GRAPH_FOR_INDEX_3: "逐步",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_ACT: "行為",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_RETURN: "返回",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_VAL: "函數",
  FE_0_HW_GRAPH_FUNCTION_MUTATOR_PARA: "參數",
  FE_0_HW_GRAPH_GET_CUSTOM_INSP: "獲取實體屬性",
  FE_0_HW_GRAPH_GLOBAL_GET: "獲取全局",
  FE_0_HW_GRAPH_GLOBAL_SET: "設置全局",
  FE_0_HW_GRAPH_GLOBAL_SET_1: "為",
  FE_0_HW_GRAPH_IF: "若",
  FE_0_HW_GRAPH_INDEX: "索引",
  FE_0_HW_GRAPH_INT: "整數",
  FE_0_HW_GRAPH_LISTAPPEND: "賦值",
  FE_0_HW_GRAPH_LISTAPPEND_1: "為",
  FE_0_HW_GRAPH_LISTGET: "獲取",
  FE_0_HW_GRAPH_LISTINSERT: "賦值",
  FE_0_HW_GRAPH_LISTINSERT_1: "為",
  FE_0_HW_GRAPH_LISTINSERT_2: "給",
  FE_0_HW_GRAPH_LISTSET: "設置",
  FE_0_HW_GRAPH_LISTTYPELABEL: "列舉",
  FE_0_HW_GRAPH_NONE: "未選擇",
  FE_0_HW_GRAPH_NULL: "空",
  FE_0_HW_GRAPH_NUMBER: "數字",
  FE_0_HW_GRAPH_OP_AND: "且",
  FE_0_HW_GRAPH_OP_OR: "或",
  FE_0_HW_GRAPH_PARALLELCALL: "執行",
  FE_0_HW_GRAPH_PICK_ENTITY: "選擇場景物件",
  FE_0_HW_GRAPH_PICK_WIDGET: "選擇UI控件",
  FE_0_HW_GRAPH_PROPERTY_GET: "獲取",
  FE_0_HW_GRAPH_PROPERTY_GET_1: "從",
  FE_0_HW_GRAPH_PROPERTY_SET: "設置",
  FE_0_HW_GRAPH_PROPERTY_SET_2: "為",
  FE_0_HW_GRAPH_RETURN_SENTENSE: "返回",
  FE_0_HW_GRAPH_SERIALCALL: "等待",
  FE_0_HW_GRAPH_SET_CUSTOM_INSP: "設置實體屬性",
  FE_0_HW_GRAPH_TEXT: "文字",
  FE_0_HW_GRAPH_UNKOWN_TYPE: "未知類型",
  FE_0_HW_INSPECT_ADD_COMPONENT: "添加組件",
  FE_0_HW_INSPECT_COPY_PROP: "複製屬性值",
  FE_0_HW_INSPECT_CUSTOMPROP: "添加自訂屬性",
  FE_0_HW_INSPECT_CUSTOM_INSP: "自訂屬性組",
  FE_0_HW_INSPECT_ECA_FILE: "圖塊檔案",
  FE_0_HW_INSPECT_NAME: "名稱",
  FE_0_HW_INSPECT_ONCLICK: "點擊事件",
  FE_0_HW_INSPECT_PASTE_PROP: "貼上屬性值",
  FE_0_HW_INSPECT_POSITION: "位置",
  FE_0_HW_INSPECT_RESET_PROP: "重置",
  FE_0_HW_INSPECT_ROTATION: "旋轉",
  FE_0_HW_INSPECT_SCALE: "縮放",
  FE_0_HW_INSPECT_TITLE_ANCHOR: "錨點",
  FE_0_HW_INSPECT_TITLE_BUTTON: "按鈕",
  FE_0_HW_INSPECT_TITLE_BUTTON_ONCLICKS: "點擊回呼",
  FE_0_HW_INSPECT_TITLE_IMAGE: "圖片",
  FE_0_HW_INSPECT_TITLE_INPUT: "文字方塊",
  FE_0_HW_INSPECT_TITLE_LAYOUT: "版面佈局",
  FE_0_HW_INSPECT_TITLE_TEXT: "文字",
  FE_0_HW_INSPECT_TITLE_TRANSFORM: "變換",
  FE_0_HW_INSPECT_TYPE: "類型",
  FE_0_HW_INSPECT_VALUE: "初始值",
  FE_0_HW_LABEL_FILE_NAME: "檔案名",
  FE_0_HW_LABEL_GRAPH_TEMPLATE_DESC: "模板说明",
  FE_0_HW_LABEL_GRAPH_TEMPLATE_NAME: "模板名稱",
  FE_0_HW_LABEL_GRAPH_VARIABLE_NAME: "變量名稱",
  FE_0_HW_LABEL_GRAPH_VARIABLE_TYPE: "變量類型",
  FE_0_HW_LABEL_NO_ECA: "未添加",
  FE_0_HW_LABEL_TRASHCAN: "資源回收桶",
  FE_0_HW_LAYOUT_CONSOLE: "控制臺",
  FE_0_HW_LAYOUT_CONTROL: "控件",
  FE_0_HW_LAYOUT_GAME: "遊戲",
  FE_0_HW_LAYOUT_HIERARCHY: "層級",
  FE_0_HW_LAYOUT_INSPECTOR: "屬性",
  FE_0_HW_LAYOUT_MODEL: "物件",
  FE_0_HW_LAYOUT_OVERVIEW: "總覽",
  FE_0_HW_LAYOUT_PROJECT: "專案",
  FE_0_HW_LAYOUT_TEMPLATE: "模板",
  FE_0_HW_MENU_ABOUT: "關於",
  FE_0_HW_MENU_ACCOUNT: "帳號",
  FE_0_HW_MENU_ADDCHILD: "添加子階段",
  FE_0_HW_MENU_ADDPHASE: "添加階段",
  FE_0_HW_MENU_ADDROUND: "添加回合",
  FE_0_HW_MENU_ALIGN_ECA: "對齊圖塊",
  FE_0_HW_MENU_API: "API 檔案",
  FE_0_HW_MENU_ASSET: "資源",
  FE_0_HW_MENU_ASSETSTORE: "資源商城",
  FE_0_HW_MENU_CANVAS_BG: "畫布背景",
  FE_0_HW_MENU_CANVAS_DARK: "深色",
  FE_0_HW_MENU_CANVAS_LIGHT: "淺色",
  FE_0_HW_MENU_CLEAR_BLOCK: "清空圖塊",
  FE_0_HW_MENU_COLLAPSE_ECA: "摺疊圖塊",
  FE_0_HW_MENU_COMMENT_ECA: "備註",
  FE_0_HW_MENU_CONTACT: "聯絡我們",
  FE_0_HW_MENU_COPY: "複製",
  FE_0_HW_MENU_CREATE: "新建",
  FE_0_HW_MENU_CUT: "剪下",
  FE_0_HW_MENU_DEBUG: "開發者工具",
  FE_0_HW_MENU_DEFAULT: "預設",
  FE_0_HW_MENU_DEFAULT_ZOOM: "重置縮放",
  FE_0_HW_MENU_DELETE: "刪除",
  FE_0_HW_MENU_DELETELAYOUT: "刪除版面佈局",
  FE_0_HW_MENU_DUPLICATE: "快速複製",
  FE_0_HW_MENU_EDIT: "編輯",
  FE_0_HW_MENU_EDITOR: "編輯器",
  FE_0_HW_MENU_EXIT: "退出",
  FE_0_HW_MENU_FILE: "檔案",
  FE_0_HW_MENU_FIT_WINDOW: "適應視窗",
  FE_0_HW_MENU_GRID_LINE: "格線",
  FE_0_HW_MENU_HELP: "幫助",
  FE_0_HW_MENU_LANGUAGE: "語言",
  FE_0_HW_MENU_LANG_EN: "English",
  FE_0_HW_MENU_LANG_SC: "简体中文",
  FE_0_HW_MENU_LANG_TC: "繁體中文",
  FE_0_HW_MENU_LAYOUT: "版面佈局",
  FE_0_HW_MENU_LOCK: "鎖定",
  FE_0_HW_MENU_MANUAL: "用戶手冊",
  FE_0_HW_MENU_NEWPROJECT: "開新專案",
  FE_0_HW_MENU_OPEN: "開啟",
  FE_0_HW_MENU_OPENLOG: "開啟日誌目錄",
  FE_0_HW_MENU_OPENPROJECT: "開啟專案",
  FE_0_HW_MENU_PASTE: "貼上",
  FE_0_HW_MENU_PUBLISHPROJECT: "發佈專案",
  FE_0_HW_MENU_REDO: "取消復原",
  FE_0_HW_MENU_RENAME: "重新命名",
  FE_0_HW_MENU_SAVELAYOUT: "儲存版面佈局",
  FE_0_HW_MENU_SAVEPROJECT: "儲存專案",
  FE_0_HW_MENU_SAVE_BLOCK_AS_TEMP: "添加到模板",
  FE_0_HW_MENU_SAVE_WORKSPACE: "儲存",
  FE_0_HW_MENU_SETING_COMMON: "設為常用",
  FE_0_HW_MENU_SETTINGS: "設置",
  FE_0_HW_MENU_SKIN: "主題",
  FE_0_HW_MENU_SMART_LINE: "格線輔助",
  FE_0_HW_MENU_UNCOLLAPSE_ECA: "展開圖塊",
  FE_0_HW_MENU_UNDO: "復原",
  FE_0_HW_MENU_UNLOCK: "解鎖",
  FE_0_HW_MENU_WIDE: "寬屏",
  FE_0_HW_MENU_WINDOW: "視窗",
  FE_0_HW_MENU_ZOOMIN: "放大",
  FE_0_HW_MENU_ZOOMOUT: "縮小",
  FE_0_HW_POPUP_DELETE_FILE: "確認刪除{0}檔案?",
  FE_0_HW_POPUP_NOT_SAVE: "返回後填寫的資料不會儲存，確認返回？",
  FE_0_HW_POPUP_NO_ATTENTION: "今日不再提醒",
  FE_0_HW_POPUP_SAVE_FILE: "有未儲存的檔案，是否儲存？",
  FE_0_HW_POPUP_SENTENCE: "已複製戰場碼，邀請好友一同遊玩！",
  FE_0_HW_POPUP_TITLE_COMMENT: "評論",
  FE_0_HW_POPUP_TITLE_ITEM: "物件選擇",
  FE_0_HW_POPUP_TITLE_MAP_SHARE: "分享戰場碼",
  FE_0_HW_POPUP_TITLE_ON_PUB: "發佈遊戲",
  FE_0_HW_POPUP_TITLE_PROP: "物品選擇",
  FE_0_HW_POPUP_TITLE_PUB_SUCCESS: "發佈成功",
  FE_0_HW_POPUP_TITLE_TIP: "提示",
  FE_0_HW_PROJECT_COMMENT_ORDER: "評論次數",
  FE_0_HW_PROJECT_DATA: "數據中心",
  FE_0_HW_PROJECT_DEFAULT_ORDER: "默認排序",
  FE_0_HW_PROJECT_GAME_DATA: "遊戲數據",
  FE_0_HW_PROJECT_GAME_MODE: "遊戲模式",
  FE_0_HW_PROJECT_GAME_PUBLISH: "發佈時間",
  FE_0_HW_PROJECT_LIKE_ORDER: "按讚次數",
  FE_0_HW_PROJECT_PERSONAL_PAGE: "個人主頁",
  FE_0_HW_PROJECT_SUB_ORDER: "收藏次數",
  FE_0_HW_PUBLISH_CREATOR: "創作者",
  FE_0_HW_PUBLISH_DESCRIPTION: "遊戲描述",
  FE_0_HW_PUBLISH_GAME_NAME: "名稱",
  FE_0_HW_PUBLISH_MODE: "模式",
  FE_0_HW_PUBLISH_PLAYER: "玩家",
  FE_0_HW_PUBLISH_SCREENSHOT: "遊戲截圖",
  FE_0_HW_SEARCH_NO_RESOURCE: "未找到資源",
  FE_0_HW_SEARCH_NO_TARGET: "未找到目標",
  FE_0_HW_SEARCH_PLACEHOLDER: "搜尋",
  FE_0_HW_TEMPLATE_NAME_1: "基礎",
  FE_0_HW_TEMPLATE_NAME_2: "殲滅",
  FE_0_HW_TEMPLATE_NAME_3: "獲得分數",
  FE_0_HW_TEMPLATE_NAME_4: "跑酷",
  FE_0_HW_TEMPLATE_NAME_5: "防守生存",
  FE_0_HW_TEXT_ADD_GRAPH_TEMPLATE: "添加圖塊模板",
  FE_0_HW_TEXT_CUSTOM_GRAPH_TEMPLATE: "自訂模板",
  FE_0_HW_TEXT_DEL_GRAPH_TEMPLATE: "刪除圖塊模板",
  FE_0_HW_TEXT_EDIT_GRAPH_TEMPLATE: "修改圖塊模板",
  FE_0_HW_TEXT_OFFICIAL_GRAPH_TEMPLATE: "官方模板",
  FE_0_HW_TIP_CHANGE_OWNERTYPE: "確認更改目前的實體類型？",
  FE_0_HW_TIP_CHOOSE_SLOT: "請選擇欲發佈遊戲的欄位",
  FE_0_HW_TIP_COPIED: "已複製",
  FE_0_HW_TIP_COPY_CODE: "複製戰場碼並分享給您的朋友：",
  FE_0_HW_TIP_CUSTOMPROP_SAMENAME: "同類型屬性已有相同名稱",
  FE_0_HW_TIP_CUSTOM_INSP_SAME_NAME: "同類型屬性已有相同名稱",
  FE_0_HW_TIP_CUSTOM_INSP_STRING_LEN: "字串不能超過20個字元",
  FE_0_HW_TIP_GRAPH_DELETE: "確認刪除模板{0}？",
  FE_0_HW_TIP_GRAPH_INPUT_DESC: "請輸入圖塊說明",
  FE_0_HW_TIP_GRAPH_INPUT_NAME: "請輸入模板名稱",
  FE_0_HW_TIP_GRAPH_TEMPLATE_DESC_LEN: "備註不可超過{0}個字元",
  FE_0_HW_TIP_GRAPH_TEMPLATE_NAME_LEN: "模板名稱不可超過{0}個字元",
  FE_0_HW_TIP_INPUT: "請輸入",
  FE_0_HW_TIP_NAME_EMPTY: "檔案名不能為空",
  FE_0_HW_TIP_NOEXTERNAL: "當前你沒有外部定義的變量或函數，此處不會顯示任何內容",
  FE_0_HW_TIP_NO_GAME_PUBLISH: "尚未發布遊戲專案",
  FE_0_HW_TIP_PREPARE_PUBLISH: "正在準備發佈程序...",
  FE_0_HW_TIP_PUBLISH_COVER: "此操作會覆蓋原有已發佈遊戲，是否繼續？",
  FE_0_HW_TIP_PUBLISH_SUCCESS: "您的遊戲已成功發佈！",
  FE_0_HW_TIP_SAVE_SUCCESS: "儲存成功",
  FE_0_HW_TIP_TO_CLEAR_TRASHCAN: "確認清空資源回收桶？",
  FE_0_HW_TIP_TO_SAVE: "當前工作區有未儲存的修改，是否儲存？",
  FE_0_HW_TIP_UNLOCK_SLOT: "請至Free Fire我的戰場中解鎖該欄位",
  FE_0_HW_TIP_VALUE_NOT_MATCH: "輸入的初始值和限定類型不匹配",
  FE_0_HW_TIP_WAIT_PUBLISH: "發佈中...請耐心等候",
  FE_0_HW_TITLE_PREVIEW: "預覽",
  FE_0_HW_TITLE_SAVE_WORK: "儲存工作區",
  FE_0_HW_TITLE_SOURCE_MANAGE: "資源管理",
  FE_0_HW_TITLE_TIP: "提示",
  FE_0_HW_TOOL_ADSORP_BOTTOM: "向下吸附",
  FE_0_HW_TOOL_ADSORP_LEFT: "向左吸附",
  FE_0_HW_TOOL_ADSORP_RIGHT: "向右吸附",
  FE_0_HW_TOOL_ADSORP_TOP: "向上吸附",
  FE_0_HW_TOOL_ALIGN_BOTTOM: "底端對齊",
  FE_0_HW_TOOL_ALIGN_LEFT: "左對齊",
  FE_0_HW_TOOL_ALIGN_RIGHT: "右對齊",
  FE_0_HW_TOOL_ALIGN_TOP: "頂端對齊",
  FE_0_HW_TOOL_CENTER: "中心",
  FE_0_HW_TOOL_CENTER_HOR: "水平置中",
  FE_0_HW_TOOL_CENTER_VER: "垂直置中",
  FE_0_HW_TOOL_CLIENT: "用戶端",
  FE_0_HW_TOOL_DISTRI_HOR: "水平分佈",
  FE_0_HW_TOOL_DISTRI_VER: "垂直分布",
  FE_0_HW_TOOL_GLOBAL: "世間空間",
  FE_0_HW_TOOL_GRID: "格線對齊",
  FE_0_HW_TOOL_GROUP: "組合",
  FE_0_HW_TOOL_HAND: "選擇",
  FE_0_HW_TOOL_LOCAL: "遊戲對象",
  FE_0_HW_TOOL_MOVE: "移動",
  FE_0_HW_TOOL_PIVOT: "樞軸",
  FE_0_HW_TOOL_REDO: "取消復原",
  FE_0_HW_TOOL_ROTATE: "旋轉",
  FE_0_HW_TOOL_SAVE: "儲存",
  FE_0_HW_TOOL_SCALE: "縮放",
  FE_0_HW_TOOL_SURF: "表面對齊",
  FE_0_HW_TOOL_TRANS: "變換",
  FE_0_HW_TOOL_UNDO: "復原",
  FE_0_HW_TOOL_UNGROUP: "取消組合",
  FE_0_HW_TOOL_VERTEX: "頂點對齊",
  FE_0_HW_UI_EDITOR_INSPECT_ACTIVE: "顯示",
  FE_0_HW_UI_EDITOR_INSPECT_BACKGROUND: "背景",
  FE_0_HW_UI_EDITOR_INSPECT_CELLSIZE: "子級大小",
  FE_0_HW_UI_EDITOR_INSPECT_COLOR: "顏色",
  FE_0_HW_UI_EDITOR_INSPECT_CONSTRAINT: "限制",
  FE_0_HW_UI_EDITOR_INSPECT_CONS_COLUMN: "限制列數",
  FE_0_HW_UI_EDITOR_INSPECT_CONS_ROW: "限制行數",
  FE_0_HW_UI_EDITOR_INSPECT_DISABLE: "禁用",
  FE_0_HW_UI_EDITOR_INSPECT_DOWN: "下",
  FE_0_HW_UI_EDITOR_INSPECT_FILL_DIRECTION: "填滿方向",
  FE_0_HW_UI_EDITOR_INSPECT_FLEX: "自動換行",
  FE_0_HW_UI_EDITOR_INSPECT_FONT: "字體",
  FE_0_HW_UI_EDITOR_INSPECT_FONTALIGN: "文字對齊",
  FE_0_HW_UI_EDITOR_INSPECT_FONTSIZE: "大小",
  FE_0_HW_UI_EDITOR_INSPECT_FONTSTYLE: "字體",
  FE_0_HW_UI_EDITOR_INSPECT_GRID: "格線佈局",
  FE_0_HW_UI_EDITOR_INSPECT_HIGHLIGHT: "選定",
  FE_0_HW_UI_EDITOR_INSPECT_HOR: "水平",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT: "左",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT_DOWN: "左下",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT_UP: "左上",
  FE_0_HW_UI_EDITOR_INSPECT_LINESPACE: "行距",
  FE_0_HW_UI_EDITOR_INSPECT_MAX: "最大",
  FE_0_HW_UI_EDITOR_INSPECT_MAXLENGTH: "最大長度",
  FE_0_HW_UI_EDITOR_INSPECT_MIN: "最小",
  FE_0_HW_UI_EDITOR_INSPECT_MULTI_LINE: "多行",
  FE_0_HW_UI_EDITOR_INSPECT_NORMAL: "預設",
  FE_0_HW_UI_EDITOR_INSPECT_OFFSET: "偏移",
  FE_0_HW_UI_EDITOR_INSPECT_PIVOT: "中心點",
  FE_0_HW_UI_EDITOR_INSPECT_PLACEHOLDER: "佔位文字",
  FE_0_HW_UI_EDITOR_INSPECT_PRESS: "點擊",
  FE_0_HW_UI_EDITOR_INSPECT_REVERSE: "翻轉",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT: "右",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT_DOWN: "右下",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT_UP: "右上",
  FE_0_HW_UI_EDITOR_INSPECT_SET_NATIVE: "恢復圖片預設大小",
  FE_0_HW_UI_EDITOR_INSPECT_SINGLE_LINE: "單行",
  FE_0_HW_UI_EDITOR_INSPECT_SOURCE: "圖片選擇",
  FE_0_HW_UI_EDITOR_INSPECT_SPACE: "間隔",
  FE_0_HW_UI_EDITOR_INSPECT_START_CORNER: "初始方向",
  FE_0_HW_UI_EDITOR_INSPECT_TABLE: "填滿版面佈局",
  FE_0_HW_UI_EDITOR_INSPECT_TEXTINPUT: "輸入文字",
  FE_0_HW_UI_EDITOR_INSPECT_TYPE: "類型",
  FE_0_HW_UI_EDITOR_INSPECT_UNACTIVE: "隱藏",
  FE_0_HW_UI_EDITOR_INSPECT_UP: "上",
  FE_0_HW_UI_EDITOR_INSPECT_VER: "垂直",
  FE_0_HW_UI_EDITOR_INSPECT_WORDWRAP: "換行",
  FE_0_HW_WARNING_FUNCTIONSIGNATURE_PARAMETERS: "函數的參數與參數類型與最初的參數類型不同，請手動確認函數是否正確調動",
  FE_0_HW_WARNING_FUNCTIONSIGNATURE_RETURNTYPE: "函數的返回類型與最初的返回類型不同，請手動確認函數是否正確調動",
  FE_0_HW_WARNING_LOCALVAR_NODEFINE: "局部變量為定義錯誤",
  FE_0_HW_WARNING_LOCALVAR_OOS: "局部變量超出使用範圍錯誤",
  FE_0_HW_WARNING_NODEFINE: "未定義錯誤{0}",
  FE_0_HW_WARNING_PARAM_NODEFINE: "變量未定義錯誤{0}",
  FE_0_HW_WARNING_RETURNNOTINFUNCTION: "只有在函數內才能使用返回語句",
  FE_0_HW_WARNING_TYPEASSIGN: "類型匹配錯誤",
  FE_0_HW_WORK_CLEAN: "清空資源回收桶",
  FE_0_HW_WORK_CREATE_VARIABLE: "創建變量",
  FE_0_M_SENCE_EDIT_NAMEERROR: "名稱含有敏感文字，請修改再試",
  FE_0_Q_FALSE: "假",
  FE_0_Q_SENCE_DEFAULT: "（預設場景）",
  FE_0_Q_SENCE_ENUM: "場景列舉",
  FE_0_Q_SENCE_SETDEFAULT: "設置為默認場景",
  FE_0_Q_TOKEN_EXPIRED: "登錄憑證已過期，需要重新登錄",
  FE_0_Q_TRUE: "真",
  FE_0_ZZ_CLEAR: "清除",
  FE_0_ZZ_CREATE_EMPTY: "創建空節點",
  FE_0_ZZ_ECA_NAME_NOT_EMPTY: "變量名稱不能為空",
  FE_0_ZZ_ECA_READ_ONLY: "唯讀模式",
  FE_0_ZZ_ECA_TO_DEFINE: "進入定義",
  FE_0_ZZ_ECA_VALUE_NOT_MATCH: "初始值與限定類型不匹配",
  FE_0_ZZ_GRAPH_NOT_FOUND: "沒有找到相關圖塊",
  FE_0_ZZ_PROJECT_FOLDER_EMPTY: "專案目錄應為空",
  FE_0_ZZ_PROJECT_PIC_SIZE: "圖示大小",
  FE_0_ZZ_PROJECT_SERVER_OUT: "伺服器連線超時",
  FE_0_ZZ_PROJECT_TYPE: "檔案類型",
  FE_0_ZZ_SEARCH_NO_RESULT: "未找到相關結果",
  FE_0_ZZ_SHOW_IN_EXPLORER: "在資源管理中顯示",
  FE_0_ZZ_SKYENV_AMBIENT: "環境光顏色",
  FE_0_ZZ_SKYENV_CUSTOM: "自訂",
  FE_0_ZZ_SKYENV_DARK: "暗度",
  FE_0_ZZ_SKYENV_DAY: "白天",
  FE_0_ZZ_SKYENV_EVE: "黃昏",
  FE_0_ZZ_SKYENV_FLARE: "鏡頭光暈",
  FE_0_ZZ_SKYENV_FOG: "霧氣顏色",
  FE_0_ZZ_SKYENV_LIGHT_COLOR: "光照顏色",
  FE_0_ZZ_SKYENV_LIGHT_INTENSITY: "光照強度",
  FE_0_ZZ_SKYENV_NIGHT: "夜晚",
  FE_0_ZZ_SKYENV_NIGHT_MODE: "夜晚模式",
  FE_0_ZZ_SKYENV_SHADOW: "陰影強度",
  FE_0_ZZ_SKYENV_SKY: "天空盒",
  FE_0_ZZ_SKYENV_WETNESS: "地面濕度",
  FE_38_B_CAMERA_DEFAULT: "預設相機",
  FE_38_B_CHECK: "查看",
  FE_38_B_CHECK_FAILED: "未通過審核",
  FE_38_B_COMPONENTS_CREATECOPY: "複製組件",
  FE_38_B_COMPONENTS_CUSTOM: "自訂組件",
  FE_38_B_COMPONENTS_CUSTOM_CREATE: "創建自定義組件",
  FE_38_B_COMPONENTS_CUSTOM_DELETE: "刪除組件",
  FE_38_B_COMPONENTS_EDIT: "配置組件屬性",
  FE_38_B_COMPONENTS_MANAGE: "組件管理",
  FE_38_B_COMPONENTS_OFFICAL: "官方組件",
  FE_38_B_COMPONENTS_PROPERTIES: "屬性",
  FE_38_B_COMPONENTS_PROPERTIES_DEFAULT: "預設屬性",
  FE_38_B_COMPONENTS_PROPERTIES_REQUIRE: "需求屬性",
  FE_38_B_COMPONENTS_RESET: "重置組件",
  FE_38_B_COMPONENTS_TIP_DELETE: "刪除組件將導致需求聯繫取消，確認刪除？",
  FE_38_B_COMPONENTS_TIP_REQUIRE: "以下組件需要該組件",
  FE_38_B_DEBUGSETTING_ASSIGN_TEAM: "分配隊伍",
  FE_38_B_DEBUGSETTING_AUTO: "自動",
  FE_38_B_DEBUGSETTING_AUTO_TEAM: "自動分配隊伍",
  FE_38_B_DEBUGSETTING_DEBUG_MODE: "除錯模式",
  FE_38_B_DEBUGSETTING_LANG: "啟動語言",
  FE_38_B_DEBUGSETTING_NAME: "除錯設定",
  FE_38_B_DEBUGSETTING_REMOTE: "使用遠端伺服器",
  FE_38_B_DEBUGSETTING_REMOTE_ADDRESS: "遠端伺服器地址",
  FE_38_B_DEBUGSETTING_SIDE_NUMBER: "除錯端數量",
  FE_38_B_DEBUGSETTING_STRICT_MODE: "嚴格模式",
  FE_38_B_DEBUGSETTING_TEAM: "隊伍 {0}",
  FE_38_B_DEBUGSETTING_TEAMUP: "組隊",
  FE_38_B_DEBUGSETTING_TOOL: "除錯工具",
  FE_38_B_ECA_ADD_WATCH: "新增偵查",
  FE_38_B_ECA_CALL_FUNCTION: "調用函數",
  FE_38_B_ECA_CAMERA_ENTITY: "相機組件",
  FE_38_B_ECA_CLEAR_WATCH: "清除偵查",
  FE_38_B_ECA_CONDITIONAL_STATEMENT: "條件語句",
  FE_38_B_ECA_DEFINE_BEHAVIOR: "定義行為",
  FE_38_B_ECA_DEFINE_FUNCTION: "定義函數",
  FE_38_B_ECA_DEL_WATCH: "刪除偵查",
  FE_38_B_ECA_LIST: "ECA 列表",
  FE_38_B_ECA_PARALIST: "參數列表",
  FE_38_B_ECA_SET_VARIABLE: "設定變量",
  FE_38_B_ECA_SOUND_ENTITY: "音效實體組件",
  FE_38_B_ECA_TIPSHUD_ENTITY: "文本 HUD 組件",
  FE_38_B_GAME_EDITOR_LOCALIZATIONSETTING: "本地化",
  FE_38_B_LOCALIZATION_NEW_CSV: "建立 CSV",
  FE_38_B_LOCALIZATION_TIPS1: "當前無綁定本地化檔案",
  FE_38_B_LOCALIZATION_TIPS2: "本地化 CSV 檔案的編碼格式必須為 UTF8",
  FE_38_B_LOCALIZATION_TIPS3: "在當前綁定檔案找不到{0}",
  FE_38_B_LOOT_RESET: "每回合重置",
  FE_38_B_MENU_DELETE: "刪除視窗佈局 {0}",
  FE_38_B_MENU_TIPS1: "請輸入佈局名稱",
  FE_38_B_MENU_TIPS2: "請更改名稱",
  FE_38_B_MENU_TIPS3: "此名稱已使用，是否更改為另一個？",
  FE_38_B_MENU_TIPS4: "Token 已過期，請重新登入",
  FE_38_B_MENU_TIPS5: "點擊查看重新跳轉詳情",
  FE_38_B_MENU_WORDFILTER: "敏感字詞過濾器",
  FE_38_B_NEW_PROJECT: "新建專案",
  FE_38_B_POINT_TIPS_EXCEED: "達到斷點上限 (1000個)",
  FE_38_B_PROJECTSETTING_COVER: "地圖封面",
  FE_38_B_REVIEW_01: "敏感字詞檢測",
  FE_38_B_REVIEW_02: "正在進行敏感字詞檢測，可在控制台中查看詳情",
  FE_38_B_REVIEW_03: "已完成敏感字詞檢測，共檢測字串 {0} 條，共有 {1} 條敏感字詞，請查看訊息",
  FE_38_B_SLOT_DEFAULT: "預設槽位",
  FE_38_B_SLOT_POPULAR: "熱門槽位",
  FE_38_B_SLOT_POPULAR_NONE: "無熱門槽位",
  FE_38_B_TIP_DELETE_FAILED: "目前無法刪除該組件",
  FE_38_B_TIP_DIRTY_SAVE: "請先儲存下列組件：",
  FE_38_B_TIP_OFFICAL_REQUIRE: "無法更改官方的需求組件",
  FE_38_B_TIP_SAVE_FAILED: "儲存失敗",
  FE_38_V_CONSOLE_TO_GRAPH: "雙擊跳轉至定義處",
  FE_38_V_CONSOLE_TO_TARGET: "雙擊到達目標地點",
  FE_38_V_ECA_COMPONENT_SELECT: "篩選組件",
  FE_38_V_MENU_WORK_AREA: "工作區",
  FE_38_WZY_WS_CLEARPRO_ALL: "清除所有屬性係數",
  FE_38_ZQ_INSPECTOR_STATIC: "靜態合批",
  FE_38_ZQ_INSPECTOR_STATICTIPS: "勾選此框來標記該對象在場景中是靜態的",
  FE_38_ZQ_LAUNCH_CHECKING: "審核中",
  FE_38_ZQ_LAUNCH_FAILED: "未通過審核，請進入專案並於控制台查看詳情",
  FE_38_ZQ_LAUNCH_TIPS: "請於「數據中心」確認審核狀態，審核通過後會自動發佈",
  FE_38_ZQ_PROJECTSETTING_COVER: "設為封面",
  FE_38_ZQ_PROJECTSETTING_DEFAULTLANG: "默認語言",
  FE_38_ZQ_PROJECTSETTING_DOUBLECHECK: "確認放棄本次修改？",
  FE_38_ZQ_PROJECTSETTING_INFO: "基礎訊息",
  FE_38_ZQ_PROJECTSETTING_LANG: "本地化列表",
  FE_38_ZQ_PROJECTSETTING_LANGTIPS: "當前沒有對應語言的文本時，該語言將會作為預設語言。",
  FE_38_ZQ_PROJECTSETTING_LIMIT: "超過 200k 的圖片無法上傳，請重新選擇",
  FE_38_ZQ_PROJECTSETTING_LOC: "本地化",
  FE_38_ZQ_PROJECTSETTING_NAME: "專案設定",
  FE_38_ZQ_PROJECTSETTING_PICTIPS1: "可接受圖片格式：jpg、jpeg、png、bmp。",
  FE_38_ZQ_PROJECTSETTING_PICTIPS2: "推薦尺寸：420 x 182 px，大小必須小於 200k。",
  FE_38_ZQ_PROJECTSETTING_PICTIPS3: "通過審核後，您的專案將對其他玩家開放",
  FE_38_ZQ_PROJECTS_IMPORT: "輸入",
  FE_38_ZQ_PROJECTS_REFRESH: "刷新",
  FE_38_ZQ_PROJECTS_TIPS: "你無法撤回刪除資源操作",
  FE_38_ZZ_CAMERA_ADD: "在當前位置新增相機",
  FE_38_ZZ_CAMERA_BLOCK_MODE: "遮蔽模式",
  FE_38_ZZ_CAMERA_CHOOSE: "選擇相機模式",
  FE_38_ZZ_CAMERA_CONTROL: "使用螢幕控制相機",
  FE_38_ZZ_CAMERA_CUSTOM: "自訂相機",
  FE_38_ZZ_CAMERA_FOCUS_OFFSET_DESC: "方向偏移量為相機方向點相對於玩家中心點的座標",
  FE_38_ZZ_CAMERA_FOV_DESC: "視野範圍為相機的觀察角度",
  FE_38_ZZ_CAMERA_INVISICAM: "半透明",
  FE_38_ZZ_CAMERA_OFFSET_DESC: "位置偏移量為相機相對於玩家中心點的座標",
  FE_38_ZZ_CAMERA_ORTHOGRAPHIC: "正字型",
  FE_38_ZZ_CAMERA_PERSPECTIVE: "透視",
  FE_38_ZZ_CAMERA_PREVIEW: "預覽",
  FE_38_ZZ_CAMERA_PROJECTION_MODE: "投影模式",
  FE_38_ZZ_CAMERA_SET: "設定遊戲內相機",
  FE_38_ZZ_CAMERA_STABLE: "固定",
  FE_38_ZZ_CAMERA_START: "預設相機",
  FE_38_ZZ_CAMERA_START_MODE: "預設相機模式",
  FE_38_ZZ_CAMERA_THIRD: "第三人稱 (追背)",
  FE_38_ZZ_CAMERA_TRANSVERSE: "橫向滾軸",
  FE_38_ZZ_CAMERA_ZOOM: "推進",
  FE_38_ZZ_ECA_COMMON: "公共事件",
  FE_38_ZZ_ECA_COMPONENT_SET: "設定組件類型",
  FE_38_ZZ_ECA_COMPONENT_TYPE: "組件類型",
  FE_38_ZZ_ECA_PRIVATE: "私有事件",
  FE_38_ZZ_ECA_USED: "已使用圖元",
  FE_38_ZZ_EMPTY: "空節點",
  FE_39A_B_LOGIN_BACK: "返回",
  FE_39A_B_LOGIN_JOIN: "加入",
  FE_39A_B_LOGIN_LOADING: "載入中",
  FE_39A_B_LOGIN_SIGNIN: "登入",
  FE_39A_B_LOGIN_SIGNINWITH: "通過 {0} 登入",
  FE_39A_B_LOGIN_SIGNUP: "註冊",
  FE_39A_B_LOGIN_SIGNUPWITH: "通過 {0} 註冊",
  FE_39A_B_LOGIN_SUCCESS: "成功",
  FE_39A_B_LOGIN_TIPS1: "登入 Craftland Studio",
  FE_39A_B_LOGIN_TIPS10: "綁定 Free Fire 帳號後可發佈專案和瀏覽 Free Fire projects",
  FE_39A_B_LOGIN_TIPS11: "沒有 Free Fire 帳號？",
  FE_39A_B_LOGIN_TIPS12: "已有 Free Fire 帳號？",
  FE_39A_B_LOGIN_TIPS2: "沒有 Craftland Studio 帳號？",
  FE_39A_B_LOGIN_TIPS3: "已有 Craftland Studio 帳號？",
  FE_39A_B_LOGIN_TIPS4: "登入成功後將刷新彈窗頁面",
  FE_39A_B_LOGIN_TIPS5: "準備啟動 Craftland Studio",
  FE_39A_B_LOGIN_TIPS6: "要使用 Craftland Studio 和瀏覽 Free Fire projects，請先綁定你的 Free Fire 帳號",
  FE_39A_B_LOGIN_TIPS7: "綁定失敗，請重試",
  FE_39A_B_LOGIN_TIPS8: "通知",
  FE_39A_B_LOGIN_TIPS9: "確認綁定以下 Free Fire 帳號？成功後將獲取 Free Fire projects 資訊",
  FE_39A_V_NINE_SLICE: "九宮格",
  FE_39A_ZQ_ATLAS_CLEARFAIL: "清理失敗",
  FE_39A_ZQ_ATLAS_CLEARSUC: "清理完成",
  FE_39A_ZQ_ATLAS_MEMORY: "UI 圖集緩存",
  FE_39A_ZQ_FILE_FILEID: "檔案 ID",
  FE_39A_ZQ_FILE_PATH: "路徑",
  FE_39A_ZQ_MESH_SUBMESHCOUNT: "子網格數量",
  FE_39A_ZQ_PERFORMANCE: "效能",
  FE_39_B_ADD: "添加",
  FE_39_B_BAN_DRAG: "禁止拖動",
  FE_39_B_CHOOSE_ENTITY: "選擇實體發送",
  FE_39_B_CHOOSE_TYPE: "選擇參數類型",
  FE_39_B_COPY: "副本",
  FE_39_B_CREATE_SIGNAL_PARAMETER: "選擇訊號參數",
  FE_39_B_CUSTOM_EVENT: "自訂事件",
  FE_39_B_DATA_OPERATE: "數據操作",
  FE_39_B_DELETE_SIGNAL_PARAMETER: "刪除訊號參數{0}",
  FE_39_B_ENUM: "枚舉",
  FE_39_B_ENUM_DETAIL: "枚舉詳請",
  FE_39_B_GUNSKIN_PROP: "槍械塗裝數據",
  FE_39_B_GUNSKIN_SKILL: "槍械塗裝技能",
  FE_39_B_LOCALIZATION_TIPS1: "本地化字串長度不符要求",
  FE_39_B_SIGNAL_CONFIG: "預定義訊號參數配置",
  FE_39_B_SIGNAL_NAME: "訊號名稱",
  FE_39_B_SIGNAL_PARAMETER: "預定義訊號參數",
  FE_39_B_SIGNAL_RECEIVE: "接受訊號{0}時",
  FE_39_B_SIGNAL_SEND: "發送訊號{0}",
  FE_39_B_SIGNAL_TIPS1: "訊號名稱不得重複",
  FE_39_B_SIGNAL_TIPS2: "自訂訊號事件失敗",
  FE_39_B_TAG_EDIT: "編輯標籤",
  FE_39_B_TAG_TIPS1: "是否刪除此標籤？",
  FE_39_B_TARGET_ENTITY: "目標實體",
  FE_39_M_ACCOUNTID: "玩家帳號",
  FE_39_M_ADDTEMPLATE: "添加模板",
  FE_39_M_ASC: "升序",
  FE_39_M_BLOCKLY: "圖元預覽",
  FE_39_M_CLEAR: "清空數據",
  FE_39_M_CLEAR1: "清空表內數據，不可取消，是否清空？",
  FE_39_M_CLEAR2: "將清空表內數據，不可取消，是否清空？",
  FE_39_M_CLEAR3: "刪除這條數據，不可取消，是否刪除？",
  FE_39_M_COMPONENT: "組件預覽",
  FE_39_M_COMPONENTDESC: "組件說明",
  FE_39_M_COMPONENTLIST: "組件列表",
  FE_39_M_DATA: "數據存儲",
  FE_39_M_DATAMAX: "數據表已達最大數量",
  FE_39_M_DATAMODEDESC: "啟用該模組後就可以調用對應的組件和圖元。注意儲存功能有嚴格的性能要求和請求頻率限制，請控制好你的數據操作邏輯",
  FE_39_M_DATANAMEREPEAT: "存在相同的數據表名稱",
  FE_39_M_DATANAMESIZE: "數據表名稱不得超過 12 個字元",
  FE_39_M_DATAOFF: "數據存儲功能未開啟",
  FE_39_M_DATASTORAGEOFF: "儲存模組已關閉",
  FE_39_M_DATASTORAGEON: "儲存模組已開啟",
  FE_39_M_DESC: "降序",
  FE_39_M_FUNON: "啟用功能",
  FE_39_M_INPUTNAME: "請輸入數據表名稱",
  FE_39_M_MANAGE: "管理存檔",
  FE_39_M_OFF: "關閉",
  FE_39_M_ORDIDATA: "普通數據表",
  FE_39_M_RANKDATA: "排行數據表",
  FE_39_M_RANKING: "排名",
  FE_39_M_RANKSHEETTIPS: "可以建立排行數據表，自動排序表內數據",
  FE_39_M_SHEETTIPS: "可以建立數據表，儲存任意數據訊息",
  FE_39_M_STATUS: "功能狀態",
  FE_39_M_TABLENULL: "當前數據表為空",
  FE_39_M_TABLESET: "設置數據表",
  FE_39_SP_ENUM01: "設置枚舉",
  FE_39_SP_ENUM02: "編輯自訂枚舉",
  FE_39_SP_ENUM03: "管理枚舉",
  FE_39_SP_ENUM04: "自訂枚舉",
  FE_39_SP_ENUM05: "官方枚舉",
  FE_39_SP_ENUM06: "數據類型",
  FE_39_SP_ENUM07: "枚舉內容",
  FE_39_SP_ENUM08: "創建副本",
  FE_39_V_ALIGN_STYLE: "同步方式",
  FE_39_V_BUTTON_DOUBLE_CLICK: "雙擊按鈕",
  FE_39_V_BUTTON_DOUBLE_CLICK_DESC: "雙擊實體後執行",
  FE_39_V_BUTTON_PRESS: "按下按鈕",
  FE_39_V_BUTTON_PRESS_DESC: "按下實體後執行",
  FE_39_V_BUTTON_RELEASE: "放開按鈕",
  FE_39_V_BUTTON_RELEASE_DESC: "實體抬起後執行",
  FE_39_V_INPUT_TEXT_ACTIVE: "啟用文字內容",
  FE_39_V_INPUT_TEXT_DEFAULT: "預設文字內容",
  FE_39_V_PATH_COPY: "複製控件名稱/路徑",
  FE_39_V_PROFILER_ASSESS: "行動裝置的預估內存使用",
  FE_39_V_PROFILER_CURRENT: "目前",
  FE_39_V_PROFILER_DOWN: "下載",
  FE_39_V_PROFILER_DRAWCALL: "繪製調用",
  FE_39_V_PROFILER_LOG: "查看性能日誌",
  FE_39_V_PROFILER_MEMORY: "記憶體",
  FE_39_V_PROFILER_NET: "網路流量",
  FE_39_V_PROFILER_OTHER: "其他",
  FE_39_V_PROFILER_PEAK: "最大",
  FE_39_V_PROFILER_PRESSURE: "發佈壓力",
  FE_39_V_PROFILER_PRESSURE_ASSESS: "行動裝置的預估性能壓力",
  FE_39_V_PROFILER_PRESSURE_HIGH: "高",
  FE_39_V_PROFILER_PRESSURE_LOW: "低",
  FE_39_V_PROFILER_PRESSURE_MEDIUM: "中",
  FE_39_V_PROFILER_RENDER: "渲染",
  FE_39_V_PROFILER_TIME_LOAD: "載入時間",
  FE_39_V_PROFILER_TIME_RUN: "運行時間",
  FE_39_V_PROFILER_TIPS: "性能監控視窗",
  FE_39_V_PROFILER_TRIS: "面數",
  FE_39_V_PROFILER_UP: "上傳",
  FE_39_V_TERRAIN_BRUSH_RADIUS: "筆刷半徑",
  FE_39_V_TERRAIN_BRUSH_SET: "筆刷設置",
  FE_39_V_TERRAIN_BRUSH_SIZE: "筆刷大小",
  FE_39_V_TERRAIN_BRUSH_STRENGTH: "強度",
  FE_39_V_TERRAIN_BUILD: "建立",
  FE_39_V_TERRAIN_BUILD_LIMIT: "目前只能建立 1 塊地形",
  FE_39_V_TERRAIN_CHANGE: "替換",
  FE_39_V_TERRAIN_DELETE: "刪除",
  FE_39_V_TERRAIN_DRAW: "繪製",
  FE_39_V_TERRAIN_FLAT: "平整",
  FE_39_V_TERRAIN_FLAT_BOTH: "全部",
  FE_39_V_TERRAIN_FLAT_MODE: "平整模式",
  FE_39_V_TERRAIN_FLAT_TARGET: "平整目標",
  FE_39_V_TERRAIN_GENERATE: "生成",
  FE_39_V_TERRAIN_IMPORT: "輸入",
  FE_39_V_TERRAIN_LOWER: "降低",
  FE_39_V_TERRAIN_NAME: "地形",
  FE_39_V_TERRAIN_NEW: "新建",
  FE_39_V_TERRAIN_PLANT_BRUSH: "植被筆刷",
  FE_39_V_TERRAIN_PLANT_CHOOSE: "植被選擇",
  FE_39_V_TERRAIN_PLANT_DENSITY: "植被密度",
  FE_39_V_TERRAIN_RAISE: "升高",
  FE_39_V_TERRAIN_RANDOM_ANGLE: "隨機角度",
  FE_39_V_TERRAIN_SCULPT: "雕刻",
  FE_39_V_TERRAIN_SET: "地形設置",
  FE_39_V_TERRAIN_SIZE: "尺寸",
  FE_39_V_TERRAIN_SMOOTH: "平滑",
  FE_39_V_TERRAIN_TEXTURE: "紋理",
  FE_39_V_TERRAIN_TEXTURE_CHANGE: "替換貼圖",
  FE_39_V_TERRAIN_TEXTURE_CHOOSE: "貼圖選擇",
  FE_39_V_TERRAIN_TEXTURE_COVER_ALL: "全部覆蓋",
  FE_39_V_TERRAIN_TEXTURE_DEIETE: "刪除貼圖",
  FE_39_V_TERRAIN_TEXTURE_IMPORT: "輸入貼圖",
  FE_39_V_TERRAIN_TEXTURE_LIMIT: "目前只能輸入 4 種貼圖",
  FE_39_V_TYPO: "文字排版",
  FE_39_XYL_ISTRIGGERHIDE: "隱藏觸發器",
  FE_39_XYL_MOVESTRAIGHT1: "直線移動A",
  FE_39_XYL_MOVESTRAIGHT2: "直線移動B",
  FE_39_XYL_TELEPORTTYPE: "自動傳送",
  FE_39_ZQ_COLLIDER_ACTIVE: "碰撞盒啟用",
  FE_39_ZQ_COLLIDER_BOX: "盒體碰撞盒",
  FE_39_ZQ_COLLIDER_CAPSULE: "膠囊體碰撞盒",
  FE_39_ZQ_COLLIDER_COLLIDER: "碰撞盒",
  FE_39_ZQ_COLLIDER_COLLIDERNUM: "碰撞盒 {0}",
  FE_39_ZQ_COLLIDER_EDIT: "編輯碰撞盒",
  FE_39_ZQ_COLLIDER_ERROR: "碰撞盒已損壞，請檢查後重試",
  FE_39_ZQ_COLLIDER_MESH: "網格體碰撞盒",
  FE_39_ZQ_COLLIDER_RADIUS: "半徑",
  FE_39_ZQ_COLLIDER_SPHERE: "球體碰撞盒",
  FE_39_ZQ_COLLIDER_TRIGGER: "是觸發器",
  FE_39_ZQ_COLLIDER_TYPE: "碰撞盒類型",
  FE_39_ZQ_FILETYPE_ALL: "所有檔案",
  FE_39_ZQ_FILETYPE_FBX: "FBX 檔案",
  FE_39_ZQ_FILETYPE_MATERIAL: "材質檔案",
  FE_39_ZQ_FILETYPE_SOUND: "音頻檔案",
  FE_39_ZQ_FILE_OUTPUT: "輸出",
  FE_39_ZQ_FILE_UNLEGAL: "非法的檔案類型，請檢查後重試",
  FE_39_ZQ_IMAGE_ERROR: "圖片已損壞",
  FE_39_ZQ_IMAGE_FORMAT: "格式",
  FE_39_ZQ_IMAGE_RESOURCESIZE: "資源大小",
  FE_39_ZQ_IMAGE_ROUTE: "路徑",
  FE_39_ZQ_IMAGE_WARNINGRULE: "圖片尺寸不符，須滿足為 2 的整數次方才能正常顯示",
  FE_39_ZQ_IMAGE_WARNINGSIZE: "圖片尺寸超過上限：2048x2048，請調整圖片尺寸",
  FE_39_ZQ_INSPECTOR_ACTIVE: "可用性",
  FE_39_ZQ_MATERIAL_BRIGHTNESS: "亮度",
  FE_39_ZQ_MATERIAL_DIFFUSEINTENSITY: "漫射強度",
  FE_39_ZQ_MATERIAL_ERROR: "材質已損壞，請檢查後重試",
  FE_39_ZQ_MATERIAL_GLOBALILLUMINATION: "雙面全局照明",
  FE_39_ZQ_MATERIAL_GPUINSTANCING: "啟動 GPU 實例化",
  FE_39_ZQ_MATERIAL_LIGHTINGON: "燈光開啟",
  FE_39_ZQ_MATERIAL_LOSTQUOTE: "引用丟失",
  FE_39_ZQ_MATERIAL_LOWQUALITY: "低畫質",
  FE_39_ZQ_MATERIAL_MAINCOLOR: "主色",
  FE_39_ZQ_MATERIAL_MAINMAP: "主貼圖",
  FE_39_ZQ_MATERIAL_MATERIAL: "材質",
  FE_39_ZQ_MATERIAL_NORMALMAP: "法線貼圖",
  FE_39_ZQ_MATERIAL_OFFSET: "偏移",
  FE_39_ZQ_MATERIAL_RENDERQUEUE: "渲染器隊列",
  FE_39_ZQ_MATERIAL_SHADER: "著色器",
  FE_39_ZQ_MATERIAL_SHININESS: "光澤",
  FE_39_ZQ_MATERIAL_SPECULARCOLOR: "高光色",
  FE_39_ZQ_MATERIAL_SPECULARINTENSITY: "高光強度",
  FE_39_ZQ_MATERIAL_SPECULARMASK: "高光遮罩",
  FE_39_ZQ_MATERIAL_TILING: "瓦",
  FE_39_ZQ_MATH_EQUAL: "等於",
  FE_39_ZQ_MATH_GREATER: "大於",
  FE_39_ZQ_MATH_GREATEREQUAL: "大於等於",
  FE_39_ZQ_MATH_LESS: "小於",
  FE_39_ZQ_MATH_LESSEQUAL: "小於等於",
  FE_39_ZQ_MATH_NOTEQUAL: "不等於",
  FE_39_ZQ_MESH_ERROR: "網格已損壞，請檢查後重試",
  FE_39_ZQ_MESH_MESH: "網格",
  FE_39_ZQ_PACKAGE_ERROR: "Package 已損壞，請檢查後重試",
  FE_39_ZQ_PACKAGE_EXPORTFAIL: "輸出失敗",
  FE_39_ZQ_PACKAGE_EXPORTSUCCESS: "輸出成功",
  FE_39_ZQ_PACKAGE_IMPORTFAIL: "輸入失敗",
  FE_39_ZQ_PACKAGE_IMPORTSUCCESS: "輸入成功",
  FE_39_ZQ_PACKAGE_IMPUTPACKAGE: "輸入 Package",
  FE_39_ZQ_PACKAGE_INCLUDEDEPENDENCY: "包含依賴項",
  FE_39_ZQ_PACKAGE_LOSTQUOTE: "引用{0}丟失",
  FE_39_ZQ_PACKAGE_NEWID: "有檔案 ID 相同但不同名稱的檔案，繼續操作可能丟失該檔案的引用",
  FE_39_ZQ_PACKAGE_OUTPUTPACKAGE: "輸出為 Package",
  FE_39_ZQ_PACKAGE_WARNING: "該檔案和專案中檔案 ID 相同，繼續輸入將全部替換目標檔案",
  FE_39_ZQ_PART_CONE: "圓錐體",
  FE_39_ZQ_PART_CUBE: "立方體",
  FE_39_ZQ_PART_CYLINDER: "圓柱體",
  FE_39_ZQ_PART_PART: "幾何體",
  FE_39_ZQ_PART_SPHERE: "球體",
  FE_39_ZQ_PART_WEDGE: "楔形體",
  FE_39_ZQ_PREFAB_APPLY: "套用",
  FE_39_ZQ_PREFAB_APPLYALL: "全部套用",
  FE_39_ZQ_PREFAB_ERROR: "Prefab 錯誤，請檢查後重試",
  FE_39_ZQ_PREFAB_NEWPREFAB: "新建 Prefab",
  FE_39_ZQ_PREFAB_NOOVERRIDE: "無覆蓋內容",
  FE_39_ZQ_PREFAB_OVERRIDE: "覆蓋",
  FE_39_ZQ_PREFAB_PREFAB: "Prefab",
  FE_39_ZQ_PREFAB_RESTORE: "還原",
  FE_39_ZQ_PREFAB_RESTOREALL: "全部還原",
  FE_39_ZQ_PREFAB_UNPACK: "脫離",
  FE_39_ZQ_PREFAB_UNPACKALL: "全部脫離",
  FE_39_ZQ_RENDER_RENDER: "渲染",
  FE_39_ZQ_SHADER_ALWAYS: "總是",
  FE_39_ZQ_SHADER_COLORMASK: "顏色遮罩",
  FE_39_ZQ_SHADER_CUTOFF: "裁剪",
  FE_39_ZQ_SHADER_FADEFACTOR: "衰減因子",
  FE_39_ZQ_SHADER_NEVER: "從不",
  FE_39_ZQ_SHADER_TINTCOLOR: "色彩",
  FE_39_ZQ_VISIBLE_CURRENTLAYER: "所在層級",
  FE_39_ZQ_VISIBLE_DEFAULTLAYER: "預設層級",
  FE_39_ZQ_VISIBLE_LAYER: "層級",
  FE_40A_B_ECA_TIPS1: "本地化 key 不支援連結",
  FE_40A_B_SETTING_BASIC: "基礎設置",
  FE_40A_B_SETTING_BUILD: "生成",
  FE_40A_B_SETTING_BUILDAIM: "生成目標",
  FE_40A_B_SETTING_BUILDSETTING: "生成設置",
  FE_40A_B_SETTING_CAMERA_INDENTATION: "相機縮放",
  FE_40A_B_SETTING_CAMERA_ROTATE: "相機旋轉",
  FE_40A_B_SETTING_CAMERA_TRANSLATE: "相機平移",
  FE_40A_B_SETTING_COMMON: "通用操作",
  FE_40A_B_SETTING_COMMONBUILD: "常規生成",
  FE_40A_B_SETTING_DOWN10PX: "向下移動 10 px",
  FE_40A_B_SETTING_DOWN1PX: "向下移動 1 px",
  FE_40A_B_SETTING_EDITORSWITCH: "編輯器切換",
  FE_40A_B_SETTING_FOCUS: "聚焦",
  FE_40A_B_SETTING_LEFT10PX: "向左移動 10 px",
  FE_40A_B_SETTING_LEFT1PX: "向左移動 1 px",
  FE_40A_B_SETTING_LEFTMOUSE: "滑鼠左鍵",
  FE_40A_B_SETTING_LOG: "打印目錄",
  FE_40A_B_SETTING_MANY: "多個多選實體",
  FE_40A_B_SETTING_MIDMOUSE: "滑鼠滾輪",
  FE_40A_B_SETTING_MIDMOUSE_HOLD: "按住滑鼠滾輪中鍵",
  FE_40A_B_SETTING_PREFERENCES: "偏好設置",
  FE_40A_B_SETTING_PROJECT: "專案操作",
  FE_40A_B_SETTING_RIGHT10PX: "向右移動 10 px",
  FE_40A_B_SETTING_RIGHT1PX: "向右移動 1 px",
  FE_40A_B_SETTING_RIGHTMOUSE: "滑鼠右鍵",
  FE_40A_B_SETTING_SCENE_ROAMING: "場景漫遊",
  FE_40A_B_SETTING_SHORTCUTKEYS: "快捷鍵",
  FE_40A_B_SETTING_SINGLE: "單個多選實體",
  FE_40A_B_SETTING_UP10PX: "向上移動 10 px",
  FE_40A_B_SETTING_UP1PX: "向上移動 1 px",
  FE_40A_B_SETTING_WEBBUILD: "Pre-package，用於 Web 工具組上傳與發佈",
  FE_40A_HJ_DEBUG_NETWORKDELAY: "延遲：",
  FE_40A_HJ_DEBUG_PACKETLOSS: "丟包率：",
  FE_40A_V_ECA_CLEAR_HISTORY: "清除歷史",
  FE_40A_V_ECA_COPY_SINGLE: "複製單行",
  FE_40A_V_ECA_DELETE_MULTIPLE: "刪除多行",
  FE_40A_V_ECA_NO_HISTORY: "暫無搜尋歷史",
  FE_40A_XYL_COLORFULCUBE: "染色方塊",
  FE_40A_XYL_REFCUBE: "鏡面方塊",
  FE_40A_XYL_TOYCUBE: "樂園方塊",
  FE_40A_ZQ_BATCH_BATCH_STATIC: "靜態",
  FE_40A_ZQ_BATCH_BUTTON_SETTING: "前往專案設置",
  FE_40A_ZQ_BATCH_CONSOLE_SCRIPT: "當前樞軸{0}的ECA 腳本檔案{1}無法正常應用，請注意是否保持當前狀態",
  FE_40A_ZQ_BATCH_TIPS_BADINHERIT: "優化渲染效能時出錯，此實體暫不支援批次或模型合併。",
  FE_40A_ZQ_BATCH_TIPS_COLLIDER: "靜態屬性已啟用。此屬性將無效並切換為默認碰撞。",
  FE_40A_ZQ_BATCH_TIPS_INHERIT: "繼承靜態合批",
  FE_40A_ZQ_BATCH_TIPS_INSPECTOR: "已開啟靜態合批，該屬性將不再生效",
  FE_40A_ZQ_BATCH_TIPS_INVALID: "靜態合批啟用，以下部分屬性可能因此失效",
  FE_40A_ZQ_BATCH_TIPS_STATICBATCHING: "啟用靜態合批後，將會使應用實體的大部分邏輯失效",
  FE_40A_ZQ_BATCH_TIPS_UNAVAILABLE: "官方物件的自身邏輯仍然生效",
  FE_40A_ZQ_SETTINGS_GOTOSETTINGS: "去設置",
  FE_40A_ZQ_SETTINGS_INPUTTIPS: "在此輸入",
  FE_40_B_DATA_SEARCH_ACCOUNTID: "搜尋 UID",
  FE_40_B_DATA_SEARCH_KEY: "搜索 key",
  FE_40_B_DATA_SEARCH_VALUE: "搜尋值",
  FE_40_B_DATA_TIPS1: "目前資料無法編輯，請發佈此地圖後重試",
  FE_40_B_DATA_TIPS2: "此資料類型無法編輯",
  FE_40_B_DATA_TIPS3: "搜尋常規資料列表需要指定 UID 與 key",
  FE_40_B_DATA_TIPS4: "儲存之前的編輯？",
  FE_40_B_DATA_TIPS5: "尚有編輯未儲存",
  FE_40_B_ECA_MISSING: "ECA 腳本遺失",
  FE_40_B_LOGIN_TIPS1: "訪客無法綁定帳號，請先登入 Craftland Studio",
  FE_40_B_RECONNECT_OFF: "關閉斷線重連",
  FE_40_B_SCRIPT: "腳本",
  FE_40_B_SCRIPT_MISSING: "代碼腳本遺失",
  FE_40_B_TERRAIN_TIPS1: "此地形塊支援貼圖已達上限 4 種",
  FE_40_B_VERSION_TIPS1: `版本不相容（編輯器版本：{0}，專案版本：{1}）
是否繼續？`,
  FE_40_JH_AVALTOKENID: "啟用的 Token ID",
  FE_40_JH_DISPLAYLABEL: "顯示標籤",
  FE_40_JH_DISPLAYLABELDESC: "顯示在 Free Fire 遊戲中的標籤",
  FE_40_JH_DISPLAYLABELMAX: "顯示標籤數已達上限",
  FE_40_JH_GAMETYPEDESC: "為該地圖選擇合適的遊戲類型",
  FE_40_JH_GAMETYPENAME: "遊戲類型",
  FE_40_JH_GETTOKENID: "帶入局內的 Token ID",
  FE_40_JH_HIDETAGLIMIT: "選擇的遊戲類型數已達上限",
  FE_40_JH_NUM: "數量",
  FE_40_JH_TOKENALIVE: "局內啟用的 Token",
  FE_40_JH_TOKENGET: "帶入局內的 Token",
  FE_40_JH_TOKENSET: "Token 設置",
  FE_40_JH_TOKENSET1: "是否啟用 Token 相關功能",
  FE_40_JH_TOKENSET2: "是否將局外 Token 帶入局內",
  FE_40_JH_TOKENSETERROR: "可拾取 Token 功能未開啟",
  FE_40_JH_TOKENSETNAME: "Token 設置",
  FE_40_M_UPDATELOG: "更新日誌",
  FE_40_SD_EMPTYWARNING: "當前父節點不為空，請注意是否繼續使用",
  FE_40_SD_FIND_IN_SCENE: "查找場景的引用",
  FE_40_SD_FIND_IN_UI: "查找 UI 中的引用",
  FE_40_SD_FIND_IN_WORKFLOW: "查找流程中的引用",
  FE_40_SD_NOTE: "註釋",
  FE_40_SD_NOT_FIND: "未發現引用",
  FE_40_V_UI_COLUMN_LIMIT: "列數限制",
  FE_40_V_UI_PANEL_CONSTRAINNOTCLIP: "約束但不裁切",
  FE_40_V_UI_PANEL_MASK: "紋理遮罩",
  FE_40_V_UI_PANEL_SOFTCLIP: "軟裁切",
  FE_40_V_UI_ROW_LIMIT: "行數限制",
  FE_40_V_UI_SCROLLBAR: "滾動條",
  FE_40_V_UI_SCROLLBAR_DRAGGING: "拖動時",
  FE_40_V_UI_SCROLLBAR_SHOW: "總是顯示",
  FE_40_V_UI_SCROLLVIEW: "滾動視圖",
  FE_40_V_UI_SCROLLVIEW_DIRECTION_UNRESTRAINED: "不約束",
  FE_40_V_UI_SCROLLVIEW_DRAGEFFECT_MOMENTUM: "推動",
  FE_40_V_UI_SCROLLVIEW_DRAGEFFECT_MOMENTUMNSPRING: "推動與彈開",
  FE_40_XXJ_CLOTHESTYPE: "服裝類型",
  FE_40_XXJ_ISEXPORT: "是否輸出",
  FE_40_XXJ_PARENTERROR: "設置父節點失敗",
  FE_40_XXJ_WEASKINSTYPE: "武器塗裝類型",
  FE_40_XYL_CUSTOMMINIMAP: "自訂小地圖",
  FE_40_XYL_NOCUSTOMMINIMAP: "自訂小地圖未開啟",
  FE_40_ZQ_COMPONENT_CUSTOMOBJECT: "自訂物件",
  FE_40_ZQ_COMPONENT_CUSTOMRENDER: "自訂渲染組件",
  FE_40_ZQ_GAME_EXITCONFIRM: "確認退出遊戲？",
  FE_40_ZQ_GAME_EXITOPTION: "允許中途退出",
  FE_40_ZQ_GAME_KICKOUT: "你長時間未操作，已返回大廳",
  FE_40_ZQ_GAME_KICKOUTTIME: "掛機判斷時間",
  FE_40_ZQ_GAME_TIPS: "提示",
  FE_40_ZQ_LD_LDTIPS: "已將 Assetbundle 放入 LD 目錄！配置 mapinfos.csv 後，請點擊此處【刷新】，否則需重新打開專案刷新",
  FE_41A_B_RENAME_TIPS1: "不可使用 {0} 字元",
  FE_41A_B_RENAME_TIPS2: "字元數限制：{0}",
  FE_41A_B_RENAME_TIPS3: "名稱不符合規範，修改失敗",
  FE_41A_B_RENAME_TIPS4: "名稱不能空白，編輯失敗。",
  FE_41A_B_RENAME_TIPS5: "遊戲名稱的長度必須介於{0}和{1}個字",
  FE_41A_M_FEEDBACK: "你的回饋非常重要！",
  FE_41B_HZY_CHECK_TIPS: "請先點選同意",
  FE_41B_HZY_COMPARE_NOTSAME: "左右類型不匹配。",
  FE_41B_HZY_CREATE_PARENTLEVEL: "創建空父節點",
  FE_41B_HZY_PRIVACY_POLICY: "我已閱讀並同意[服務條款](https://contentgarena-a.akamaihd.net/legal/tos/tos_zh-TW.html)與[隱私政策](https://contentgarena-a.akamaihd.net/legal/pp/pp_zh-TW.html)",
  FE_41B_HZY_PROJECT_FAVORITE_TIPS: "將這個詞設為收藏。",
  FE_41B_M_DEFAULTVALUE: "默認值",
  FE_41B_M_RANGE: "取值範圍",
  FE_41_B_CONSOLE_TIPS1: "雙擊查看錯誤資訊",
  FE_41_B_DATA_ACCUMULATED_SHEET: "資料統計表",
  FE_41_B_DATA_CLEAR_AWARD: "清空時發放獎勵",
  FE_41_B_DATA_CLEAR_CYCLE: "清除週期",
  FE_41_B_DATA_CLEAR_CYCLE_INTERVAL: "週期間隔",
  FE_41_B_DATA_CLEAR_SETTING: "清除設置",
  FE_41_B_DATA_CLEAR_SHEET: "清空資料表",
  FE_41_B_DATA_CLEAR_TIME: "清除時間",
  FE_41_B_DATA_CLEAR_TIMING: "清除倒計時",
  FE_41_B_DATA_CLEAR_TIPS1: "此操作無法還原，是否繼續？",
  FE_41_B_DATA_CLEAR_TIPS2: "此操作無法還原，是否繼續？",
  FE_41_B_DATA_DAY: "天",
  FE_41_B_DATA_HOUR: "小時",
  FE_41_B_DATA_KEY_MANAGE: "Key 管理",
  FE_41_B_DATA_NOTOPEN: "不開啟",
  FE_41_B_DATA_TIMEZONE: "時區",
  FE_41_B_DATA_TIPS1: "資料統計表內 Key 總數量已達上限",
  FE_41_B_DATA_TIPS2: "可以建立資料統計表，表內資料由後端累加，不易丟失",
  FE_41_B_DATA_TIPS3: "已添加至發獎梯度數量上限",
  FE_41_B_DATA_TIPS4: "清空時間需晚於當前時間",
  FE_41_B_DATA_WEEK: "周",
  FE_41_B_ECA_LISTTANY: "任意列表",
  FE_41_B_LABEL_COPY: "複製腳本名稱",
  FE_41_B_LABEL_EDIT: "修改腳本名稱",
  FE_41_B_LABEL_FUNCTION: "圖元函數",
  FE_41_B_LABEL_FUNCTION_PARA: "圖元函數參數",
  FE_41_B_LABEL_SCRIPTNAME: "腳本名稱",
  FE_41_B_LABEL_TIPS1: `腳本名稱只能由字母、數字與底線組成，且第一個字元不得是數字
`,
  FE_41_B_LABEL_TIPS2: "腳本名稱已被使用",
  FE_41_B_LABEL_TIPS3: "腳本名稱不能為內置關鍵字",
  FE_41_B_LABEL_TIPS4: "編譯失敗",
  FE_41_B_LABEL_VARIBLE: "圖元變量",
  FE_41_HJ_AC_STATENOTEXIST: "動畫控制器不存在狀態 {0}",
  FE_41_HZY_FILE_TERRAIN: "Terrain 檔案",
  FE_41_HZY_POINT_CONTEXTLIST: "上下文列表",
  FE_41_HZY_POINT_ID: "編號",
  FE_41_HZY_POINT_LIST: "斷點列表",
  FE_41_HZY_POINT_VALUE: "值",
  FE_41_HZY_SEARCH_NO_FILE: "未找到對應檔案",
  FE_41_JH_AI_SELFIMPORTERROR: "錯誤：無法重複從當前專案檔輸入自訂節點",
  FE_41_JH_BT_ACTIONNODE: "Action",
  FE_41_JH_BT_BEEDITOR: "AI 編輯器",
  FE_41_JH_BT_BTNAME: "行為樹",
  FE_41_JH_BT_COMPOSITE: "Composite",
  FE_41_JH_BT_CONDITIONNODE: "Contion",
  FE_41_JH_BT_CREATENODE: "新建節點",
  FE_41_JH_BT_DECORATORNODE: "Decorator",
  FE_41_JH_BT_EDITNODE: "編輯節點",
  FE_41_JH_BT_NODENAME: "節點名稱",
  FE_41_JH_BT_NODENAMETIP: "節點名稱不得為空",
  FE_41_JH_BT_NODES: "節點",
  FE_41_JH_BT_NODESCRIPT: "節點腳本",
  FE_41_JH_BT_NODESX: "節點變量",
  FE_41_JH_BT_NODETYPE: "節點類型",
  FE_41_JH_BT_NODEVARNUM: "節點變量值",
  FE_41_JH_BT_NODEVARTYPE: "節點變量類型",
  FE_41_JH_BT_ROOTNODE: "根節點",
  FE_41_JH_HACK_ANTIHACKCONTROL: "開啟反作弊功能",
  FE_41_SD_LOGICFRAME_SETTING: "低邏輯幀模式（30降至15）",
  FE_41_V_PROJECT_ANIM: "動畫",
  FE_41_V_PROJECT_CSV: "CSV 檔案",
  FE_41_V_PROJECT_ECATEMP: "ECA 模板",
  FE_41_V_PROJECT_UITEMP: "UI 模板",
  FE_41_V_PROJECT_XBT: "行為樹檔案",
  FE_41_V_PROJECT_XBTTEMP: "XBT 模板",
  FE_41_V_UI_CONTAINER: "3D 內容裝載器",
  FE_41_V_UI_CONTAINER_EFFECT: "特效",
  FE_41_V_UI_CONTAINER_MESH: "模型",
  FE_41_V_UI_PANEL_TIPS: "此類將於 UI 層級中置頂",
  FE_41_V_UI_PANEL_TYPE: "Panel 類",
  FE_41_V_UI_PROFILE: "頭像",
  FE_41_V_UI_PROFILE_NICKNAME: "玩家暱稱",
  FE_41_V_UI_PROFILE_PIN: "紀念章",
  FE_41_V_UI_PROFILE_PRANKED_TYPE: "段位類型",
  FE_41_V_UI_PROFILE_RANKED: "段位",
  FE_41_V_UI_PROFILE_TYPE_ONE: "類型 1",
  FE_41_V_UI_PROFILE_TYPE_TWO: "類型 2",
  FE_41_V_UI_TEXTURE: "貼圖",
  FE_41_V_UI_TEXTURE_CENTER_INVISIBLE: "中心不可見",
  FE_41_V_UI_TEXTURE_FILLED: "填充",
  FE_41_V_UI_TEXTURE_FILL_AMOUNT: "填充量",
  FE_41_V_UI_TEXTURE_FILL_DIR: "填充方向",
  FE_41_V_UI_TEXTURE_FILL_HOR: "水平填充",
  FE_41_V_UI_TEXTURE_FILL_INVERT: "反向填充",
  FE_41_V_UI_TEXTURE_FILL_RADIAL: "徑向填充",
  FE_41_V_UI_TEXTURE_FILL_VER: "垂直填充",
  FE_41_V_UI_TEXTURE_FIT: "自適應",
  FE_41_V_UI_TEXTURE_GRADIENT: "漸層",
  FE_41_V_UI_TEXTURE_GRADIENT_DIR: "方向",
  FE_41_V_UI_TEXTURE_SIMPLE: "簡單",
  FE_41_V_UI_TEXTURE_TILED: "平鋪",
  FE_41_V_UI_TEXTURE_TILED_TRIM: "裁剪",
  FE_41_V_UI_WIDGET_TYPE: "Widget 類",
  FE_41_XYL_IMPORT_NOTICE001: "此功能不支援 Craftland Studio 的戰場碼輸入",
  FE_41_XYL_IMPORT_NOTICE002: "戰場碼已過期，無法輸入",
  FE_41_XYL_INPUTMAP: "線上地圖",
  FE_41_XYL_NAVMESH: "靜態導航網格",
  FE_41_XYL_NAVMESHTIPS: "勾選此項的物件只會在開局生成靜態導航網格",
  FE_41_XYL_PREFABGENERATOR: "模板 (Prefab)",
  FE_41_ZQ_AC_ANIMCONTROLLER: "動畫控制器",
  FE_41_ZQ_AC_ANIMEDITOR: "動畫",
  FE_41_ZQ_AC_CLIP: "片段",
  FE_41_ZQ_AC_CLIPNO: "片段數量",
  FE_41_ZQ_AC_LOOP: "循環",
  FE_41_ZQ_AC_LOOPTIPS: "上一片段循環播放中，下一片段將不會自動播放",
  FE_41_ZQ_AC_NEWCLIP: "新建動畫片段",
  FE_41_ZQ_AC_NEWSTATE: "新建狀態",
  FE_41_ZQ_AC_NOCLIP: "未安裝動畫片段",
  FE_41_ZQ_AC_PLAYSPEED: "播放速度",
  FE_41_ZQ_AC_STATE: "狀態",
  FE_41_ZQ_ANIM_LENGTH: "長度",
  FE_41_ZQ_BUILD_DYNAMIC: "動態載入",
  FE_41_ZQ_BUILD_DYNAMIC_TIP: "啟用時，該資源將在玩家進入遊戲後才開始載入",
  FE_41_ZQ_BUILD_FILE: "手動選擇打包紀錄",
  FE_41_ZQ_BUILD_LAUNCH: "遊戲已提交審核，已產生本次打包記錄。請在「數據中心」關注審核狀態，審核通過後會為你自動發佈遊戲",
  FE_41_ZQ_BUILD_PACKAGERULE: "打包規則",
  FE_41_ZQ_BUILD_REPACKAGE: "原始打包方式",
  FE_41_ZQ_OPEN_PACKAGE_HISTORY: "打開紀錄列表",
  FE_41_ZQ_PACKAGE_RECORD: "打包紀錄",
  FE_42A_HJ_HUD_COMMONHUDSWITCH: "通用按鈕",
  FE_42A_HJ_HUD_COUNTDOWN: "階段倒數計時器",
  FE_42A_HJ_HUD_COUNTDOWNREMIND: "倒數提醒",
  FE_42A_HJ_HUD_FACTIONINFO: "陣營資訊",
  FE_42A_HJ_HUD_FIVECOUNTDOWN: "倒數計時5秒",
  FE_42A_HJ_HUD_MATCHINFO: "對局子標題圖示",
  FE_42A_HJ_HUD_MATCHINFOSIMPLE: "簡短比賽訊息",
  FE_42A_HJ_HUD_ROUNDRESULT: "回合結束圖示",
  FE_42A_HJ_HUD_ROUNDTRANSITION: "回合開始圖示",
  FE_42A_HJ_HUD_TITLEBANNER: "標題圖示",
  FE_42A_HJ_HUD_TWOTEAMMATCHINFO: "記分板",
  FE_42A_HJ_HUD_TWOTEAMSCORE: "回合開始",
  FE_42A_HJ_HUD_TWOTEAMSTART: "隊伍戰鬥圖示",
  FE_42A_HJ_HUD_TYPE: "內建按鈕",
  FE_42A_HZY_ECAMOUNT_TIP: "此實體並不存在以下組件類型。這可能導致部分程式碼無法正常運作：{0}。",
  FE_42A_HZY_WS_FUNCTIONCALL_D: `等待：串行調用。 
執行：平行調用。`,
  FE_42A_HZY_WS_LOCALVAR_D: "定義並初始化區域變數。",
  FE_42A_XYL_LOOTSWITCH: "開啟地圖預設戰利品刷新點",
  FE_42A_ZQ_ASSET_PICCONTROL: "{0}超過2048x2048，請修改後重新導入。",
  FE_42A_ZQ_ASSET_PICREDUCE: "原始檔案過大，已依原比例壓縮在 2048px 以內。",
  FE_42A_ZQ_ASSET_SIZECONTROL: "{0} 已超出限制。請調整後再次導入。",
  FE_42A_ZQ_ASSET_SOUNDCONTROL: "{0} fmod超過10,000,000，請修改後重新導入。",
  FE_42A_ZQ_BATCH_OFFLINE: "離線合批",
  FE_42A_ZQ_BATCH_OFFLINETIPS: "匯出時進行靜態合批，可能會導致玩家下載額外的資源。",
  FE_42A_ZQ_BATCH_RUNNING: "運行時合批",
  FE_42A_ZQ_BATCH_RUNNINGTIPS: "運行時進行靜態合批，不會產生新的資源。",
  FE_42A_ZQ_EFRAME_ADD: "新增事件幀",
  FE_42A_ZQ_EFRAME_COPY: "複製事件幀",
  FE_42A_ZQ_EFRAME_DTL: "刪除事件幀",
  FE_42A_ZQ_EFRAME_PASTE: "貼上事件幀",
  FE_42A_ZQ_EFRAME_SLT: "選擇事件幀",
  FE_42A_ZQ_MESH_FACECONTROL: "{0} 包含超過 30,000 個。請減少數量後再次導入。",
  FE_42A_ZQ_PCK_ROOT: "選擇根目錄",
  FE_42A_ZQ_PCK_ROOTERROR: "無效路徑",
  FE_42A_ZQ_P_OPENING: "開啟中...",
  FE_42A_ZQ_P_RUNNING: "專案運行中",
  FE_42A_ZQ_P_RUNNINGV: "專案運行中：{0}",
  FE_42A_ZQ_WEB_LAUNCH: "立即發布",
  FE_42A_ZQ_WEB_LAUNCHERROR: "發布失敗。 請稍後再試。",
  FE_42A_ZQ_WEB_LAUNCHSUC: "已上傳至創作者網站。 請透過創作者中心發佈。",
  FE_42_B_ECA_NORMAL: "普通 ECA",
  FE_42_B_ECA_STATIC: "靜態 ECA",
  FE_42_B_SCRIPT_ECARELATED: "與ECA相關",
  FE_42_B_SCRIPT_EXPORTPACKAGE: "導出",
  FE_42_B_SCRIPT_QUICKNAME: "快捷腳本命名",
  FE_42_B_SCRIPT_TIPS1: "請選擇欲導出的模組。當前與腳本名稱重複的部分將被自動跳過。",
  FE_42_B_SCRIPT_TIPS10: "自動全選並執行",
  FE_42_B_SCRIPT_TIPS2: "包含自定義組件名稱和自訂屬性名稱",
  FE_42_B_SCRIPT_TIPS3: "包含自定義列舉名稱和自訂列舉屬性名稱",
  FE_42_B_SCRIPT_TIPS4: "包含自定義事件名稱",
  FE_42_B_SCRIPT_TIPS5: "包括 ECA 檔案名稱、變數名稱、函數名稱和函數返回值。",
  FE_42_B_SCRIPT_TIPS6: "快捷腳本名已命名，共成功{0}條，失敗{1}条，請查看錯誤回報信息",
  FE_42_B_SCRIPT_TIPS7: "腳本名命名：{0}不符合規範，命名失敗",
  FE_42_B_SCRIPT_TIPS8: "腳本命名：{0}與其他命名重複。 命名失敗。",
  FE_42_B_SCRIPT_TIPS9: "腳本命名：{0} 與內部關鍵詞重複，命名失敗。",
  FE_42_HJ_API_INTERNAL: "內部區塊",
  FE_42_HJ_API_TEST: "測試區塊",
  FE_42_HJ_BLOCKDESCINTERNAL: "內部圖塊",
  FE_42_HJ_BLOCKDESCTEST: "測試圖塊",
  FE_42_HJ_DEBUG_ENTITYNUM: "實體數量",
  FE_42_HJ_DEBUG_ENTITYPROPNUM: "實體同步數量",
  FE_42_HJ_DEBUG_LOGICDEBUG: "邏輯除錯",
  FE_42_HJ_DEBUG_NETWORKDOWNLOAD: "網路流量 (下載)",
  FE_42_HJ_DEBUG_NETWORKUPLOAD: "網路流量 (上傳)",
  FE_42_HJ_DEBUG_SCENERYDEBUG: "場景除錯",
  FE_42_HJ_DEBUG_WATCHLIST: "監視列表",
  FE_42_HJ_VFX_BLACKHOLE: "黑洞",
  FE_42_HJ_VFX_BLACKHOLEEXPLOSION: "黑洞爆炸",
  FE_42_HJ_VFX_CRYSTALBALL: "水晶球",
  FE_42_HJ_VFX_INK: "水墨",
  FE_42_HJ_VFX_SPLASH: "水花",
  FE_42_HZY_SEARCH_BLOCK: "全局區塊搜尋",
  FE_42_HZY_SEARCH_BLOCKNAME: "按此區塊名稱搜尋",
  FE_42_HZY_SEARCH_GLOBAL: "搜尋(全局)",
  FE_42_HZY_SEARCH_TIPS: "輸入並按下 Enter 鍵進行搜尋",
  FE_42_HZY_TERRAIN_DELETE_TIPS: "選擇植被刷子工具以開始著色。刷子 + Shift：擦除範圍內的所有植被。刷子 + Ctrl：僅擦除所選的植被。",
  FE_42_HZY_TIP_DELETE_SLOT: "此槽中的地圖因過期而無法發布。 請前往 Free Fire 我的戰場刪除地圖。",
  FE_42_JH_AIEDITOR_ACTIONFUNCNAME: "執行動作",
  FE_42_JH_AIEDITOR_TICKFUNCNAME: "Tick",
  FE_42_JH_AI_ADDTONEWNODE: "複製新的樞紐表",
  FE_42_JH_AI_CLEAREDITOR: "清除",
  FE_42_JH_AI_DELETEINPUT: "刪除樞紐輸入",
  FE_42_JH_AI_DELETENODE: "刪除自定義樞紐",
  FE_42_JH_AI_DELETEOUTPUT: "刪除樞紐輸出",
  FE_42_JH_AI_DRWAERROR: "背景無法初始化",
  FE_42_JH_AI_FILELOADER: "檔案讀取錯誤",
  FE_42_JH_AI_NODEID: "樞紐ID",
  FE_42_JH_AI_NOROOTNODE: "請先創建一個樞紐節點",
  FE_42_JH_AI_SETUP: "樞紐基本資訊",
  FE_42_JH_ECANAME1: "行為樹 - 執行行為",
  FE_42_JH_ECANAME2: "行為樹 - 條件判斷",
  FE_42_JH_SCODE_ERROR1: "簡短地圖代碼的長度不符合要求。",
  FE_42_JH_SCODE_ERROR2: "簡短地圖代碼長度必須為6個字元，只能由大寫字母和數字組成。",
  FE_42_JH_SCODE_ERROR3: "此簡短地圖代碼已存在",
  FE_42_JH_SCODE_ERROR5: "您可以輸入由數字或大寫字母組成的6位字元以生成一個短地圖代碼，該代碼將替換先前的地圖代碼。",
  FE_42_JH_SCODE_ERROR6: "這張地圖已存在一個簡短的地圖代碼，無法修改。",
  FE_42_JH_SCODE_RANDOMSCODE: "隨機生成",
  FE_42_JH_SCODE_SCODENAME: "簡短地圖代碼",
  FE_42_JH_WS_CUSTOMNODEDESC: "節點說明",
  FE_42_JH_WS_DELETECUSTOMNODE: "刪除節點",
  FE_42_JH_WS_DELETENODEPANEL: "確認清除畫布",
  FE_42_JH_WS_EXSEQUENCE: "按時間順序執行所有子節點。 當所有子節點都回傳true時，該節點也會回傳true； 否則會回傳 false。",
  FE_42_JH_WS_EXWAIT: "等待指定時間。 您可以設定等待時間，以便在該時間到期時執行下一個動作。",
  FE_42_JH_WS_INVERTER: "取得子節點執行結果的相反值。",
  FE_42_JH_WS_MAXS: "設定子節點執行時長的最大值。",
  FE_42_JH_WS_MENPRIORITY: "工作原理與優先節點類似，只不過它會儲存子節點的執行狀態，以便從該節點當前儲存進度開始執行。",
  FE_42_JH_WS_MENSEQUENCE: "工作原理與序列節點類似，只不過它會儲存子節點的執行狀態，以便從該節點當前儲存進度開始執行。",
  FE_42_JH_WS_PRIORITY: "按時間順序執行所有子節點。 當任意子節點回傳true時，該節點也會回傳true； 否則會回傳 false。",
  FE_42_JH_WS_REPEATX: "重複執行子節點，直到達到指定的執行次數。",
  FE_42_JH_WS_REPETFAIL: "重複執行子節點，直到傳回 false。",
  FE_42_JH_WS_REPETSUCC: "重複執行子節點直到回傳 true。",
  FE_42_M_BOMBER: "轟炸",
  FE_42_M_ShutdownDelay: "伺服器關閉延遲時間",
  FE_42_M_StartTimeout: "伺服器開啟延遲時間",
  FE_42_SD_FCG_VSIX_INSTALL: "缺少IDE開發環境，是否安裝VSCode作為IDE?",
  FE_42_V_ACTION_ABOARD: "進入載具",
  FE_42_V_ACTION_ABOARD_DRIVER: "作為駕駛上車",
  FE_42_V_ACTION_ABOARD_OFF: "進入/離開載具",
  FE_42_V_ACTION_ABOARD_PASSENGER: "作為乘客上車",
  FE_42_V_ACTION_BACK: "向後移動",
  FE_42_V_ACTION_CROUCH: "下蹲",
  FE_42_V_ACTION_DIVE: "空中俯衝",
  FE_42_V_ACTION_FIRE: "射擊",
  FE_42_V_ACTION_FORWARD: "向前移動",
  FE_42_V_ACTION_GRENADE: "手榴彈",
  FE_42_V_ACTION_HUD_HIDE: "隱藏UI",
  FE_42_V_ACTION_INTERACT: "互動",
  FE_42_V_ACTION_JUMP: "跳躍",
  FE_42_V_ACTION_LEFT: "向左移動",
  FE_42_V_ACTION_MOUSE_LOCKED: "鎖定滑鼠",
  FE_42_V_ACTION_MOVE: "移動",
  FE_42_V_ACTION_OFF: "離開載具",
  FE_42_V_ACTION_PICKUP: "撿起",
  FE_42_V_ACTION_PRONE: "俯臥",
  FE_42_V_ACTION_QUICK_SWITCH: "快速切換武器",
  FE_42_V_ACTION_RELOAD: "換彈",
  FE_42_V_ACTION_RIGHT: "向右移動",
  FE_42_V_ACTION_RUN: "奔跑",
  FE_42_V_ACTION_SKILL: "角色技能",
  FE_42_V_ACTION_SWITCH: "切換武器",
  FE_42_V_ACTION_ZOOM: "開鏡",
  FE_42_V_INPUT_ACTION: "對應操作",
  FE_42_V_INPUT_CLICK: "點擊",
  FE_42_V_INPUT_DOUBLE_CLICK: "點擊兩次",
  FE_42_V_INPUT_DOWN: "按住",
  FE_42_V_INPUT_KEY: "輸入按鍵",
  FE_42_V_INPUT_KEYBOARD: "鍵盤",
  FE_42_V_INPUT_LIST: "對應列表",
  FE_42_V_INPUT_MODE: "輸入手勢",
  FE_42_V_INPUT_MOUSE: "滑鼠",
  FE_42_V_INPUT_NUM: "對應數量",
  FE_42_V_INPUT_PRESS: "按下",
  FE_42_V_INPUT_RELEASE: "釋放",
  FE_42_V_INPUT_SYSTEM: "輸入設定",
  FE_42_V_INPUT_SYSTEM_TIPS: "配置配對作業前請先將當前工作內容儲存為UI檔案",
  FE_42_XXJ_FILEMISSING: "缺少檔案資源",
  FE_42_XXJ_INVAR: "輸入值",
  FE_42_XXJ_NORETURN: "錯誤: 無回傳值",
  FE_42_XXJ_OUTVAR: "輸出值",
  FE_42_ZQ_ANIM_ADDANIMEVENT: "增加動畫事件",
  FE_42_ZQ_ANIM_ANIMEVENT: "動畫事件",
  FE_42_ZQ_ANIM_ANIMTIPS: "點擊兩次動畫檔案或將動畫檔案拖入以打開",
  FE_42_ZQ_ANIM_CANNOTEDIT: "該類型事件不可修改",
  FE_42_ZQ_ANIM_COPYANIMEVENT: "複製動畫事件",
  FE_42_ZQ_ANIM_DELETEANIMEVENT: "刪除動畫事件",
  FE_42_ZQ_ANIM_DURATION: "持續",
  FE_42_ZQ_ANIM_EFRAME: "幀事件",
  FE_42_ZQ_ANIM_EVENTNUM: "動畫事件",
  FE_42_ZQ_ANIM_EVENTSELECT: "選擇事件",
  FE_42_ZQ_ANIM_FRAME: "幀",
  FE_42_ZQ_ANIM_MODELTIPS: "沒有可預覽的模型，請拖入一個模型到此區域",
  FE_42_ZQ_ANIM_NOANIMEVENT: "無動畫事件",
  FE_42_ZQ_ANIM_PARANUM: "參數{0}",
  FE_42_ZQ_ANIM_PASTEANIMEVENT: "貼上動畫事件",
  FE_42_ZQ_ANIM_TIME: "時間",
  FE_42_ZQ_ASSET_CANNOTEDIT: "無法編輯參考資源",
  FE_42_ZQ_BATCH_DYNAMICBATCH: "動態批次處理",
  FE_42_ZQ_BATCH_DYNAMICTIPS: "在動態批次處理下，仍然支援創建、刪除和修改屬性（如位置移動、旋轉和紋理縮放）",
  FE_42_ZQ_ECA_TIP_BONE_EDITOR_DIS_SELECT: "目前場景為外觀編輯器，不可選擇物件。",
  FE_42_ZQ_EVENT_NOTIPICALEVENT: "無指定事件種類",
  FE_42_ZQ_IMPORT_CANCEL: "取消導入",
  FE_42_ZQ_IMPORT_TARGETFILE: "目標資料夾",
  FE_42_ZQ_LOGIN_GOLOGIN: "請先登入",
  FE_42_ZQ_MIPMAP: "是否啟用小地圖",
  FE_42_ZQ_MIPMAP_TIP: "開啟小地圖可能會稍微增加內存和渲染的負擔，但會帶來更平滑的紋理過度和更好的細節顯示效果",
  FE_42_ZQ_OPAQUE: "移除 Alpha",
  FE_42_ZQ_OPAQUE_TIP: "選擇此選項將使 Alpha 通道無法受到讀取（不會影響圖集）。",
  FE_42_ZQ_SK_APPEARENCE: "外觀",
  FE_42_ZQ_SK_APPEARENCEGROUP: "外觀組",
  FE_42_ZQ_SK_BINDMETHOD: "綁定方式",
  FE_42_ZQ_SK_BONESELECT: "骨骼選擇",
  FE_42_ZQ_SK_CONNECT: "連接",
  FE_42_ZQ_SK_ENABLE: "啟用",
  FE_42_ZQ_SK_GROUP: "互斥組",
  FE_42_ZQ_SK_GROUPCONTROL: "互斥组管理",
  FE_42_ZQ_SK_MUTUALTIPS: "在同一個互斥組下，修改指定的外觀群組將導致其他外觀群組失效。",
  FE_42_ZQ_SK_NEWAPPEARENCE: "新建外觀",
  FE_42_ZQ_SK_NEWAPPEARENCEGROUP: "新建外觀群組",
  FE_42_ZQ_SK_NOBONE: "未找到對應骨骼",
  FE_42_ZQ_SK_NORMALMESH: "普通網格",
  FE_42_ZQ_SK_PARENTSK: "父節點骨架",
  FE_42_ZQ_SK_SK: "骨架",
  FE_42_ZQ_SK_SKINFO: "骨骼資訊",
  FE_42_ZQ_SK_SKINNED: "蒙皮",
  FE_42_ZQ_SK_SKINNEDMESH: "蒙皮網格",
  FE_42_ZQ_SK_SKSELECT: "選擇骨架",
  FE_42_ZQ_SK_WARNING: "沒有在 {0} 中找到 {1}",
  FE_42_ZQ_STORE_ADDED: "已添加到資源庫",
  FE_42_ZQ_STORE_ADDFILE: "請添加檔案",
  FE_42_ZQ_STORE_ASSETS: "資源庫",
  FE_42_ZQ_STORE_AUTHOR: "創作者",
  FE_42_ZQ_STORE_BUILDFAIL: "導出失敗",
  FE_42_ZQ_STORE_BUILDPCK: "發布資源包",
  FE_42_ZQ_STORE_BUILDPLACE: "資源發布中...請前往【我的資源】 - 【我的發布】查看",
  FE_42_ZQ_STORE_BUILDSUC: "執行成功！",
  FE_42_ZQ_STORE_BUILDTIPS: "資源成功創造! 是否立即前往發布?",
  FE_42_ZQ_STORE_CHANGEFILE: "更換檔案",
  FE_42_ZQ_STORE_CHOOSEPCK: "選擇下載的資源類型",
  FE_42_ZQ_STORE_CLOSE: "此專案已被其他任務占用。請結束該任務並重試。如果該任務已經結束，請稍後再試。",
  FE_42_ZQ_STORE_CURRENT_PROJECT_ONLY: "只能匯入正在開啟的項目",
  FE_42_ZQ_STORE_DESCRIPTION: "描述",
  FE_42_ZQ_STORE_DOWNLOAD: "下載資源",
  FE_42_ZQ_STORE_DOWNLOADED: "已下載",
  FE_42_ZQ_STORE_FREE: "免費",
  FE_42_ZQ_STORE_FULLPCK: "完整包體",
  FE_42_ZQ_STORE_FULLPCKSUC: "已成功通知專案導入整包。",
  FE_42_ZQ_STORE_FULLPCKTIPS: "支援自由編輯，容量更大",
  FE_42_ZQ_STORE_GET: "獲得",
  FE_42_ZQ_STORE_IMPORT: "導入專案",
  FE_42_ZQ_STORE_MYASSET: "我的資源",
  FE_42_ZQ_STORE_MYUPLOAD: "我的發布",
  FE_42_ZQ_STORE_NAME: "標題",
  FE_42_ZQ_STORE_NOASSET: "未獲得任何資源",
  FE_42_ZQ_STORE_NORESULT: "無相關內容。請嘗試其他關鍵字",
  FE_42_ZQ_STORE_NOTDOWNLOAD: "未下載",
  FE_42_ZQ_STORE_NOTUPLOADED: "未發布",
  FE_42_ZQ_STORE_NOUPLOAD: "未上傳任何資源",
  FE_42_ZQ_STORE_OPENPROJECT: "通過打開一個新專案導入整包。",
  FE_42_ZQ_STORE_OWNED: "已獲取",
  FE_42_ZQ_STORE_PICTIPS: "建議尺寸為{0}px，大小必須在{1}以內。",
  FE_42_ZQ_STORE_PICWARNING: "檔案大小超出限制{0}。",
  FE_42_ZQ_STORE_PRICE: "售價",
  FE_42_ZQ_STORE_REDOWNLOAD: "重新下載",
  FE_42_ZQ_STORE_RELOAD: "正在替換成引用專案。您需要重新載入。",
  FE_42_ZQ_STORE_RENEWAL: "最近更新",
  FE_42_ZQ_STORE_RESNAME: "暱稱必須介於 {0} 到 {1} 個字元之間。",
  FE_42_ZQ_STORE_RESPCK: "參考包體",
  FE_42_ZQ_STORE_RESPCKSUC: "成功載入引用包資源。",
  FE_42_ZQ_STORE_RESPCKTIPS: "不支援編輯，容量更小更快",
  FE_42_ZQ_STORE_SELECTFILE: "選擇檔案",
  FE_42_ZQ_STORE_SELECTIMPORT: "選擇資源",
  FE_42_ZQ_STORE_UPDATE: "點此更新遊戲資源",
  FE_42_ZQ_STORE_UPDATEANDUPLOAD: "更新並發布",
  FE_42_ZQ_STORE_UPDATECONFIRM: "是否要更新資源包?確認後其他玩家將會需要更新資源。",
  FE_42_ZQ_STORE_UPDATEDOWNLOAD: "更新下載",
  FE_42_ZQ_STORE_UPLOAD: "上傳",
  FE_42_ZQ_STORE_UPLOADCANCEL: "這將不會保存你所填寫的內容，確定取消上傳嗎?",
  FE_42_ZQ_STORE_UPLOADED: "已發布",
  FE_42_ZQ_STORE_UPLOADING: "發布中",
  FE_43A_HZY_ACCOUNT_BOUNDTIP: "偵測到已登入的《Free Fire》帳戶。如果您現在退出綁定流程，將清除已偵測到的帳戶資訊。",
  FE_43A_HZY_ACCOUNT_UNBOUND: "未綁定",
  FE_43A_HZY_ERROR_TIP1: "無法轉換為",
  FE_43A_HZY_ERROR_TIP2: "未找到",
  FE_43A_HZY_PROJECT_SCREEN: "過濾器",
  FE_43A_HZY_PROJECT_SCREENRESET: "重置過濾器",
  FE_43A_HZY_SCENE_ALIGNMENT: "同步",
  FE_43A_HZY_SCENE_ALIGNMENTSET: "同步設置",
  FE_43A_HZY_SCENE_ALIGNMENTTIP: "按住 Ctrl 鍵可快速啟用/停用此功能",
  FE_43A_HZY_SCENE_CAMERASPEED: "調整場景中的相機移動速度",
  FE_43A_HZY_SCENE_OPERATETIP: "工具提示",
  FE_43A_HZY_SCENE_OPERATE_TIP1: "選擇/選框",
  FE_43A_HZY_SCENE_OPERATE_TIP10: "取消新建地形",
  FE_43A_HZY_SCENE_OPERATE_TIP11: "取消繪製",
  FE_43A_HZY_SCENE_OPERATE_TIP12: "清除選取植被",
  FE_43A_HZY_SCENE_OPERATE_TIP13: "清除全部植被",
  FE_43A_HZY_SCENE_OPERATE_TIP2: "轉動視角",
  FE_43A_HZY_SCENE_OPERATE_TIP3: "移動/縮放視角",
  FE_43A_HZY_SCENE_OPERATE_TIP4: "快速拖曳",
  FE_43A_HZY_SCENE_OPERATE_TIP5: "自由移動",
  FE_43A_HZY_SCENE_OPERATE_TIP6: "上下移動",
  FE_43A_HZY_SCENE_OPERATE_TIP7: "加速移動",
  FE_43A_HZY_SCENE_OPERATE_TIP8: "擺放物件",
  FE_43A_HZY_SCENE_OPERATE_TIP9: "退出擺放",
  FE_43A_M_TASKS: "Craftland 任務設定",
  FE_43A_M_TASKS2: "任務設置",
  FE_43A_M_TASKS3: "任務進度",
  FE_43A_SD_CLOTH_RES: "全套服裝",
  FE_43A_SD_CSV_RES: "CSV表",
  FE_43A_SD_ECAC_RES: "客户端ECA",
  FE_43A_SD_ECA_RES: "服務器 ECA",
  FE_43A_SD_EFFECT_RES: "特效",
  FE_43A_SD_EMOTE_RES: "動作",
  FE_43A_SD_FCGC_RES: "客户端FCG",
  FE_43A_SD_INTERNALHUD_RES: "內建HUD",
  FE_43A_SD_ITEM_RES: "道具",
  FE_43A_SD_MOD_RES: "關卡對象",
  FE_43A_SD_OTHER_RES: "其他",
  FE_43A_SD_QUIT_INFOR: "以下檔案尚未儲存，是否現在要儲存？",
  FE_43A_SD_SOUND_RES: "音效",
  FE_43A_SD_TABM_CLOSE: "關閉",
  FE_43A_SD_TABM_CLOSEOTHER: "關閉其他標籤頁",
  FE_43A_SD_TABM_CLOSERIGHT: "關閉右側標籤頁",
  FE_43A_SD_TABM_LOCATIONOPEN: "打開本地文件位置",
  FE_43A_SD_TABM_LOCATIONVIEW: "查看檔案位置",
  FE_43A_SD_TABM_SAVEALL: "儲存所有標籤頁",
  FE_43A_SD_TABM_SAVECURRENT: "儲存目前的檔案",
  FE_43A_SD_TEXTURE_RES: "貼圖文件",
  FE_43A_SD_VEHICLESKIN_RES: "載具外觀",
  FE_43A_SD_WEAPONSKIN_RES: "槍皮",
  FE_43_HJ_NFPP_3CRESOURCE: "3C資源下載",
  FE_43_HJ_NFPP_SWITCH: "使用新版第一人稱資源",
  FE_43_HZY_COMPLIANT_TIP: `發現不相容的版本（編輯器版本: {0}，資源版本: {1}）
可能會缺少一些功能。是否繼續？`,
  FE_43_HZY_UPDATE: "版本更新",
  FE_43_HZY_UPDATE_CANCEL: "稍後更新",
  FE_43_HZY_UPDATE_CONFIRM: "立即更新",
  FE_43_HZY_UPDATE_MENU_TEST: "檢查更新",
  FE_43_HZY_UPDATE_NETWORKERROR: "網路錯誤，請稍後再試",
  FE_43_HZY_UPDATE_RETRY_TIP: "這將會清除當前進度，如果連線穩定但進度仍停止，請嘗試重新下載",
  FE_43_HZY_UPDATE_SAVE: "儲存並上傳",
  FE_43_HZY_UPDATE_TEST: "檢查版本",
  FE_43_HZY_UPDATE_TIP: "目前的編輯器版本已過期。 請先儲存您的檔案並更新編輯器以使用發布功能。",
  FE_43_HZY_UPDATE_TIP1: "編輯器已為最新版本",
  FE_43_HZY_UPDATE_TIP2: `版本驗證失敗。
未連線到伺服器。 請檢查您的網路並重試。`,
  FE_43_HZY_UPDATE_W_CLOSETIP: "目前正在下載 Craftland Sudio {0}。 確定要退出嗎？",
  FE_43_HZY_UPDATE_W_DEFAULT: `1. 修復一些已知錯誤 
2. 優化細節帶來更佳的體驗`,
  FE_43_HZY_UPDATE_W_DETAIL: "{0}更新内容",
  FE_43_HZY_UPDATE_W_LOAD: "下載中...",
  FE_43_HZY_UPDATE_W_RECONNECT: "重連中...",
  FE_43_HZY_UPDATE_W_RETRY: "重新下載",
  FE_43_HZY_UPDATE_W_TIP1: "注意：發現新版本。 建議將目前版本 {0} 更新至最新版本。",
  FE_43_HZY_UPDATE_W_TIP2: "注意：您目前的版本 {0} 已過期，請立即更新。",
  FE_43_HZY_UPDATE_W_WEB: "查看網站",
  FE_43_M_BOMBERSCRIPT: "炸彈人（腳本）",
  FE_43_SD_ASSETS: "資源",
  FE_43_SD_ASSETS_IMPACK: "導入package",
  FE_43_SD_ASSETS_IMPORT: "導入",
  FE_43_SD_ASSETS_OUTPACK: "匯出為package",
  FE_43_SD_ASSETS_PACKSHOP: "資源商店",
  FE_43_SD_ASSETS_UPLOADPACK: "產生資源包並上傳",
  FE_43_SD_EDIT: "編輯",
  FE_43_SD_EDIT_COPY: "複製",
  FE_43_SD_EDIT_DELETE: "刪除",
  FE_43_SD_EDIT_DUPLICATE: "複製",
  FE_43_SD_EDIT_FOCUS: "聚焦",
  FE_43_SD_EDIT_PASTE: "貼上",
  FE_43_SD_EDIT_REDO: "重做",
  FE_43_SD_EDIT_RENAME: "重新命名",
  FE_43_SD_EDIT_SAVE: "儲存",
  FE_43_SD_EDIT_UNDO: "撤銷",
  FE_43_SD_ERROR_DIVISOR: "除數不能為0",
  FE_43_SD_ERROR_KEY_NOTINMAP: "映射中不存在該鍵：{0}",
  FE_43_SD_ERROR_LIST_OUTRANGE: "清單索引超出範圍：{0}",
  FE_43_SD_FCG_ASSETLOST: "檔案遺失，子級註冊內容失效",
  FE_43_SD_FCG_ASS_RES: "資源註冊",
  FE_43_SD_FCG_DELETE_TEXT_B: "是否確定要刪除此資源註冊？",
  FE_43_SD_FCG_DELETE_TEXT_F: "您已經註冊了該資源內的子節點，刪除該資源註冊後，將使子節點註冊失效",
  FE_43_SD_FCG_DELETE_WIN: "注意",
  FE_43_SD_FCG_ENTITYSELETE: "實體選擇",
  FE_43_SD_FCG_FCG_RES: "伺服器FCG",
  FE_43_SD_FCG_FILESELETE: "檔案選擇",
  FE_43_SD_FCG_KEY_NAMEINL: "Key命名不合規定",
  FE_43_SD_FCG_N_DICT: "腳本變數名稱",
  FE_43_SD_FCG_N_ENUM: "列舉名稱",
  FE_43_SD_FCG_N_GRAPH: "圖像名稱",
  FE_43_SD_FCG_OBJ_RES: "場景物件註冊",
  FE_43_SD_FCG_PREFAB_RES: "Prefab 檔案",
  FE_43_SD_FCG_SCE_RES: "場景文件",
  FE_43_SD_FCG_SCE_WAITRESIST: "請先註冊場景檔案",
  FE_43_SD_FCG_SYN_DES: "引用語法",
  FE_43_SD_FCG_UI_RES: "使用者介面",
  FE_43_SD_FCG_UI_WAITRESIST: "請先註冊 UI 檔案",
  FE_43_SD_FCG_UI_WID_RES: "註冊 UI 控件",
  FE_43_SD_FCG_WINDOWNAME: "註冊腳本資源",
  FE_43_SD_FILE: "檔案",
  FE_43_SD_FILE_BUILD: "產生",
  FE_43_SD_FILE_EXIT: "退出",
  FE_43_SD_FILE_MODULE: "系統設置",
  FE_43_SD_FILE_NEW: "新建專案",
  FE_43_SD_FILE_OPEN: "開啟專案",
  FE_43_SD_FILE_PUBLISH: "發布專案",
  FE_43_SD_FILE_QUITRUN: "退出運行",
  FE_43_SD_FILE_RUN: "運行",
  FE_43_SD_FILE_SAVE: "儲存專案",
  FE_43_SD_HELP: "幫助",
  FE_43_SD_HELP_ABOUT: "關於",
  FE_43_SD_HELP_ACCOUNT: "帳號管理",
  FE_43_SD_HELP_APIMANUAL: "API文件",
  FE_43_SD_HELP_CONTACT: "聯絡我們",
  FE_43_SD_HELP_SUGGEST: "建議與回饋",
  FE_43_SD_HELP_UPDATE: "版本更新",
  FE_43_SD_HELP_UPDATELOG: "更新日誌",
  FE_43_SD_HELP_USERMANUAL: "使用手冊",
  FE_43_SD_MODULE_ENTRY: "系統設置",
  FE_43_SD_SINGLEFILE_SAVE: "儲存",
  FE_43_SD_TOOLS: "工具",
  FE_43_SD_TOOLS_COMPONENT: "組件管理",
  FE_43_SD_TOOLS_DEBUG: "偵錯設定",
  FE_43_SD_TOOLS_DEVELOPER: "開發者工具",
  FE_43_SD_TOOLS_ENUM: "列舉管理",
  FE_43_SD_TOOLS_FCG: "腳本化工具",
  FE_43_SD_TOOLS_FCG_NAME: "快速腳本名稱命名",
  FE_43_SD_TOOLS_FCG_REGISTER: "註冊腳本資源",
  FE_43_SD_TOOLS_LOC: "本地化設定",
  FE_43_SD_TOOLS_OPENLOG: "開啟日誌目錄",
  FE_43_SD_TOOLS_PREFER: "偏好設置",
  FE_43_SD_TOOLS_SEARCH: "全域搜尋",
  FE_43_SD_TOOLS_WORDFILTER: "不雅字眼偵測",
  FE_43_SD_WINDOW: "窗口",
  FE_43_SD_WINDOW_DECK: "工作區",
  FE_43_SD_WINDOW_FULL: "全螢幕",
  FE_43_SD_WINDOW_LAYOUT: "布局",
  FE_43_SD_WINDOW_LAYOUT_DEF: "默認",
  FE_43_SD_WINDOW_LAYOUT_DEL: "刪除佈局",
  FE_43_SD_WINDOW_LAYOUT_SAVE: "儲存布局",
  FE_43_TYC_ENABLE_UGC_SPECTATOR: "允許觀戰模式",
  FE_43_TYC_FREE_PERSPECTIVE: "自由觀戰",
  FE_43_TYC_FREE_PERSPECTIVE_WITH_REBOUND: "自由觀戰並重新設定視角",
  FE_43_TYC_KEEP_TARGET_PERSPECTIVE: "鎖定特定玩家",
  FE_43_TYC_ONLY_ALLOW_SPECTATING_SELF: "僅限自己",
  FE_43_TYC_ONLY_SPECTATING_ALLIES: "僅限友善玩家",
  FE_43_TYC_ONLY_SPECTATING_SAME_FACTION: "僅限戰隊成員",
  FE_43_TYC_ONLY_SPECTATING_SAME_TEAM: "僅限隊友",
  FE_43_TYC_PHYSICS_DESC_ANG: "以度為單位。如果坡度角度超過此值，角色將無法行走並且控制器會滑下。",
  FE_43_TYC_PHYSICS_DESC_G: "應用於角色控制器的重力加速度",
  FE_43_TYC_PHYSICS_DESC_H: "膠囊對撞機的高度，包括半球的高度。",
  FE_43_TYC_PHYSICS_DESC_MAX_V: "角色控制器的絕對速度不能超過該值",
  FE_43_TYC_PHYSICS_DESC_MIN_D: "如果移動距離小於此值，角色將不會移動。",
  FE_43_TYC_PHYSICS_DESC_OFFSET: "從變換中心到膠囊碰撞器中心的偏移向量",
  FE_43_TYC_PHYSICS_DESC_R: "膠囊對撞機的半徑。 它不能超過對撞機高度的一半。",
  FE_43_TYC_PHYSICS_DESC_SKIN_W: "刺入膠囊的深度，防止角色卡住或抖動",
  FE_43_TYC_PHYSICS_DESC_VTD: "上下樓梯時允許的偏移距離使角色不會偏離平面或被阻擋。",
  FE_43_TYC_SHOW_LOBBY_BUTTON: "顯示大廳按鈕",
  FE_43_TYC_SPECTATING_ANY_TARGET: "任何人",
  FE_43_TYC_SPECTATOR_CAMERA_CONTROL_SETTING: "觀戰視角控制",
  FE_43_TYC_SPECTATOR_SETTINGS: "觀戰設定",
  FE_43_TYC_SPECTATOR_TARGET_SETTING: "觀戰者定義",
  FE_43_TYC_UIED_TEXT_CLIPPING_SETTING: "文字裁剪",
  FE_43_TYC_UIED_TEXT_DIRECT_CLIPPING: "裁剪溢出文本",
  FE_43_TYC_UIED_TEXT_NO_CLIPPING: "請勿裁剪",
  FE_43_TYC_UIED_TEXT_REDUCE_FONT_SIZE: "減小字體大小",
  FE_43_TYC_UIED_TEXT_SHADOW_COLOR: "陰影顏色",
  FE_43_TYC_UIED_TEXT_SHADOW_ENABLED: "啟用陰影效果",
  FE_43_TYC_UIED_TEXT_SHADOW_OFFSET: "陰影",
  FE_43_TYC_UNEDITABEL_INTERNAL_TEXTURE: "此為 Free Fire 資源，您無法編輯。",
  FE_43_XXJ_COPYCOMPONENT: "複製組件",
  FE_43_XXJ_GETVECTOR2COMPONENT: "取得 Vector2 組件",
  FE_43_XXJ_GETVECTOR3COMPONENT: "取得 Vector3 組件",
  FE_43_XXJ_MODULEUNOPENED: "請啟用以下模組並重試。",
  FE_43_XXJ_PASTECOMPNEW: "將新組件貼上",
  FE_43_XXJ_PASTECOMPVALUE: "貼上組件值",
  FE_43_XXJ_PHYSICS_ISCONVEX: "是凸起",
  FE_43_XXJ_REQUIRECOMP: "需要組件",
  FE_43_XXJ_SETVECTOR2COMPONENT: "設定 Vector2 組件",
  FE_43_XXJ_SETVECTOR3COMPONENT: "設定 Vector3 組件",
  FE_43_XXJ_VECTOR2OPERATIONS: "Vector2 運作",
  FE_43_XXJ_VECTOR3OPERATIONS: "Vector3 運作",
  FE_43_XYL_AUTORENDERING: "自動合併與渲染實例",
  FE_43_XYL_BATCHING: "合批",
  FE_43_XYL_CLIENT: "客戶端",
  FE_43_XYL_CLIENTFCG: "客戶端fcg",
  FE_43_XYL_CLINETECA: "客戶端ECA",
  FE_43_XYL_CROSSEND: "是否跨端發送",
  FE_43_XYL_CULLBACK: "背面裁剪",
  FE_43_XYL_CULLMODE: "裁剪模式",
  FE_43_XYL_CULLOFF: "不裁剪",
  FE_43_XYL_ECACTEMPLATE: "ECAC 模板",
  FE_43_XYL_EVENTTARGETSIDE: "事件端",
  FE_43_XYL_INHERITRENDERINGOPT: "繼承父級設定",
  FE_43_XYL_MASKCOLOR: "遮罩顏色",
  FE_43_XYL_MASKTEXTURE: "遮罩貼圖",
  FE_43_XYL_MERGEMODELS: "自動合併模型",
  FE_43_XYL_NOTIFYCLIENT: "通知客戶端",
  FE_43_XYL_OFFLINECHILD: "離線時合併子節點模型",
  FE_43_XYL_ONLINECHILD: "於運行時合併子節點模型",
  FE_43_XYL_PREFORMANCEOPT: "地圖效能優化",
  FE_43_XYL_REDUCTION: "網格簡化",
  FE_43_XYL_RENDERINGOPT: "渲染性能優化",
  FE_43_XYL_SERVER: "伺服器",
  FE_43_XYL_SERVERCLIENT: "客戶端與伺服器",
  FE_43_XYL_SERVERECA: "伺服器ECA",
  FE_43_XYL_SERVERFCG: "伺服器fcg",
  FE_43_XYL_STREAMINGDIST: "載入距離",
  FE_43_XYL_STREAMINGDIVD: "區域劃分尺寸",
  FE_43_YU_WS_MODULEOPERATION: "使用前須先載入此模型",
  FE_43_YU_WS_MODULE_ALL: "所有",
  FE_43_YU_WS_MODULE_BELONGEDMODULEDISABLE: "依賴模組目前停用中",
  FE_43_YU_WS_MODULE_BELONGEDMODULEMISS: "對應的模組尚未啟用：",
  FE_43_YU_WS_MODULE_CANCEL: "取消",
  FE_43_YU_WS_MODULE_CANNOTINSTALLEDMODULES: "無法在實際版本中安裝測試模組。",
  FE_43_YU_WS_MODULE_CANNOTINSTALLINTERNALMODULE: "您沒有權限安裝此模組：",
  FE_43_YU_WS_MODULE_CONFIRMTHEUNINSTALL: "所有使用的API、事件、該模組的資源將會失效，確認要解除安裝嗎？",
  FE_43_YU_WS_MODULE_CUSTOMCURRENCY: "自訂貨幣",
  FE_43_YU_WS_MODULE_CUSTOMMINIMAP: "自訂小地圖",
  FE_43_YU_WS_MODULE_DEATHWATCH: "觀戰模式",
  FE_43_YU_WS_MODULE_DEFAULTMINIMAP: "預設小地圖",
  FE_43_YU_WS_MODULE_DELETIONFAILED: "刪除模組配置失敗",
  FE_43_YU_WS_MODULE_DESCRIPTION: "描述",
  FE_43_YU_WS_MODULE_DISABLE: "停用",
  FE_43_YU_WS_MODULE_DISABLEMODULE: "依賴模組目前停用中。請啟用所有相關的模組以使用相應功能。目前停用的依賴模組包括：",
  FE_43_YU_WS_MODULE_EXCLUSIVEMODULE: "與目前模組衝突的模組已啟用。 請確保所有這些都已停用。 這些模組包括：",
  FE_43_YU_WS_MODULE_EXITEXCLUSIVEMODULE: "存在模組衝突",
  FE_43_YU_WS_MODULE_FUNCTIONSTATUS: "啟用功能",
  FE_43_YU_WS_MODULE_LOADED: "已載入",
  FE_43_YU_WS_MODULE_LOADING: "載入",
  FE_43_YU_WS_MODULE_LOADINGTIPS: "讀取提示",
  FE_43_YU_WS_MODULE_MARKEDDISCARD: "該模組已被停止使用，未來版本將不再支援該模組。請停止使用以避免潛在風險。",
  FE_43_YU_WS_MODULE_MINIMAPTYPE: "小地圖類型",
  FE_43_YU_WS_MODULE_MODMOVED: "該模組已被刪除。",
  FE_43_YU_WS_MODULE_MODULEMANAGEMENT: "模組管理",
  FE_43_YU_WS_MODULE_NAME: "模組",
  FE_43_YU_WS_MODULE_NOTLOADED: "尚未載入",
  FE_43_YU_WS_MODULE_NUMBEROFPLAYERS: "玩家數量",
  FE_43_YU_WS_MODULE_ONECLICKLOADING: "載入所有",
  FE_43_YU_WS_MODULE_ONLINEDATAMANAGEMENT: "線上管理",
  FE_43_YU_WS_MODULE_OPENTHEMOD: "啟用模組：",
  FE_43_YU_WS_MODULE_PRESETTYPE: "預設角色類型",
  FE_43_YU_WS_MODULE_REGISTRATIONFAILED: "註冊失敗",
  FE_43_YU_WS_MODULE_SCENE: "場景",
  FE_43_YU_WS_MODULE_SETTINGS: "設定",
  FE_43_YU_WS_MODULE_SPECIALSETTINGS: "特殊設定",
  FE_43_YU_WS_MODULE_TYPESELECTION: "類型選擇",
  FE_43_YU_WS_MODULE_UNINSTALL: "解除安裝",
  FE_43_YU_WS_MODULE_UNINSTALLED: "已成功解除模組安裝",
  FE_43_YU_WS_MODULE_UNINSTALLPROMPT: "解除安裝注意事項",
  FE_43_YU_WS_MODULE_UNLOADEDDEPENDENCYFEATURES: "這個模組包含必須上傳和啟用的相依性，以便您可以使用相關的功能。尚未載入的相依性包括：",
  FE_43_YU_WS_MODULE_WARNING1: "在配置表中找不到該條目",
  FE_43_YU_WS_MODULE_WARNING2: "配置表錯誤",
  FE_43_ZQ_PLAYER_ACTION: "動作",
  FE_43_ZQ_PLAYER_ADDACTION: "新增角色動作",
  FE_43_ZQ_PLAYER_ATTACK1FIST: "左手攻擊",
  FE_43_ZQ_PLAYER_ATTACK2FIST: "右手攻擊",
  FE_43_ZQ_PLAYER_ATTACK2GUN: "射擊（持步槍）",
  FE_43_ZQ_PLAYER_ATTACK2PISTOL: "射擊（持手槍）",
  FE_43_ZQ_PLAYER_BONETIPS: "部分骨架與Free Fire角色骨骼不匹配，可能導致無法正常播放動畫。",
  FE_43_ZQ_PLAYER_CACTION: "角色動作",
  FE_43_ZQ_PLAYER_CHANGECLIPGUN: "換彈（持步槍）",
  FE_43_ZQ_PLAYER_CHANGECLIPPISTOL: "換彈（持手槍）",
  FE_43_ZQ_PLAYER_CHANGEWEAPON: "切換武器",
  FE_43_ZQ_PLAYER_CMESH: "角色模型",
  FE_43_ZQ_PLAYER_CRAWIDLEFIST: "俯臥",
  FE_43_ZQ_PLAYER_CRAWLCHANGECLIPGUN: "俯臥換彈（持步槍）",
  FE_43_ZQ_PLAYER_CRAWLCHANGECLIPPISTOL: "俯臥換彈（持手槍）",
  FE_43_ZQ_PLAYER_CRAWLCHANGEWEAPON: "俯臥時切換武器",
  FE_43_ZQ_PLAYER_CRAWLFFIST: "俯臥移動",
  FE_43_ZQ_PLAYER_CRAWLFGUN: "俯臥移動（持步槍）",
  FE_43_ZQ_PLAYER_CRAWLFIREGUN: "俯臥瞄準（持步槍）",
  FE_43_ZQ_PLAYER_CRAWLFIREPISTOL: "俯臥瞄準（持手槍）",
  FE_43_ZQ_PLAYER_CRAWLFIRINGGUN: "俯臥射擊（持步槍）",
  FE_43_ZQ_PLAYER_CRAWLFIRINGPISTOL: "俯臥射擊（持手槍）",
  FE_43_ZQ_PLAYER_CRAWLFPISTOL: "俯臥移動（持手槍）",
  FE_43_ZQ_PLAYER_CRAWLIDLEGUN: "俯臥（持步槍）",
  FE_43_ZQ_PLAYER_CRAWLIDLEPISTOL: "俯臥（持手槍）",
  FE_43_ZQ_PLAYER_CROUCHATTACK1FIST: "蹲下左手攻擊",
  FE_43_ZQ_PLAYER_CROUCHATTACK2FIST: "蹲下右手攻擊",
  FE_43_ZQ_PLAYER_CROUCHATTACK2GUN: "蹲下射擊（持步槍）",
  FE_43_ZQ_PLAYER_CROUCHATTACK2PISTOL: "蹲下射擊（持手槍）",
  FE_43_ZQ_PLAYER_CROUCHBGUN: "瞄準時蹲下向後移動（持步槍）",
  FE_43_ZQ_PLAYER_CROUCHBPISTOL: "瞄準時蹲下向後移動（持手槍）",
  FE_43_ZQ_PLAYER_CROUCHCHANGECLIPGUN: "蹲下換彈（持步槍）",
  FE_43_ZQ_PLAYER_CROUCHCHANGECLIPPISTOL: "蹲下換彈（持手槍）",
  FE_43_ZQ_PLAYER_CROUCHCHANGEWEAPON: "蹲下時切換武器",
  FE_43_ZQ_PLAYER_CROUCHFFIST: "蹲下移動",
  FE_43_ZQ_PLAYER_CROUCHFGUN: "蹲下移動（持步槍）",
  FE_43_ZQ_PLAYER_CROUCHFPISTOL: "蹲下移動（持手槍）",
  FE_43_ZQ_PLAYER_CROUCHIDLEFIST: "蹲下",
  FE_43_ZQ_PLAYER_CROUCHIDLEGUN: "蹲下（持步槍）",
  FE_43_ZQ_PLAYER_CROUCHIDLEPISTOL: "蹲下（持手槍）",
  FE_43_ZQ_PLAYER_CROUCHLGUN: "瞄準時蹲下向左移動（持步槍）",
  FE_43_ZQ_PLAYER_CROUCHLPISTOL: "瞄準時蹲下向左移動（持手槍）",
  FE_43_ZQ_PLAYER_CROUCHRGUN: "瞄準時蹲下向右移動（持步槍）",
  FE_43_ZQ_PLAYER_CROUCHRPISTOL: "瞄準時蹲下向右移動（持手槍）",
  FE_43_ZQ_PLAYER_CUSTOMP: "玩家數據",
  FE_43_ZQ_PLAYER_DACTION: "預設動作",
  FE_43_ZQ_PLAYER_DASHRUNFFIST: "奔跑",
  FE_43_ZQ_PLAYER_DASHRUNFGUN: "奔跑（持步槍）",
  FE_43_ZQ_PLAYER_DASHRUNFPISTOL: "奔跑（持手槍）",
  FE_43_ZQ_PLAYER_DRIVERIDLE: "作為司機坐姿",
  FE_43_ZQ_PLAYER_FEMALE: "女性",
  FE_43_ZQ_PLAYER_GENDER: "性別",
  FE_43_ZQ_PLAYER_GETRIG: "可點選此處取得預設設置",
  FE_43_ZQ_PLAYER_HIT: "被擊中",
  FE_43_ZQ_PLAYER_IDLE: "閒置",
  FE_43_ZQ_PLAYER_INCARIDLE: "作為乘客坐姿",
  FE_43_ZQ_PLAYER_JUMPDOWNFIST: "跳躍墜落",
  FE_43_ZQ_PLAYER_JUMPDOWNGUN: "跳躍墜落（持步槍）",
  FE_43_ZQ_PLAYER_JUMPDOWNPISTOL: "跳躍墜落（持手槍）",
  FE_43_ZQ_PLAYER_JUMPLANDFIST: "跳躍落地",
  FE_43_ZQ_PLAYER_JUMPLANDGUN: "跳躍落地（持步槍）",
  FE_43_ZQ_PLAYER_JUMPLANDPISTOL: "跳躍落地（持手槍）",
  FE_43_ZQ_PLAYER_JUMPUPFIST: "跳躍開始",
  FE_43_ZQ_PLAYER_JUMPUPGUN: "跳躍開始（持步槍）",
  FE_43_ZQ_PLAYER_JUMPUPPISTOL: "跳躍開始（持手槍）",
  FE_43_ZQ_PLAYER_LINE: "底線",
  FE_43_ZQ_PLAYER_MALE: "男性",
  FE_43_ZQ_PLAYER_MOVE: "移動",
  FE_43_ZQ_PLAYER_NEARDEATHIDLE: "擊倒",
  FE_43_ZQ_PLAYER_NEARDEATHMOVE: "倒地時向前爬行",
  FE_43_ZQ_PLAYER_NEWCUSTOMP: "新預設角色",
  FE_43_ZQ_PLAYER_NORMALDEAD: "死亡",
  FE_43_ZQ_PLAYER_ONLYADDEDANIM: "只播放添加動作",
  FE_43_ZQ_PLAYER_PLATFORM: "Free Fire 角色",
  FE_43_ZQ_PLAYER_PREVIEWTIPS: "請先新增一個模型！",
  FE_43_ZQ_PLAYER_RIG: "取得預設設置",
  FE_43_ZQ_PLAYER_RIGTIPS: "若想要更改角色模型，建議使用官方的設置，並在其他建模軟體中匯入使用，即可正常播放所有預設動畫。",
  FE_43_ZQ_PLAYER_RUNFFIST: "向前移動",
  FE_43_ZQ_PLAYER_RUNFGUN: "向前移動（持步槍）",
  FE_43_ZQ_PLAYER_RUNFPISTOL: "向前移動（持手槍）",
  FE_43_ZQ_PLAYER_SHOOTIDLEGUN: "站立瞄準（持步槍）",
  FE_43_ZQ_PLAYER_SHOOTIDLEPISTOL: "站立瞄準（持手槍）",
  FE_43_ZQ_PLAYER_STANDIDLEFIST: "站立",
  FE_43_ZQ_PLAYER_STANDIDLEGUN: "站立（持長槍）",
  FE_43_ZQ_PLAYER_STANDIDLEPISTOL: "站立（持手槍）",
  FE_43_ZQ_PLAYER_WALKBGUN: "瞄準時向後移動（持步槍）",
  FE_43_ZQ_PLAYER_WALKBPISTOL: "瞄準時向後移動（持手槍）",
  FE_43_ZQ_PLAYER_WALKFGUN: "瞄準時向前移動（持步槍）",
  FE_43_ZQ_PLAYER_WALKFPISTOL: "瞄準時向前移動（持手槍）",
  FE_43_ZQ_PLAYER_WALKLGUN: "瞄準時向左移動（持步槍）",
  FE_43_ZQ_PLAYER_WALKLPISTOL: "瞄準時向左移動（持手槍）",
  FE_43_ZQ_PLAYER_WALKRGUN: "瞄準時向右移動（持步槍）",
  FE_43_ZQ_PLAYER_WALKRPISTOL: "瞄準時向右移動（持手槍）",
  FE_43_ZQ_REMOVE_REMOVE: "移除",
  FE_43_ZQ_REVIEW_LINEROW: "{3} 已被檢測為 {0} 的第 {1} 行、第 {2} 列的敏感詞。請修改後再試一次。",
  FE_43_ZQ_REVIEW_MEANNING: "在 {0} 中檢測到敏感信息。請進行修改後重試。",
  FE_43_ZQ_STORE_BACK: "上一步",
  FE_43_ZQ_STORE_CHANGEPROJECT: "此參考資源來自當前專案。請嘗試另一個專案。",
  FE_43_ZQ_STORE_CODE: "資源辨識碼",
  FE_43_ZQ_STORE_CODECHANGE: "資源辨識碼已更改！",
  FE_43_ZQ_STORE_CREATE: "新建資源",
  FE_43_ZQ_STORE_DELETEPURCHASE: "從資源庫中移除",
  FE_43_ZQ_STORE_DETAIL: "詳細資訊",
  FE_43_ZQ_STORE_DOWN: "下架",
  FE_43_ZQ_STORE_EDIT: "操作介面",
  FE_43_ZQ_STORE_ESTSIZE: "預估大小",
  FE_43_ZQ_STORE_FABCANNOT: "此資源不能被打包為商店資源。",
  FE_43_ZQ_STORE_HIGHVERSION: "商店資源版本號高於當前版本號。",
  FE_43_ZQ_STORE_NEEDLOGIN: "上傳前請先進行登入",
  FE_43_ZQ_STORE_NEWRES: "發布新資源",
  FE_43_ZQ_STORE_NEWRESTIPS: "在資源商店中新增資源",
  FE_43_ZQ_STORE_NEXT: "下一步",
  FE_43_ZQ_STORE_NOSEARCH: "未檢測到相關資源。",
  FE_43_ZQ_STORE_OPENED: "專案開啟狀態下，無法退出 Craftland Studio",
  FE_43_ZQ_STORE_PUBSET: "發布設定",
  FE_43_ZQ_STORE_QUOTECANNOT: "此資源不能被打包為商店資源，因為此資源或其引用中含有引用包中的資源。",
  FE_43_ZQ_STORE_REMOVEMYASSET: "將從【資源庫】中移除該資源但不會刪除本機文件，是否繼續？",
  FE_43_ZQ_STORE_REMOVEMYUPLOAD: "該資源將從上傳空間中刪除。 繼續？",
  FE_43_ZQ_STORE_RESDETAIL: "資源詳情",
  FE_43_ZQ_STORE_RESERRORTIPS: "操作異常，儲存失敗！",
  FE_43_ZQ_STORE_RESSCENETIPS: "此資源為引用資源，無法儲存，再次進入將復原。",
  FE_43_ZQ_STORE_TRANSFERTIPS: "正在傳輸資源中，繼續推出將會中斷操作，是否要繼續？",
  FE_43_ZQ_STORE_TYPE: "資源類型",
  FE_43_ZQ_STORE_UNPUB: "已下架",
  FE_43_ZQ_STORE_UNPUBCONFIRM: "下架後其他用戶將無法再取得該資源，是否繼續？",
  FE_43_ZQ_STORE_UPDATERES: "更新資源",
  FE_43_ZQ_STORE_UPDATERESTIPS: "覆蓋已在資源商店中發布的資源",
  FE_43_ZQ_STORE_UPDATETIME: "更新時間",
  FE_43_ZQ_STORE_UPLOAD: "上傳",
  FE_43_ZQ_STORE_UPTIME: "上傳時間",
  FE_43_ZQ_STORE_VERSION: "編輯器版本",
  FE_44A_HJ_ERRORCODE1: "自訂事件錯誤",
  FE_44A_HJ_ERRORCODE2: "自訂類型錯誤",
  FE_44A_SD_SETTING_UNITTESTBUILD: "單元測試構建，用於QA測試",
  FE_44A_SD_UNITTEST_BUILD: "單元測試構建",
  FE_44A_XXJ_ACTION: "行動",
  FE_44A_XXJ_BASIC: "基本",
  FE_44A_XXJ_COMPCONFLICK: "此元件與其他元件衝突：{0}。",
  FE_44A_XXJ_CONDITION: "條件",
  FE_44A_XXJ_CSVDATA: "CSV 檔",
  FE_44A_XXJ_DEPENDMISS: "尚未添加依賴元件：{0}",
  FE_44A_XXJ_SUPPLY: "供給",
  FE_44A_XXJ_VARIABLE: "變數",
  FE_44A_XXJ_WARNING_COMPCONFLICK: "{0}：組件 {1} 與 {2} 發生衝突。",
  FE_44A_XXJ_WARNING_COMPDEPENDMISS: "{0}：{1} 的依賴元件 {2} 尚未添加。",
  FE_44_HZY_BLADEBALL: "刀鋒球",
  FE_44_HZY_BLOCKINVALID_TIP1: "伺服器不支援該功能",
  FE_44_HZY_BLOCKINVALID_TIP2: "客戶端不支援該功能",
  FE_44_HZY_BLOCKPERMISSION_CONCSOLE: "您將無法發布此內容，因為您正在使用您沒有權限的區塊",
  FE_44_HZY_BLOCKPERMISSION_WARNING: "您無權使用該區塊",
  FE_44_HZY_GUNKING: "槍神",
  FE_44_HZY_HIERARCHY_MOUNTSCRIPT: "掛載腳本",
  FE_44_HZY_INSPECTOR_ADDCOMPONENT: "添加组件",
  FE_44_HZY_INSPECTOR_TEXTURE: "質地",
  FE_44_HZY_INSPECTOR_TILLING: "平鋪",
  FE_44_HZY_INSPECTOR_TYPE: "類型",
  FE_44_HZY_MAPCOVER_PERMISIONTIP: "沒有使用自定義封面的權限。",
  FE_44_HZY_PERMISSIONTIPS1: "這個項目可能包含您無法編輯訪問的資源。這可能會在發布過程中引發錯誤。",
  FE_44_HZY_PERMISSIONTIPS2: "無法發佈該項目，因為其中包含您無法編輯訪問的資源。",
  FE_44_HZY_PROJECT_BASICOBJECT: "基礎物件",
  FE_44_HZY_PROJECT_CREATIONTIME: "按創建時間排序",
  FE_44_HZY_PROJECT_LASTEDITTIME: "按上次開啟時間排序",
  FE_44_HZY_PVE: "喪屍之戰",
  FE_44_HZY_REVIEW_BASE: "基本資訊",
  FE_44_HZY_REVIEW_ROOMPAR: "自定義房間參數",
  FE_44_HZY_SEARCH_FUNCTIONNAME: "按函數名稱進行搜尋",
  FE_44_HZY_SEARCH_VARIABLENAME: "按變數名稱進行搜尋",
  FE_44_HZY_SNIPER: "狙擊手",
  FE_44_M_WS_LOCALVAR: "本地變量",
  FE_44_SD_CUSRESULT: "上傳自訂結算訊息",
  FE_44_SD_EDIT_SELECT_ALL: "全選",
  FE_44_SD_EDIT_SELECT_CHILD: "選擇所有子節點",
  FE_44_SD_EDIT_SELECT_INV: "反選",
  FE_44_SD_EDIT_SELECT_PARENT: "選擇父節點",
  FE_44_SD_FCG_COMPILE: "編譯腳本",
  FE_44_SD_FCG_ENV: "手動部署 FCG 環境",
  FE_44_SD_TIPSFCG: "腳本語法",
  FE_44_TYC_ACTIVE: "活躍狀態",
  FE_44_TYC_ADD_ANIMATION_CLIP: "請新增動畫",
  FE_44_TYC_ARROR: "方向箭頭",
  FE_44_TYC_DRAG_RADIUS: "阻力半徑",
  FE_44_TYC_INACTIVE: "非活動狀態",
  FE_44_TYC_JOYSTICK: "虛擬搖桿",
  FE_44_TYC_JOYSTICK_BG: "虛擬搖桿背景",
  FE_44_TYC_JOYSTICK_CAP: "虛擬搖桿帽",
  FE_44_TYC_KEEP_PRESSED_OUTSIDE: "允許拖曳超出範圍",
  FE_44_TYC_OFFSET: "抵銷",
  FE_44_TYC_PLAYER_ANIMATION_NEED_SSS: "請為站立、站立（步槍）和站立（手槍）添加動畫。",
  FE_44_TYC_RADIUS: "半徑",
  FE_44_TYC_TOGGLE: "切換按鈕",
  FE_44_TYC_TOUCHPAD: "觸控板",
  FE_44_TYC_TRANSPARENCY: "透明度",
  FE_44_TYC_WARNING_SERVER_DRIVEN_DISABLED: "Craftland角色控制器的屬性「IsServerDriven」已停用，因此相關的伺服器API無法生效。",
  FE_44_XXJ_ASSETTYPE: "資產類型",
  FE_44_XXJ_COMPOBSOLETE: "這個組件已被棄用。請移除它以避免相關問題。",
  FE_44_XXJ_EDITCCTSHAPE: "編輯 CCT 形狀",
  FE_44_XXJ_GAMERESULT: "比賽結果",
  FE_44_XXJ_GETRIGISTERASSETBYKEY: "透過Key取得註冊資產",
  FE_44_XXJ_MODULEERROR: "由於模組衝突導致導出失敗。 請檢查模組管理設置，稍後重試。",
  FE_44_XXJ_PREPARING: "即將推出",
  FE_44_XXJ_ROUNFPHASEINDEX: "回合和階段索引",
  FE_44_XXJ_TIPCONTENTHIDE: "隱藏的項目數量為：{0}。並非所有清單都包含這些項目。",
  FE_44_XXJ_WOWEMPTY: "此處沒有任何東西可以展示",
  FE_44_XXJ_WS_RIGISTERRESNAME: "Key",
  FE_44_XYL_AUTOLOD0: "不自動產生LOD",
  FE_44_XYL_AUTOLOD1: "模組大小 > 15m",
  FE_44_XYL_AUTOLOD2: "2m < 模組大小 < 15m",
  FE_44_XYL_AUTOLOD3: "模組大小<2m",
  FE_44_XYL_AUTOREDUCTION: "自動為網格簡化生成 LOD",
  FE_44_XYL_DYNAMICNAVBLOCK: "動態導航網格障礙",
  FE_44_XYL_DYNAMICNAVBLOCKDESC: "根據物件的動態新增或移除狀態，產生或移除阻礙網格尋路的區塊。 使用此功能前，必須先啟用全域動態導覽網格設定。",
  FE_44_XYL_PREVIEWANIM: "請選擇可預覽的動畫文件",
  FE_44_XYL_REDUCTIONLIST: "網格簡化清單",
  FE_44_XYL_SERVERSLOADAREA: "伺服器加載區",
  FE_44_XYL_SERVERSLOADAREACHILD: "地區",
  FE_44_XYL_SERVERSLOADCHOOSE: "啟用場景內的伺服器加載區域",
  FE_44_XYL_SERVERSLOADDESC: "勾選此項以允許在層級面板和場景內編輯伺服器加載區域。(百慕達場景目前不支持此功能)",
  FE_44_XYL_SERVERSLOADSETTING: "伺服器加載設定",
  FE_44_XYL_SERVERTOCLIENT: "同步到客户端",
  FE_44_XYL_SERVERTOCLIENTDESC: "將物件的伺服器邏輯同步到客戶端",
  FE_44_XYL_STREAMING0: "永遠加載",
  FE_44_ZQ_IMPORT_PCKWARNING: "該項目已包含此資源包。 再次導入它可能導致某些資產被替換或引用被中斷。是否要繼續導入？",
  FE_44_ZQ_PREVIEW_RUNGAME: "此資源暫不支援預覽，請執行遊戲查看。",
  FE_44_ZQ_PREVIEW_SELECT: "請選擇使用以預覽的模型",
  FE_44_ZQ_RES_LOST: "引用資源 {0} 已遺失",
  FE_44_ZQ_RES_NOEDIT: "來自引用資源：{0}。 無法編輯。",
  FE_44_ZQ_RES_PHASETIPS: "使用了階段索引的圖元，不可匯出進引用包內。",
  FE_44_ZQ_RES_PREECA: "預設腳本",
  FE_44_ZQ_RES_PRESFROM: "引用自 {0}",
  FE_44_ZQ_RES_RESENUM: "來自引用包的枚舉",
  FE_45A_M_MODIFICATION: "是否確認修改數據",
  FE_45A_M_SAVEFAILED: "修改資料錯誤，儲存失敗。",
  FE_45A_SD_ISSTATIC: "是否為靜態",
  FE_45A_SD_NAME_ECA: "區塊腳本",
  FE_45A_SD_NAME_ECAC: "客戶端區塊腳本",
  FE_45A_SD_NAME_FCC: "自訂義函式庫",
  FE_45A_SD_NAME_FCG: "程式碼腳本",
  FE_45A_SD_NAME_FCGC: "客戶端程式碼腳本",
  FE_45A_SD_NAME_OTHER: "其他腳本",
  FE_45A_SD_SCRIPTNAME_CURRENT: "現在名稱",
  FE_45A_SD_SCRIPTNAME_HOLDER: "請輸入名稱",
  FE_45A_SD_SCRIPTNAME_TYPE: "類型",
  FE_45A_SD_STATICTIPS: "靜態腳本將自動添加到全局實體中並在運行時執行。",
  FE_45A_SD_STATIC_FILE: "靜態腳本",
  FE_45A_XXJ_ERRORCODE: "狀態代碼",
  FE_45A_XXJ_OVERLIMIT: "超過限制",
  FE_45A_XXJ_PARAMERROR: "參數錯誤",
  FE_45A_XXJ_TIMEOUT: "超時",
  FE_45A_XYL_FEBRUSHGRASS: "草數量上限",
  FE_45A_XYL_FEBRUSHROCK: "石頭數量上限",
  FE_45A_XYL_FEBRUSHSHRUB: "灌木數量上限",
  FE_45A_XYL_FEBRUSHTREE: "樹數量上限",
  FE_45A_XYL_FEBRUSHWARN: "無法同時編輯引用相同資源的地形",
  FE_45A_XYL_FETIPS1: "退出雕塑",
  FE_45A_XYL_FETIPS2: "縮小",
  FE_45A_XYL_FETIPS3: "放大",
  FE_45A_XYL_FETIPS4: "植被筆刷",
  FE_45A_XYL_FETIPS5: "已達到植被筆刷的限制",
  FE_45A_XYL_FETIPS6: "地形檔案",
  FE_45_HJ_PLATFORM_ADDFRIEND: "添加好友按鈕",
  FE_45_HJ_PLATFORM_BRIGHT: "按鈕樣式一",
  FE_45_HJ_PLATFORM_DARK: "按鈕樣式 2",
  FE_45_HJ_PLATFORM_PERMISSIONTIPS1: "由於您的帳戶沒有使用部分 UI 部件的權限，您將無法發布該專案。",
  FE_45_HJ_PLATFORM_REPORT: "檢舉按鈕",
  FE_45_HJ_PLATFORM_SEETING: "好友申請通知類型",
  FE_45_HJ_PLATFORM_SEETINGMESSAGE: "訊息通知",
  FE_45_HJ_PLATFORM_SEETINGTYPE: "是否彈出好友申請視窗",
  FE_45_HJ_PLATFORM_SEETINGWINDOW: "局內彈跳視窗通知‵",
  FE_45_HJ_PLATFORM_WIDGET: "Free Fire 功能控件",
  FE_45_HZY_FOURFRIENDS: "四位朋友",
  FE_45_HZY_FOURFRIENDS_D: "以第一人稱視角探索身臨其境的解謎遊戲！",
  FE_45_HZY_SCENE_OPERATE_TIP14: "沿X/Y/Z軸旋轉",
  FE_45_HZY_SCENE_OPERATE_TIP15: "繪製",
  FE_45_SD_AIS_AI: "AI搜尋",
  FE_45_SD_AIS_BTN: "使用AI搜尋",
  FE_45_SD_AIS_DEF: "預設搜尋",
  FE_45_SD_AIS_NORESULT: "AI搜尋未找到新結果",
  FE_45_SD_BASICTEMPLATE: "基礎模板",
  FE_45_SD_BERMUDA: "百慕達",
  FE_45_SD_CREATE: "創建",
  FE_45_SD_DESC_BERMUDA: "沒有 API 並使用默認地形的項目：百慕達。",
  FE_45_SD_DESC_BLADEBALL: "解鎖不同的能力並贏得比賽！",
  FE_45_SD_DESC_BOMBER: "放置炸彈攻擊敵人，但小心不要炸到自己",
  FE_45_SD_DESC_BOMBERSCRIPT: "一個範例腳本專案。放置炸彈攻擊敵人，但小心不要傷到自己。",
  FE_45_SD_DESC_EMPTYMAP: "沒有 API 並使用默認地形的項目：空地圖。",
  FE_45_SD_DESC_GUNKING: "使用各種武器消滅最多的敵人。",
  FE_45_SD_DESC_ISLANDL: "沒有 API 並使用默認地形的項目：冠軍島（50*50）。",
  FE_45_SD_DESC_ISLANDS: "沒有 API 並使用默認地形的項目：出生島（100*100）。",
  FE_45_SD_DESC_PVE: "獲得強大的效果並消滅最終BOSS！",
  FE_45_SD_DESC_SNIPER: "從這裡活著出去，成為最佳狙擊手！",
  FE_45_SD_EMPTYMAP: "空地圖",
  FE_45_SD_GAMEPLAYTEMPLATE: "玩法模板",
  FE_45_SD_ISLAND_L: "初始島",
  FE_45_SD_ISLAND_S: "冠軍島",
  FE_45_SD_NEWPROJECT: "專案管理",
  FE_45_SD_PROJECTLOST: "該專案的本地文件不存在",
  FE_45_SD_REGIST_DYNAMIC: "動態呼叫語法",
  FE_45_SD_REGIST_LOST: "無法找到在 {0} 位置，資產類型為 {1} 的文件，該資產腳本名為 {2}",
  FE_45_SD_REGIST_STATIC: "靜態呼叫語法",
  FE_45_SD_SPECIALTEMPLATE: "特殊模板",
  FE_45_SD_SPRITE_RES: "精靈檔案",
  FE_45_SD_TEXTURE_RES: "紋理檔案",
  FE_45_SD_TIMEOFMODIFY: "修改時間",
  FE_45_SD_VERSION: "版本",
  FE_45_TYC_CCT_COLLISION_THRESHOLD: "角色控制器碰撞閾值",
  FE_45_TYC_CCT_COLLISION_THRESHOLD_ANNOT: "當角色控制器接觸剛體時，設定碰撞閾值。如果未達到閾值，控制器將輕輕推動剛體，而不會造成硬碰撞。",
  FE_45_TYC_CCT_CUSTOMIZE_PUSH: "啟用自訂推力設置",
  FE_45_TYC_CCT_CUSTOMIZE_PUSH_ANNOT: "自定義角色控制器對剛體施加的推力",
  FE_45_TYC_CCT_ORIENTATION2GRAVITY: "方向跟隨重力",
  FE_45_TYC_CCT_ORIENTATION2GRAVITY_ANNOT: "允許角色控制器自動調整其方向以符合重力方向",
  FE_45_TYC_CCT_PUSH_FORCE: "自定義推力力量",
  FE_45_TYC_CCT_PUSH_FORCE_ANNOT: "角色控制器對剛體施加的推力力量",
  FE_45_TYC_COLLIDER_CONVEX: "凸形算法",
  FE_45_TYC_COLLIDER_CONVEX_ANNOT: "在碰撞計算中將此網格視為凸體",
  FE_45_TYC_COLLIDER_GEN: "生成碰撞器",
  FE_45_TYC_COLLIDER_GEN_ANNOT: "當將網格拖入場景以創建物件時，自動添加並配置碰撞器組件。",
  FE_45_TYC_COLLIDER_OPTIMIZATION: "碰撞器優化",
  FE_45_TYC_COLLIDER_OPTIMIZATION_ANNOT: "通過優化網格數據，提高碰撞的性能",
  FE_45_TYC_MESH_SCALE_FACTOR: "比例因子",
  FE_45_TYC_MESH_SCALE_FACTOR_ANNOT: "根據設定的參數調整此文件中網格的大小",
  FE_45_TYC_MIDAIR_MOVE: "在空中移動",
  FE_45_TYC_MIDAIR_MOVE_ANNOT: "允許在空中更改玩家的速度和移動方向",
  FE_45_TYC_MULTI_JUMP_HEIGHT: "跳躍高度",
  FE_45_TYC_MULTI_JUMP_HEIGHT_ANNOT: "空中多段跳躍的高度",
  FE_45_TYC_MULTI_JUMP_MAX: "最大跳躍次數",
  FE_45_TYC_MULTI_JUMP_MAX_ANNOT: "在空中允許的連續跳躍次數的最大值",
  FE_45_TYC_OPTIMIZATION_NONE: "無",
  FE_45_XXJ_DELETECUSTOMEVENT: "刪除信號 {0}",
  FE_45_XXJ_EDITCUSTOMEVENT: "編輯信號 {0}",
  FE_45_XXJ_WARNING_EDITVARTYPE: "更改類型可能會導致正在使用的區塊和 API 出現錯誤。",
  FE_45_XXJ_WORKFLOWLOGIC: "過程中預定義的邏輯",
  FE_45_XXJ_WORKFLOWLOGICENABLE: "啟用過程中的預定義邏輯",
  FE_45_XXJ_WORKFLOWLOGICENABLE_D: "在回合開始時啟用預先定義的邏輯，例如玩家的無敵效果和回合開始的音效。",
  FE_45_XYL_STOREBAN_1: "功能尚未開放。敬請期待！",
  FE_45_XYL_STOREBAN_2: "發生錯誤。該功能尚未開放。",
  FE_46A_HZY_PROJECT_EMCTIP: "這是個在線上的專案，使用前請先儲存至本機",
  FE_46A_HZY_REVIEW_PUBLISH: "檢測到敏感字眼。查看錯誤訊息以了解詳情。",
  FE_46_ERRORCODE_UNKONW_PROP: "{1} 擁有未知屬性：{0}",
  FE_46_HJ_ERRORCODE_CUSTOMTYPE: "自訂類型 {0} 錯誤",
  FE_46_HJ_ERRORCODE_CUSTOMTYPE_LOOP: "自訂組件需要循環",
  FE_46_HJ_ERRORCODE_FUNCTION_SIGNATURE: "函數簽章不符：{0}",
  FE_46_HJ_ERRORCODE_GFILEE: "{1} 的 GFile 無效：{0}",
  FE_46_HJ_ERRORCODE_IMAGE: "圖像文件已恢復為紋理，因為類型未知：{0}",
  FE_46_HJ_ERRORCODE_MISSGRAPH: "區塊腳本遺失",
  FE_46_HJ_ERRORCODE_NOTENTITY: "無法將 {0} 類型轉換為實體",
  FE_46_HJ_ERRORCODE_NOTENUM: "無法將型別'{0}'轉換為型別 'Enum'",
  FE_46_HJ_ERRORCODE_NOTFIND_FILE: "找不到檔案：{0}",
  FE_46_HJ_ERRORCODE_NOTFIND_GRAPH: "無法找到區塊腳本 {0}",
  FE_46_HJ_ERRORCODE_NOTVALUE: "值不是{0}",
  FE_46_HJ_ERRORCODE_NOTVALUE_P: "{1} 的值不是 {0}",
  FE_46_HJ_ERRORCODE_NOTVALUE_RANGE: "值 ({0}) 不在範圍 [{1}, {2}) 內，類型為 {3}",
  FE_46_HJ_ERRORCODE_NULLPARAM: "參數為空值",
  FE_46_HJ_ERRORCODE_REFEREDFILE: "引用的檔案無效的項目位元組檔案: {0}",
  FE_46_HJ_ERRORCODE_TYPEABSTRACT: "類型'{0}'是虛擬類型",
  FE_46_HJ_ERRORCODE_TYPE_ERROR: "無法將類型 '{0}' 轉換為 '未知類型'",
  FE_46_HJ_ERRORCODE_TYPE_ERROR_P: "無法將類型'{1}'轉換為類型 '{0}'",
  FE_46_HJ_ERRORCODE_UNKNOW_API1: "配置中未定義 API：{0}",
  FE_46_HJ_ERRORCODE_UNKNOW_API2: "未定義API：{0}",
  FE_46_HJ_ERRORCODE_UNKNOW_APIID: "API ID 未定義：{0}",
  FE_46_HJ_ERRORCODE_UNKNOW_ENTITY_P: "{1}的未知實體：{0}",
  FE_46_HJ_ERRORCODE_UNKNOW_EVENT: "自定義事件未定義",
  FE_46_HJ_ERRORCODE_UNKNOW_EVENTID: "自定義事件 {0} 未定義",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPE: "未知類型：{0}",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPEASSIGNING: "屬性未定義",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPE_P: "未知的 {1} 類型：{0}",
  FE_46_HJ_ERRORCODE_UNKNOW_VALUE_P: "{1} 的未知值：{0}",
  FE_46_HJ_ERRORCODE_UNKONW_ACTION: "圖元'{0}'未定義",
  FE_46_HJ_ERRORCODE_UNKONW_ENTITY: "參數具有未知類型",
  FE_46_HJ_ERRORCODE_UNKONW_ENUM: "枚舉項目 {0} 在枚舉類型 {1} 中未定義",
  FE_46_HJ_ERRORCODE_UNKONW_ENUM_P: "枚舉項 {0} 在枚舉類型 {1} 中無效",
  FE_46_HJ_ERRORCODE_UNKONW_FUNCTION: "區塊 {0} 是未知的",
  FE_46_HJ_ERRORCODE_UNKONW_FUNCTION2: "自訂函數/操作的未知定義：{0}",
  FE_46_HJ_ERRORCODE_UNKONW_PROP: "屬性 {0} 在 {1} 類型中未定義",
  FE_46_HJ_ERRORCODE_UNKONW_PROPID: "屬性 '{0}' 位於類型 '{1}' 中非法",
  FE_46_HJ_ERRORCODE_UNKONW_PROP_P: "屬性'{0}'未定義",
  FE_46_HJ_ERRORCODE_UNKONW_VAR: "指標'{0}'未定義",
  FE_46_HJ_ERRORCODE_UNKONW_VARLOCAL: "臨時指標'{0}'未定義",
  FE_46_HJ_ERRORCODE_UNSPPPORTFILE: "文件導出不支持，類型 {1}：{0}",
  FE_46_HJ_ERRORCODE_UPSUPPORTTYPE: "{1} 的數值類型不支援：{0}",
  FE_46_HZY_SHOW_INASSETS: "顯示於資產中",
  FE_46_HZY_SOUNDTYPE_CUSTOM: "自定義",
  FE_46_LJY_NUMTOSTRING5: "1000 分隔符號 (,)",
  FE_46_SD_BUTTON_DOUBLECLICK: "雙擊",
  FE_46_SD_NODELETE_WHEN_OPENED: "待刪除文件已被打開，刪除將關閉文件頁籤",
  FE_46_SD_NODELETE_WHEN_OPENED_2: "待刪除文件已打開，刪除將關閉文件頁簽，且無法撤銷刪除操作",
  FE_46_SD_NODELETE_WHEN_OPENED_CONSOLE: "您要刪除的檔案已開啟：{0}",
  FE_46_SD_RESTORE_FILE_MISS: "{0} 的復原檔案未找到，無法復原",
  "FE_46_SD_RESTORE_FILE_NO_PERMISSION ": "{0} 無法寫入",
  "FE_46_SD_RESTORE_FILE_OVERRIDE ": "{0} 已存在，將被復原檔案覆蓋",
  "FE_46_SD_RESTORE_FILE_PATH_ERROR ": "{0} 非本專案資產文件，不進行復原",
  FE_46_SD_UNDOREDOING: "執行操作中...",
  "FE_46_SD_UNREDO_RENAME_NOT_FIND ": "{0} 未找到，不可移動或重新命名",
  FE_46_SD_UNSELECTCALLBACK: "選擇回調",
  FE_46_TYC_CUSTOM_UI_DEPTH: "渲染深度",
  FE_46_TYC_CUSTOM_UI_DEPTH_DESC: "此屬性決定了自定義 UI 的繪製順序及其控件的渲染順序。與其他渲染深度的衝突可能會導致渲染順序干擾。我們建議為可能干擾的自定義 UI 保留一個合理的深度區間。",
  FE_46_TYC_ENABLEAOIFILTER: "打開AOI濾鏡",
  FE_46_TYC_ENABLEAOIFILTER_DESC: "如果關閉設置，所有物件將保持同步；如果開啟設置，遠處的物件將被忽略，以優化資料使用。",
  FE_46_TYC_NO_COLLIDERS_TIPS: "未添加碰撞器",
  FE_46_TYC_PANEL_DEPTH: "渲染深度",
  FE_46_TYC_PANEL_DEPTH_CONFLICT: "渲染深度衝突於：",
  FE_46_TYC_PANEL_DEPTH_DESC: "此屬性決定了此自定義 UI 的繪製順序。如果與其他渲染深度發生衝突，可能會導致渲染順序干擾。您不能直接更改此屬性，因為它基於自定義 UI 的渲染深度。",
  FE_46_TYC_PANEL_DEPTH_TOTAL: "總渲染深度",
  FE_46_TYC_PANEL_DEPTH_TOTAL_DESC: "此自定義 UI 及其控件所處的渲染深度。如果與其他渲染深度衝突，可能會導致渲染順序干擾。",
  FE_46_XXJ_ADDOERSONA: "增加角色",
  FE_46_XXJ_DYNAMICRES: "正在載入動態資源",
  FE_46_XXJ_FORMAT: "格式",
  FE_46_XXJ_FORMATVALUE: "數位",
  FE_46_XXJ_MUSTRES: "必要資源",
  FE_46_XXJ_NOFOUND: "無法找到相應角色",
  FE_46_XXJ_NOPERMISSIONTOUSE: "你沒有權限使用",
  FE_46_XXJ_NUMTOFLOAT: "數字轉換為浮點數",
  FE_46_XXJ_NUMTOFLOAT1: "保留小數位數",
  FE_46_XXJ_NUMTOFLOAT2: "常規",
  FE_46_XXJ_NUMTOFLOAT3: "科學記號",
  FE_46_XXJ_NUMTOFLOAT4: "百分比",
  FE_46_XXJ_PERSONALIMIT: "角色數量已達限制，無法增加更多角色",
  FE_46_XXJ_PLAYERDIAMOND: "玩家擁有的鑽石数量",
  FE_46_XXJ_PLAYERPREMIUM: "啟用玩家會員",
  FE_46_XXJ_PLEASEENTER: "輸入角色ID",
  FE_46_XXJ_PREMIUMSETTING: "會員設定",
  FE_46_XXJ_RESCOLLECT: "資源蒐集",
  FE_46_XXJ_SEARCH: "搜尋",
  FE_46_XXJ_WARNINGMATCHRESULT: "局後結算警告：先前局後結算邏輯無法使用，建議使用自定義局後結算，這將在賽後將玩家送回大廳，若有需要，你可以自定義其介面，或使用相關模板。",
  FE_46_XYL_FINDINCLASSIFICATION: "顯示於分類中",
  FE_46_XYL_FINDUGCDOCS: "查看使用說明",
  FE_46_XYL_NAVMESHSHOW: "顯示場景內預覽",
  FE_47A_HZY_BOMBERSCRIPT_LEVEL: "中等 - 轟炸(腳本)",
  FE_47A_HZY_BOMBER_LEVEL: "中等 - 轟炸",
  FE_47A_HZY_SNIPER_LEVEL: "進階 - 狙擊手",
  FE_47A_MX_CUSTOMEVENT_TIP: "對應區塊將失效，你確定嗎？",
  FE_47_GT_USERMANUAL: "使用手冊",
  FE_47_HJ_FOG_DENSITY: "霧氣密度",
  FE_47_HJ_FOG_ENABLEFOG: "啟用霧氣",
  FE_47_HJ_FOG_ENDDISTANCE: "霧氣結束距離",
  FE_47_HJ_FOG_EXPONENTIAL: "指數",
  FE_47_HJ_FOG_EXPONENTIALSQUARED: "指數平方",
  FE_47_HJ_FOG_FOGMODE: "霧氣模式",
  FE_47_HJ_FOG_LINEAR: "線性",
  FE_47_HJ_FOG_STARTDISTANCE: "霧氣開始距離",
  FE_47_HL_FREE_VIEW: "玩家視角/自由視角",
  FE_47_HZY_BLOCK_CATEGORY: "分類",
  FE_47_HZY_BLOCK_CUSTOMVARIABLE: "自訂變數",
  FE_47_HZY_BLOCK_DESC: "描述",
  FE_47_HZY_BLOCK_ID: "區塊ID",
  FE_47_HZY_BLOCK_INPUT: "輸入",
  FE_47_HZY_BLOCK_MODULE: "對應模組",
  FE_47_HZY_BLOCK_NAME: "區塊名稱",
  FE_47_HZY_BLOCK_OUTPUT: "輸出",
  FE_47_HZY_BLOCK_OWNERTYPE: "可觸發",
  FE_47_HZY_BLOCK_PARADESC: "參數資訊",
  FE_47_HZY_BLOCK_RETURNDESC: "回傳值說明",
  FE_47_HZY_BLOCK_RETURNTYPE: "回傳類型",
  FE_47_HZY_CLIENTNUM_D: "設定客戶端數量",
  FE_47_HZY_CUSTOMSTORE: "自訂商店",
  FE_47_HZY_CUSTOMSTORE_ADDCUSTOM: "添加自訂物品",
  FE_47_HZY_CUSTOMSTORE_ADDITEM: "拖曳此處來新增物品",
  FE_47_HZY_CUSTOMSTORE_ADDSHELVE: "創建貨架",
  FE_47_HZY_CUSTOMSTORE_COVER: "封面圖片",
  FE_47_HZY_CUSTOMSTORE_CURRENCY: "貨幣類型",
  FE_47_HZY_CUSTOMSTORE_DELETETIP1: "要永久刪除此自定義商店嗎？",
  FE_47_HZY_CUSTOMSTORE_DELETETIP2: "清除物品並刪除貨架？",
  FE_47_HZY_CUSTOMSTORE_DELETETIP3: "一旦刪除，自訂商店無法復原，確定要刪除嗎？",
  FE_47_HZY_CUSTOMSTORE_DOWN: "向下一層",
  FE_47_HZY_CUSTOMSTORE_EDIT: "編輯自訂商店",
  FE_47_HZY_CUSTOMSTORE_ENTITY: "商店",
  FE_47_HZY_CUSTOMSTORE_FFITEM: "預設物品",
  FE_47_HZY_CUSTOMSTORE_INFO: "物品資訊",
  FE_47_HZY_CUSTOMSTORE_LIMIT: "上限",
  FE_47_HZY_CUSTOMSTORE_LIMITNUM: "購買上限",
  FE_47_HZY_CUSTOMSTORE_PRODUCTCONTENT: "物品內容",
  FE_47_HZY_CUSTOMSTORE_PRODUCTNAME: "物品名稱",
  FE_47_HZY_CUSTOMSTORE_PROP: "物品屬性",
  FE_47_HZY_CUSTOMSTORE_SHELVES: "貨架",
  FE_47_HZY_CUSTOMSTORE_UP: "向上一層",
  FE_47_HZY_MODULE_CUSTOMRESULT_D: "勾選此項目將不會顯示預設的局後結算頁面",
  FE_47_HZY_MODULE_D: "管理模組及設置模組相關參數",
  FE_47_HZY_MODULE_LOGICFRAME_D: "勾選此項目以使用低邏輯幀模式 (30 > 15)",
  FE_47_HZY_MODULE_LOOTSWITCH_D: "勾選此項目可為百慕達等大型地圖啟用經典模式地面上戰利品",
  FE_47_HZY_MODULE_NAVMESH_D: "勾選此項目並啟用動態導航網格，以生成類似於碰撞體的尋路障礙物，這個障礙物將會和物件同時建立或刪除",
  FE_47_HZY_MODULE_NFPP_D: "勾選此項目使用第一人稱資源",
  FE_47_HZY_SCENESWITCH_TIP: "百慕達地圖不支持場景內的伺服器加載區域",
  FE_47_HZY_SCENE_ALIGNMENTLOCK_D: "解鎖時，設定x/y/z軸固定移動距離",
  FE_47_HZY_SCENE_ALIGNMENTRESET_D: "重設為預設值",
  FE_47_HZY_SCENE_ALIGNMENTSET_D: "使用同步功能以固定距離來旋轉、縮放或移動場景物件",
  FE_47_HZY_SERVERSLOAD_BERMUDA: "百慕達地圖不支持啟用場景內的伺服器加載區域",
  FE_47_HZY_TERRAIN_DOWN_D: "降低這個區域的地形高度",
  FE_47_HZY_TERRAIN_FLAT_D: "該區域使用相同地形高度",
  FE_47_HZY_TERRAIN_SMOOTH_D: "對附近的區域進行平均化處理，柔化景觀並減少突然變化的出現",
  FE_47_HZY_TERRAIN_TEXTURE_CHANGE_D: "用新紋理取代選取的紋理",
  FE_47_HZY_TERRAIN_TEXTURE_COVERALL_D: "檢查以繪製選取的紋理並覆蓋至整個地形上",
  FE_47_HZY_TERRAIN_TEXTURE_DEL_D: "刪除選擇的紋理",
  FE_47_HZY_TERRAIN_TEXTURE_INPUT_D: "導入新紋理",
  FE_47_HZY_TERRAIN_TEXTURE_TIP: "設定要繪製的紋理",
  FE_47_HZY_TERRAIN_UP_D: "提升這個區域的地形高度",
  FE_47_HZY_UI_3D_D: "顯示Prefab等3D內容的控件",
  FE_47_HZY_UI_AVATAR_D: "顯示玩家頭像的控件",
  FE_47_HZY_UI_BUTTON_D: "按下時觸發事件邏輯的控件",
  FE_47_HZY_UI_EMPTY_D: "此控件不可見，可用於組織控件父子級關係",
  FE_47_HZY_UI_JOYSTICK_D: "模擬搖桿並對拖曳做出反應的控件(僅限客戶端)",
  FE_47_HZY_UI_LAYOUT_D: "自動排列其子控件的控件",
  FE_47_HZY_UI_PANEL_D: "包含其他子控件的面板",
  FE_47_HZY_UI_PICTURE_D: "顯示圖片的控件",
  FE_47_HZY_UI_PLATFORM_D: "支持新增好友和檢舉功能的面板",
  FE_47_HZY_UI_SCROLLVIEW_D: "在此面板的子控件可滾動查看",
  FE_47_HZY_UI_TEXTBOX_D: "用以取得用戶文字輸入的控件",
  FE_47_HZY_UI_TEXTURE_D: "用於顯示紋理的控件",
  FE_47_HZY_UI_TEXT_D: "用於顯示純文字的控件",
  FE_47_HZY_UI_TOGGLE_D: "類似按鈕的控件，按下時可在兩種狀態間切換",
  FE_47_HZY_UI_TOUCHPAD_D: "對觸控/拖曳輸入做出反應的控件(僅限客戶端)",
  FE_47_JH_WS_ROOMMINPLAYERCNT: "最低玩家數",
  FE_47_TYC_ANIM_BLEND_TIME: "混合淡入時長",
  FE_47_TYC_AOI_FILTER_ALWAYS: "始終過濾",
  FE_47_TYC_AOI_FILTER_AUTO: "自動",
  FE_47_TYC_AOI_FILTER_D: "確定物件的濾鏡設定。 自動：根據物件是否為靜態而開啟或關閉濾鏡。 不過濾：物件將始終被同步。 始終過濾：物件將始終被過濾，這表示遠處物件不會被同步。",
  FE_47_TYC_AOI_FILTER_NEVER: "不過濾",
  FE_47_TYC_AOI_FILTER_T: "AOI濾鏡",
  FE_47_TYC_CCT_ENABLED_D: "停用：使用預設的玩家角色控制器，這可能導致玩家和剛體互動時出現錯誤；啟用：使用 Craftland 角色控制器",
  FE_47_TYC_CCT_HEIGHT_D: "此角色控制器的膠囊高度，請注意，高度必須大於膠囊半徑的兩倍。",
  FE_47_TYC_CCT_RADIUS_D: "此角色控制器的膠囊半徑，請注意，膠囊的高度必須大於膠囊半徑的兩倍。",
  FE_47_TYC_GLOBAL_GRAVITY_D: "適用於所有剛體的重力",
  FE_47_TYC_HINT_COLOR_TEXTURE_RESTRICTION: "不支援內部紋理或 128*128像素的紋理",
  FE_47_TYC_PHYSICS_DEFAULT_MAT: "如果沒有設定碰撞和剛體，則預設物理紋理",
  FE_47_TYC_PHYSICS_SLEEP_THRESHOLD_D: "如果剛體的動能或重力低於這個值，將自動進入睡眠模式(以降低效能成本)。",
  FE_47_TYC_PLAYER_PHYSICS_LAYER_D: "玩家所在的物理層",
  FE_47_TYC_PTC: "粒子發射器",
  FE_47_TYC_PTC_A_ACCELERATION: "加速度",
  FE_47_TYC_PTC_A_ACCELERATION_D: "此屬性控制了粒子隨時間的加速度",
  FE_47_TYC_PTC_A_ACCELERATION_RANDOMNESS: "加速度隨機量",
  FE_47_TYC_PTC_A_ACCELERATION_RANDOMNESS_D: "加到粒子加速度的隨機量(最終加速度是在[基礎值] 到 [基礎值 + 加速度隨機量] 這段範圍內隨機選擇)",
  FE_47_TYC_PTC_A_ANGLE: "旋轉角度",
  FE_47_TYC_PTC_A_ANGLE_D: "粒子的初始旋轉角度(以隨機軸為旋轉軸心)",
  FE_47_TYC_PTC_A_ANGLE_RANDOMNESS: "旋轉角度隨機量",
  FE_47_TYC_PTC_A_ANGLE_RANDOMNESS_D: "加到粒子初始旋轉角度的隨機量(最終角度是在[基礎值] 到 [基礎值 + 角度隨機量] 這段範圍內隨機選擇)",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY: "角速度",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_D: "粒子將隨時間旋轉(以隨機軸為旋轉軸心)",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_RANDOMNESS: "角速度隨機量",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_RANDOMNESS_D: "加到粒子角速度的隨機量(最終速度是在[基礎值] 到 [基礎值 + 角速度隨機量] 這段範圍內隨機選擇)",
  FE_47_TYC_PTC_A_BOX: "立方體",
  FE_47_TYC_PTC_A_BOX_D: "從盒子底部向上發射粒子",
  FE_47_TYC_PTC_A_CIRCLE: "圓形",
  FE_47_TYC_PTC_A_CIRCLE_D: "從圓形中心向外發射粒子",
  FE_47_TYC_PTC_A_COLOR: "粒子顏色",
  FE_47_TYC_PTC_A_COLOR_D: "此屬性會影響粒子的顏色",
  FE_47_TYC_PTC_A_COLOR_OVER_LIFETIME: "生命週期顏色",
  FE_47_TYC_PTC_A_COLOR_OVER_LIFETIME_D: "粒子的顏色會隨著時間而改變",
  FE_47_TYC_PTC_A_CONE: "錐形",
  FE_47_TYC_PTC_A_CONE_D: "從錐形的底部向外發射粒子(而不是從內部)",
  FE_47_TYC_PTC_A_DAMPING: "阻尼",
  FE_47_TYC_PTC_A_DAMPING_D: "粒子速度的阻尼，阻尼值越高代表摩擦力越大",
  FE_47_TYC_PTC_A_DAMPING_RANDOMNESS: "阻尼隨機量",
  FE_47_TYC_PTC_A_DAMPING_RANDOMNESS_D: "加到粒子阻尼的隨機量(最終阻尼是在[基礎值] 到 [基礎值 + 阻尼隨機量] 這段範圍內隨機選擇)",
  FE_47_TYC_PTC_A_DURATION: "持續時間",
  FE_47_TYC_PTC_A_DURATION_D: "發射器運作一個週期的時間量",
  FE_47_TYC_PTC_A_FINAL_VALUE: "最終值",
  FE_47_TYC_PTC_A_HEMISPHERE: "半球",
  FE_47_TYC_PTC_A_HEMISPHERE_D: "從這個半球的內部和表面向外發射粒子",
  FE_47_TYC_PTC_A_INITIAL_VALUE: "初始值",
  FE_47_TYC_PTC_A_LIFETIME: "生命週期",
  FE_47_TYC_PTC_A_LIFETIME_D: "粒子存在的時間",
  FE_47_TYC_PTC_A_LIFETIME_RANDOMNESS: "生命週期隨機量",
  FE_47_TYC_PTC_A_LIFETIME_RANDOMNESS_D: "加到粒子生命週期的隨機量(最終生命週期是在[基礎值] 到 [基礎值 + 生命週期隨機量] 這段範圍內隨機選擇)",
  FE_47_TYC_PTC_A_LOOP: "循環",
  FE_47_TYC_PTC_A_LOOP_D: "啟用此屬性來允許發射器在發射後自動重播",
  FE_47_TYC_PTC_A_MATERIAL: "粒子材質",
  FE_47_TYC_PTC_A_MATERIAL_D: "適用於粒子的渲染材質",
  FE_47_TYC_PTC_A_MAX_PARTICLES: "最大粒子數量",
  FE_47_TYC_PTC_A_MAX_PARTICLES_D: "允許同時存在的最大粒子數量，如果達到限制，則不再生成新的粒子。",
  FE_47_TYC_PTC_A_MESH: "自訂網格",
  FE_47_TYC_PTC_A_MESH_D: "從任意給定網格的頂部向外發射粒子",
  FE_47_TYC_PTC_A_MODE: "發射模式",
  FE_47_TYC_PTC_A_MODE_D: "此屬性決定了粒子發射的順序",
  FE_47_TYC_PTC_A_RATE_OVER_TIME: "發射速度",
  FE_47_TYC_PTC_A_RATE_OVER_TIME_D: "發射器每秒發射的粒子數",
  FE_47_TYC_PTC_A_RENDER_MODE: "渲染模式",
  FE_47_TYC_PTC_A_RENDER_MODE_D: "決定了粒子使用哪種渲染模式",
  FE_47_TYC_PTC_A_SHAPE: "發射形狀",
  FE_47_TYC_PTC_A_SHAPE_D: "此屬性決定了發射的起始位置和方向，每個形狀可能包含不同選項",
  FE_47_TYC_PTC_A_SIMULATION_SPACE: "模擬座標",
  FE_47_TYC_PTC_A_SIMULATION_SPACE_D: "此屬性決定了粒子移動時所使用的座標系統",
  FE_47_TYC_PTC_A_SIMULATION_SPEED: "模擬速度",
  FE_47_TYC_PTC_A_SIMULATION_SPEED_D: "調整粒子發射器和粒子的整體速度",
  FE_47_TYC_PTC_A_SIZE: "大小",
  FE_47_TYC_PTC_A_SIZE_D: "粒子的初始縮放",
  FE_47_TYC_PTC_A_SIZE_RANDOMNESS: "大小隨機量",
  FE_47_TYC_PTC_A_SIZE_RANDOMNESS_D: "加到粒子初始大小的隨機量(最終大小是在[基礎值] 到 [基礎值 + 大小隨機量] 這段範圍內隨機選擇)",
  FE_47_TYC_PTC_A_SORT_MODE: "排序類型",
  FE_47_TYC_PTC_A_SORT_MODE_D: "此屬性決定了如何計算粒子渲染順序",
  FE_47_TYC_PTC_A_SPHERE: "球體",
  FE_47_TYC_PTC_A_SPHERE_D: "從該球體的內部和表面向外發射粒子",
  FE_47_TYC_PTC_A_START_SPEED: "啟動速度",
  FE_47_TYC_PTC_A_START_SPEED_D: "粒子朝設定方向發射的初始速度",
  FE_47_TYC_PTC_A_START_SPEED_RANDOMNESS: "啟動速度隨機量",
  FE_47_TYC_PTC_A_START_SPEED_RANDOMNESS_D: "加到粒子初始速度的隨機量(最終速度是在[基礎值] 到 [基礎值 + 速度隨機量] 這段範圍內隨機選擇)",
  FE_47_TYC_PTC_A_TEXTURE: "顏色紋理",
  FE_47_TYC_PTC_A_TEXTURE_D: "該紋理決定了粒子的顏色，從相應位置發射的粒子會依據此處的顏色而變色",
  FE_47_TYC_PTC_A_TRANSFORM: "發射形狀變換",
  FE_47_TYC_PTC_A_TRANSFORM_D: "此屬性僅適用於發射形狀，不會影響粒子",
  FE_47_TYC_PTC_A_VELOCITY: "速度",
  FE_47_TYC_PTC_A_VELOCITY_D: "初始速度",
  FE_47_TYC_PTC_A_VELOCITY_RANDOMNESS: "速度隨機量",
  FE_47_TYC_PTC_A_VELOCITY_RANDOMNESS_D: "加到粒子初始速率的隨機量(最終值是在[基礎值] 到 [基礎值 + 速率隨機量] 這段範圍內隨機選擇)",
  FE_47_TYC_PTC_BASIC: "基礎",
  FE_47_TYC_PTC_ENUM_BILLBOARD: "面向攝影機",
  FE_47_TYC_PTC_ENUM_BY_DIST: "按照距離",
  FE_47_TYC_PTC_ENUM_GLOBAL: "世界空間",
  FE_47_TYC_PTC_ENUM_LOCAL: "本地空間",
  FE_47_TYC_PTC_ENUM_LOOP: "循環",
  FE_47_TYC_PTC_ENUM_OLDEST_IN_FRONT: "從舊到新",
  FE_47_TYC_PTC_ENUM_PING_PONG: "往返",
  FE_47_TYC_PTC_ENUM_RANDOM: "隨機",
  FE_47_TYC_PTC_ENUM_YOUNGEST_IN_FRONT: "從新到舊",
  FE_47_TYC_PTC_PARA: "粒子參數",
  FE_47_TYC_PTC_PROPERTY_FILE: "粒子屬性",
  FE_47_TYC_PTC_PROPERTY_FILE_D: "粒子屬性檔案描述粒子和發射器的行為，當檔案在運行時無法更改其屬性，但可以切換成不同屬性檔案",
  FE_47_TYC_PTC_RENDERING: "渲染",
  FE_47_TYC_PTC_SHAPE: "形狀",
  FE_47_TYC_SHD_BLENDMODE: "混合模式",
  FE_47_TYC_SHD_COLOR_CORRECTION: "色彩校正",
  FE_47_TYC_SHD_CULL_BACK: "背面剔除",
  FE_47_TYC_SHD_CULL_FRONT: "正面剔除",
  FE_47_TYC_SHD_MAIN_ROTATION: "主旋轉",
  FE_47_TYC_SHD_MASK: "遮罩",
  FE_47_TYC_SHD_ON: "啟用",
  FE_47_TYC_SHD_Z_TEST: "深度測試",
  FE_47_TYC_SHD_Z_WRITE: "深度寫入",
  FE_47_XXJ_ACCOUNTNOPERMISSION: "你的帳號不被允許使用角色",
  FE_47_XXJ_AUTOCLEAR: "對戰結束後自動清除",
  FE_47_XXJ_IMPORTED: "此角色已存在",
  FE_47_XXJ_LOGINTIMEOUT: "會話已過期，請重新登入",
  FE_47_XXJ_MEMORYTYPE: "記憶體類型",
  FE_47_XXJ_NOCONECT: "網路錯誤",
  FE_47_XXJ_NOPERMISSION: "不允許使用此角色",
  FE_47_XXJ_NOTAUTOCLEAR: "關閉自動清除",
  FE_47_XXJ_PERSONAIDSEARCH: "輸入角色ID來搜尋",
  FE_47_XXJ_PERSONAOFFLINE: "此角色不再可用",
  FE_47_XXJ_PERSONATOOTIP: "複製在角色中心創建的角色ID，貼到此處匯入角色",
  FE_47_XXJ_SELECTOBSERVOR: "選擇觀察者",
  FE_47_XYL_ASSETSTORE_TYPE: "資源商店分類",
  FE_47_XYL_IMAPGEUPDATEFAIL: "不支持此圖片的檔案類型",
  FE_47_XYL_PROJECTTEMPLATE: "專案模板",
  FE_47_XYL_SHOPSEARCHCOUNT: "共{0}個搜索結果",
  FE_47_XYL_SHOPSELECTTYPE: "選擇分類",
  FE_47_XYL_SHOPTAGS: "標籤",
  FE_47_XYL_SHOPTYPENONEERROR: "商店類型不能為空白",
  FE_47_XYL_SHOP_CLASSNEWEST: "從新到舊",
  FE_47_XYL_SHOP_CLASSOLDEST: "從舊到新",
  FE_47_XYL_SHOP_ENTERTOADD: "按Enter鍵創建標籤",
  FE_47_XYL_SHOP_TAGLIMITED: "標籤上限",
  FE_47_XYL_SHOP_TAGRECOMMEND: "推薦標籤",
  FE_47_XYL_STORE2DASSET: "2D 資源",
  FE_47_XYL_STORE3ASSET: "3D 資源",
  FE_47_ZCS_EDITOR_EXIT_REMINDER: "專案未保存",
  FE_47_ZCS_EDITOR_FILTER_NOTICE: "搜索時無法貼上",
  FE_48A_HZY_CUSTOMRES_ADDTIP: "你沒有權限使用這個自定義資產，使用這個資源可能導致發布失敗。",
  FE_48A_HZY_CUSTOMRES_CONSOLETIP: "你沒有權限使用這個自定義資產，請替換或刪除它。",
  FE_48A_HZY_SAVEFAIL_TIP1: "儲存失敗",
  FE_48A_HZY_SAVEFAIL_TIP2: "下列檔案可能是唯讀的，請調整檔案屬性並再次儲存",
  FE_48A_HZY_SAVEFAIL_TIP3: "這個檔案可能是唯讀的，請調整檔案屬性並再次儲存",
  FE_48A_XXJ_LOOPWARNIG: "該片段不會生效，因為前一個片段類型設定為永遠循環",
  FE_48A_XXJ_UNSELECT: "取消選擇",
  FE_48A_XYL_NAVMESHSWITCH: "啟用離線靜態導航網格",
  FE_48A_ZCS_EDITOR_SELECTED_NOTICE: "已選擇",
  FE_48_HL_REVIEW_MEANNING: "在{0}中偵測到敏感訊息：{1}",
  FE_48_HZY_COSTLIMIT_CONSOLETIPS: "超過最大資源數：{0}，請刪除一些資源",
  FE_48_HZY_COSTLIMIT_TIPS1: "太多場景資源可能導致發布失敗，請適量添加",
  FE_48_HZY_COSTLIMIT_TIPS2: "由於場景:{0}中的資源過多導致發布失敗，請確認錯誤詳情並刪除一些資源",
  FE_48_HZY_DEFINEDPATH: "定義路徑",
  FE_48_HZY_ECA_TIP_ONLY_SCENE_SELECT: "只能選擇場景中的物件",
  FE_48_HZY_EDITCUSTOMEVENT: "編輯信號",
  FE_48_HZY_FUNCTIONNAME: "函數名稱",
  FE_48_HZY_GETEXFUNCTION: "取得外部函數",
  FE_48_HZY_GETEXVARIABLE: "取得外部變數",
  FE_48_HZY_GETVARIABLE: "取得變數",
  FE_48_HZY_RECEIVEEVENT: "接收信號",
  FE_48_HZY_SELECTENTITY: "發送實體",
  FE_48_HZY_SENDEVENT: "發射信號",
  FE_48_HZY_SETEXVARIABLE: "設定外部變數",
  FE_48_SD_ASSET_REGIST: "註冊資產",
  FE_48_SD_QUICKREGIST: "快速註冊",
  FE_48_TYC_CONVEX_WARNING_RIGIDBODY: "此碰撞器形狀包含非凸網格，因此無法作為動態或運動剛體使用。請使用凸網格或將其拆分為多個較簡單的碰撞器。",
  FE_48_TYC_CONVEX_WARNING_TRIGGER: "此碰撞器形狀包含非凸網格，因此無法設置為觸發器。請使用凸網格或其他類型的碰撞器形狀。",
  FE_48_TYC_SPECTATOR_FF: "Free Fire",
  FE_48_TYC_SPECTATOR_FF_RULE: "與 Free Fire 相同",
  FE_48_TYC_SPECTATOR_TYPE: "觀戰類型",
  FE_48_TYC_SPECTATOR_UGC: "Craftland 編輯器",
  "FE_48_TYC_UI_ADAPT_SCREEN ": "適配螢幕",
  FE_48_TYC_UI_PENETRATABLE: "透傳",
  FE_48_TYC_UI_PENETRATABLE_D: "若啟用，此控件將不會阻止底層小控件的觸發事件",
  FE_48_XXJ_ADDBEHINDWAYPOINT: "插入路徑點在後",
  FE_48_XXJ_ADDBODYPARTTRACK: "添加身體部位追蹤",
  FE_48_XXJ_ADDEVENT: "添加事件",
  FE_48_XXJ_ADDFRONTWAYPOINT: "添加路徑點在前",
  FE_48_XXJ_ADDITIVE: "添加",
  FE_48_XXJ_ADDWAYPOINT: "添加路徑點",
  FE_48_XXJ_BASETRAK: "基礎追蹤",
  FE_48_XXJ_BETA: "這是測試版本，可能有些bug",
  FE_48_XXJ_BODY: "身體",
  FE_48_XXJ_BODYPART: "身體部位",
  FE_48_XXJ_BODYPARTCONFIG: "身體部位配置",
  FE_48_XXJ_BODYPARTTRACK: "身體部位追蹤",
  FE_48_XXJ_BONESELECTOR: "剛體選擇器",
  FE_48_XXJ_COLLAPSEALL: "全部收起",
  FE_48_XXJ_CREATECLIP: "建立片段",
  FE_48_XXJ_DELETECURRENTWAYPOINT: "刪除路徑點",
  FE_48_XXJ_DELETEEVENT: "刪除事件",
  FE_48_XXJ_ENDTIME: "結束時間",
  FE_48_XXJ_EVENTTRACK: "事件追蹤",
  FE_48_XXJ_EXPANDALL: "全部展開",
  FE_48_XXJ_HOLD: "默認值",
  FE_48_XXJ_LOCK: "鎖定",
  FE_48_XXJ_LOOP: "循環",
  FE_48_XXJ_LOOPFOREVER: "永遠循環",
  FE_48_XXJ_MASK: "遮罩",
  FE_48_XXJ_MUTE: "靜音",
  FE_48_XXJ_NONE: "無",
  FE_48_XXJ_OVERRIDE: "覆蓋",
  FE_48_XXJ_PAUSE: "暫停",
  FE_48_XXJ_PINGPONG: "回彈",
  FE_48_XXJ_PLAY: "播放",
  FE_48_XXJ_PLAYBACKLENGHT: "播放長度",
  FE_48_XXJ_POSTEXTRA: "後外插",
  FE_48_XXJ_PREAXTRA: "前外插",
  FE_48_XXJ_PREGERTANGENTDRAG: "優先切線拖曳",
  FE_48_XXJ_REPLAY: "重播",
  FE_48_XXJ_SELECTBONES: "選擇剛體",
  FE_48_XXJ_SELECTEDBONES: "{0} 剛體選定",
  FE_48_XXJ_SELECTEDWAYPOINT: "選定路徑點",
  FE_48_XXJ_SETGAPEXTRA: "設置空白內容的外插處理",
  FE_48_XXJ_SETTOCAMERA: "設定為當前場景的相機位置",
  FE_48_XXJ_STARTTIME: "開始時間",
  FE_48_XXJ_TOGGLEALL: "全部切換",
  FE_48_XXJ_UNLOCK: "解除鎖定",
  FE_48_XXJ_UNMUTE: "解除靜音",
  FE_48_XXJ_WAYPOINTS: "路徑點",
  FE_48_XXJ_WEIGHT: "權重",
  FE_48_XYL_CUTOFF: "截止值",
  FE_48_ZCS_EDITOR_CHECK_UPDATES: "檢查更新中...",
  FE_48_ZCS_EDITOR_COMPILER_VERSION: "編譯器版本",
  FE_48_ZCS_EDITOR_COPY_PATH: "複製路徑資訊",
  FE_48_ZCS_EDITOR_DELETE_INVALID_PROJECT: "刪除失效專案",
  FE_48_ZCS_EDITOR_MANAGEMENT: "管理",
  FE_48_ZCS_EDITOR_OFFICIAL_WEBSITE: "官方網站",
  FE_48_ZCS_EDITOR_PRIVACY_POLICY: "隱私權政策",
  FE_48_ZCS_EDITOR_REFRESH_PROJECTLIST: "刷新專案列表",
  FE_48_ZCS_EDITOR_TERMS_OF_SERVICE: "服務條款",
  FE_48_ZCS_EDITOR_UPDATES_ABOUT: "更新與關於",
  FE_49_HJ_DEBUG_ERROR: "連結伺服器失敗，請稍後再試",
  FE_49_HJ_DEBUG_GAMEOVER: "對戰已結束",
  FE_49_HJ_PLAYER_SlowMove_FIST: "",
  FE_49_HJ_PLAYER_SlowMove_GUN: "",
  FE_49_HJ_PLAYER_SlowMove_PISTOL: "",
  FE_49_HZY_CONTROLLER: "播放控制器",
  FE_49_HZY_CONTROLLERATTACH: "",
  FE_49_HZY_CONTROLLER_DELETETIP: "未找到物件",
  FE_49_HZY_CONTROLLER_FRAMEMOVE: "By frame",
  FE_49_HZY_CONTROLLER_FRAMEMOVETIP: "Set whether the motion is by frame. If true: by-frame motion; if false: accumulated motion.",
  FE_49_HZY_CONTROLLER_LIFETIME: "生命週期",
  FE_49_HZY_CONTROLLER_OVERRIDETIP: "Conflicts with other motion(s): {0}",
  FE_49_HZY_CONTROLLER_PLAYABLE: "可播放項目 {0}",
  FE_49_HZY_CONTROLLER_STARTTIME: "開始延遲時間",
  FE_49_HZY_TEMPLATE_COMPLEXITY_1: "Low",
  FE_49_HZY_TEMPLATE_COMPLEXITY_2: "Medium",
  FE_49_HZY_TEMPLATE_COMPLEXITY_3: "High",
  FE_49_HZY_TEMPLATE_ECACOMPLEXITY: "ECA Complexity",
  FE_49_HZY_TEMPLATE_LEVEL1: "Easy",
  FE_49_HZY_TEMPLATE_LEVEL2: "Advanced",
  FE_49_HZY_TEMPLATE_LEVEL3: "Professional",
  FE_49_HZY_TEMPLATE_SCENECOMPLEXITY: "Scene Complexity",
  FE_49_HZY_TEMPLATE_TUTORIAL: "View Tutorial",
  FE_49_HZY_TEMPLATE_UICOMPLEXITY: "UI Complexity",
  FE_49_TYC_PHYS_FREEZE_POS_X: "Lock position - x",
  FE_49_TYC_PHYS_FREEZE_POS_Y: "Lock position - y",
  FE_49_TYC_PHYS_FREEZE_POS_Z: "Lock position - z",
  FE_49_TYC_PHYS_FREEZE_ROT_X: "Lock rotation - x",
  FE_49_TYC_PHYS_FREEZE_ROT_Y: "Lock rotation - y",
  FE_49_TYC_PHYS_FREEZE_ROT_Z: "Lock rotation - z",
  FE_49_TYC_PHYS_HINT_ANGULAR_DRAG: "將一個與物件當前角速度成正比並且方向相反的扭力作用於物件，導致物體逐漸停止旋轉。",
  FE_49_TYC_PHYS_HINT_DRAG: "將一個與物件當前線性速度成正比並且方向相反的力量作用於物件，導致物件在沒有外部力量作用下逐漸減速。",
  FE_49_TYC_PHYS_MAT_HINT_BOUNCINESS: "物理模擬中物件的彈性",
  FE_49_TYC_PHYS_MAT_HINT_BOUNCINESS_COMBINATION: `這個屬性決定了在物理模擬中兩個物件碰撞時如何計算彈性：
平均：使用兩個值的平均值。
最小值：使用兩個值中較小的那一個。
相乘：將兩個彈性值相乘。
最大值：使用兩個值中較大的那一個。
當兩個物件的設置不同時，優先順序為：平均 < 最小值 < 相乘 < 最大值。`,
  FE_49_TYC_PHYS_MAT_HINT_DYNAMIC_FRICTION: "物理模擬中物件的動摩擦值",
  FE_49_TYC_PHYS_MAT_HINT_FRICTION_COMBINATION: `這個屬性決定了在物理模擬中兩個物件碰撞時如何計算摩擦力：
平均：使用兩個摩擦值的平均值。
最小值：使用兩個摩擦值中較小的那一個。
相乘：將兩個摩擦值相乘。
最大值：使用兩個摩擦值中較大的那一個。

當兩個物件的設置不同時，優先順序為：平均 < 最小值 < 相乘 < 最大值。舉例，如果一個物件設置為「平均」，而另一個物件設置為「最大值」，則碰撞將使用最大值方法並應用較大的摩擦值，從而產生較強的摩擦效果。`,
  FE_49_TYC_PHYS_MAT_HINT_STATIC_FRICTION: "物理模擬中物件的靜摩擦值",
  FE_49_TYC_PHYS_OPTIMIZATION_MAX: "",
  FE_49_TYC_PHYS_OPTIMIZATION_MEDIUM: "",
  FE_49_TYC_PHYS_OPTIMIZATION_MIN: "",
  FE_49_TYC_PHYS_OPTIMIZATION_NONE: "",
  FE_49_TYC_SHADER_SKYBOX_ENUM_MAIN_COLOR: "使用場景的光源顏色",
  FE_49_TYC_SHADER_SKYBOX_ENUM_SUN_COLOR: "使用太陽的顏色",
  FE_49_TYC_SHADER_SKYBOX_EXPOSURE: "曝光",
  FE_49_TYC_SHADER_SKYBOX_GROUND_COLOR: "地面顏色",
  FE_49_TYC_SHADER_SKYBOX_GROUND_GRADIENT: "地面顏色漸變",
  FE_49_TYC_SHADER_SKYBOX_GROUND_HORIZON_COLOR: "地面地平線顏色",
  FE_49_TYC_SHADER_SKYBOX_ROTATION: "旋轉",
  FE_49_TYC_SHADER_SKYBOX_SKY_COLOR: "天空顏色",
  FE_49_TYC_SHADER_SKYBOX_SKY_GRADIENT: "天空顏色漸變",
  FE_49_TYC_SHADER_SKYBOX_SKY_HORIZON_COLOR: "天空地平線顏色",
  FE_49_TYC_SHADER_SKYBOX_SUN_COLOR: "太陽顏色",
  FE_49_TYC_SHADER_SKYBOX_SUN_COLOR_MODE: "太陽顏色模式",
  FE_49_TYC_SHADER_SKYBOX_SUN_SIZE: "太陽大小",
  FE_49_TYC_SHADER_SKYBOX_TEX_BACK: "背面著色器",
  FE_49_TYC_SHADER_SKYBOX_TEX_DOWN: "下方著色器",
  FE_49_TYC_SHADER_SKYBOX_TEX_FRONT: "前向著色器",
  FE_49_TYC_SHADER_SKYBOX_TEX_LEFT: "左側著色器",
  FE_49_TYC_SHADER_SKYBOX_TEX_RIGHT: "右側著色器",
  FE_49_TYC_SHADER_SKYBOX_TEX_UP: "上方著色器",
  FE_49_TYC_SHADER_SKYBOX_TINT_COLOR: "顏色",
  FE_49_TYC_SKY_CUSTOM_MATERIAL: "天空盒材質",
  FE_49_XXJ_CUSTOMEVENT: "Custom Event",
  FE_49_XXJ_EVENT: "",
  FE_49_XXJ_EVENTMGR: "Event Manager",
  FE_49_XXJ_EVENTPRAM: "",
  FE_49_XXJ_EVENTPRAM_D: "",
  FE_49_XXJ_NOEVENT: "No custom event",
  FE_49_XXJ_PERFORMANCE_1: "Choose a Performance asset to start editing",
  FE_49_XXJ_PERFORMANCE_10: "Pause",
  FE_49_XXJ_PERFORMANCE_11: "Jump to start",
  FE_49_XXJ_PERFORMANCE_12: "Jump to finish",
  FE_49_XXJ_PERFORMANCE_13: "Move forward 1 frame",
  FE_49_XXJ_PERFORMANCE_14: "Move back 1 frame",
  FE_49_XXJ_PERFORMANCE_15: "Play Range",
  FE_49_XXJ_PERFORMANCE_16: "Manage sub-tracks",
  FE_49_XXJ_PERFORMANCE_17: "Locked",
  FE_49_XXJ_PERFORMANCE_18: "Muted",
  FE_49_XXJ_PERFORMANCE_19: "Receiver",
  FE_49_XXJ_PERFORMANCE_2: "Open Asset Selector",
  FE_49_XXJ_PERFORMANCE_20: "Previewing",
  FE_49_XXJ_PERFORMANCE_21: "",
  FE_49_XXJ_PERFORMANCE_3: "Group Track",
  FE_49_XXJ_PERFORMANCE_4: "",
  FE_49_XXJ_PERFORMANCE_5: "",
  FE_49_XXJ_PERFORMANCE_6: "Auto-Calculate",
  FE_49_XXJ_PERFORMANCE_7: "Start recording",
  FE_49_XXJ_PERFORMANCE_8: "Stop recording",
  FE_49_XXJ_PERFORMANCE_9: "Start playing",
  FE_49_XXJ_RECEIVEEVENT: "On Receive Event {0}",
  FE_49_XXJ_RECEIVERTYPE: "Receiver Type",
  FE_49_XXJ_RECEIVERTYPE_D: "",
  FE_49_XXJ_SENDEVENT: "",
  FE_49_XYL_GAMEPLAYOBJECTTIPDESC: "具備玩法功能的物件",
  FE_49_ZCS_FEASSETSTORENOT_SUPPORT_ITEM: "沒有可選擇的物品",
  FE_49_ZCS_FEASSETSTORE_CLPACKAGE: "資產類型",
  FE_49_ZCS_FEASSETSTORE_CLSETTING: "Craftland 上傳設定",
  FE_49_ZCS_FEASSETSTORE_COMMON_CANTUPLOAD_ITEMBYTES: "你的專案無法作為串流媒體資產上傳",
  FE_49_ZCS_FEASSETSTORE_COST: "成本",
  FE_49_ZCS_FEASSETSTORE_CUSTOM_SELECTION: "自定義選項",
  FE_49_ZCS_FEASSETSTORE_DEFAULT_CATAGORY: "預設分類",
  FE_49_ZCS_FEASSETSTORE_DEFAULT_VALUE: "預設值",
  FE_49_ZCS_FEASSETSTORE_ENTITYTYPE: "實體類型",
  FE_49_ZCS_FEASSETSTORE_ERROR_ASSET_SELECT: "你只能在資產分類下選擇要打包的內容",
  FE_49_ZCS_FEASSETSTORE_ERROR_CANTBUILD: "尚未為資源包選擇資產",
  FE_49_ZCS_FEASSETSTORE_ERROR_NOASSET: "找不到資產",
  FE_49_ZCS_FEASSETSTORE_EXPAND_DETAIL: "展開",
  FE_49_ZCS_FEASSETSTORE_EXPORT_ALL: "全部輸出",
  FE_49_ZCS_FEASSETSTORE_FESETTING: "Craftland 編輯器上傳設定",
  FE_49_ZCS_FEASSETSTORE_HIDE_SOURCEFILE: "隱藏來源檔案",
  FE_49_ZCS_FEASSETSTORE_ITEMBYTES_ADVANCED: '您可以手動編輯 "manifest" 和 "description.ecad" 以啟用更多高級功能。',
  FE_49_ZCS_FEASSETSTORE_ITEM_CATAGORY: "項目分類",
  FE_49_ZCS_FEASSETSTORE_ITEM_DESC: "描述",
  FE_49_ZCS_FEASSETSTORE_ITEM_NAME: "項目名稱",
  FE_49_ZCS_FEASSETSTORE_MAX_VALUE: "最大值",
  FE_49_ZCS_FEASSETSTORE_MIN_VALUE: "最小值",
  FE_49_ZCS_FEASSETSTORE_NOTSELECT_PREFEB: "No prefab selected",
  FE_49_ZCS_FEASSETSTORE_SCALE: "縮放",
  FE_49_ZCS_FEASSETSTORE_SCALING_RANGEERROR: "Range error. Value should be between {0} - {1}",
  FE_49_ZCS_FEASSETSTORE_SCALING_SIZEERROR: "Size error. Please make sure the min. value is smaller than the max. value",
  FE_49_ZCS_FEASSETSTORE_SELECTION_SIZE: "選取大小",
  FE_49_ZCS_FEASSETSTORE_SELECTION_TIP: "從資源包內選擇一個物品使用",
  FE_49_ZCS_FEASSETSTORE_SELECT_PLATFORMS: "Choose the publishing platform",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_ANNO: "沒有可選擇的項目",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_COST: "總成本",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_INFO: "小項目資訊",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_INFO_TIPS: "該資產來自原始資源包，你可以個別使用它，也可以結合其他資產使用",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_SELECTALL: "全選",
  FE_49_ZCS_FEASSETSTORE_STEP_VALUE: "步進值",
  FE_49_ZCS_FEASSETSTORE_TAG_NOTICE: "Enter text to create custom tag",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_ALL: "全部",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_CL: "Craftland",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_DUAL: "雙平台",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_FE: "Craftland 編輯器",
  FE_49_ZCS_PREFABCHANGE_WARNING: "你的操作將會調整prefab的結構，但場景內的prefab不會改變，請手動更換",
  FE_OB43_TYC_HIERARCHY_HIDE_SHOW: "隱藏/顯示",
  FF_47A_HZY_QUICKMESSAGE_LEVEL: "進階 - 團隊突襲",
  OB40A_UP_DB1: "偵錯功能更新",
  OB40A_UP_DB2: "新增中途加入偵錯、中期退出遊戲偵錯以及網路連線不佳的偵錯",
  OB40A_UP_T1: "多項用戶體驗優化和 bug 修復",
  OB40A_UP_W1: "武器生成器",
  OB40A_UP_W2: "於 Inspector 設置槍械塗裝時，支援場景內刷新塗裝樣式",
  OB40_UP_DB1: "數據儲存功能更新",
  OB40_UP_DB2: `1. 「數據中心」中的「數據管理」新增搜尋、排序、編輯功能
2. 讀寫頻率擴增：
--每分鐘寫頻率 30 → 40；
--每分鐘讀頻率 50 → 60`,
  OB40_UP_O1: "其他",
  OB40_UP_O2: `1. 自訂碰撞盒可作為「觸發器」使用 
2. 支持音頻檔案以 Assetbundle 的格式輸入及使用 
3. 在流程設置中增加斷線重連開關、重新加入比賽開關、掛機檢測開關 
4. 新增一批圖元，詳情請見 UGC WIKI`,
  OB40_UP_S1: "多場景編輯功能更新",
  OB40_UP_S2: `1. 支持一場比賽中，玩家傳送到不同場景中。
2. 建議操作方式：
--使用多場景功能的專案，建議不要使用模板場景，只使用空場景。
--建議開啟自訂小地圖功能，自訂場景中的小地圖。 
--不同場景（.scene 檔案）中物件的座標建議不要重疊（Craftland Studio 中多場景 2.0 的運作方式可以理解為：伺服器將多個 .scene 檔案合併成一張大世界地圖，每個用戶端只載入一個 .scene 文件。若座標重合，涉及伺服器處理的邏輯會有問題。）`,
  OB40_UP_T1: "地形編輯功能",
  OB40_UP_T2: `1. 新增「地形」功能，可進行地形相關編輯
2. 新增植披刷樣式
3. 可編輯地形面積擴大至 150*150，支持多地形快`,
  OB40_UP_UI1: "UI 編輯器更新",
  OB40_UP_UI2: `1.在「UI編輯器」中，將原有的面板和佈局控件進行整合，保留原有的長寬和錨點錨框屬性，新增背景填充和裁切功能
2. 將原有的佈局功能遷移後進行更新，已經能正常使用
3. 新增滾動視圖控件並開放相應屬性，可以使用滾動視圖製作螢幕滾動等效果
4. 開放所有控件屬性在圖元中獲取和調用`,
  OB41A_UP_1: "新增問題反饋管道",
  OB41A_UP_1_D: "1. 點擊右上角問號標誌，即可提交您寶貴的建議",
  OB41A_UP_2: "多處用戶互動體驗優化",
  OB41_UP_1: "新增動畫狀態機 1.0",
  OB41_UP_1_D: `1. 新增動畫狀態機功能，可以為殭屍和通過 Assetbundle 輸入的 Prefab 添加狀態機
2. 狀態機為純動畫的控制器，需要通過 ECA 圖元撰寫邏輯來切換動畫狀態
3. 若當前沒有其他動畫狀態要切換或其他狀態播放完成後，都會回到閒置的動畫狀態`,
  OB41_UP_2: "UI 編輯器更新",
  OB41_UP_2_D: `1. 插值運動設置圖元目前已支援 UI 控件
2. 新增 3D 裝載器，可以將 3D 物件、特效等 Prefab 添加至裝載器，並在 HUD 介面中顯示
3. 在資源管理器中選擇和替換需要的 3D 資源
4. 可以單獨對掛載資源角度和整體縮放進行設置
5. 新增貼圖控件，開放九宮格、平舖、填充等更多顯示方式
6. 新增圖像填充方式，與貼圖一致
7. 新增頭像控件，幫助創作者獲取和展示玩家資訊，例如排行榜功能
8. 有兩種樣式提供創作者選擇，並可以單獨開關需要顯示的身分資訊，包含暱稱、紀念章、橫幅、段位等`,
  OB41_UP_3: "支援使用腳本編輯",
  OB41_UP_3_D: `1. 更新插件功能
-錯誤提示
-語義重點顯示
懸浮提示
-定義跳轉
2. 更新引擎支援 
3. 新增腳本名稱，可通過右鍵或快捷鍵更改下列功能的腳本名稱
-自訂控件
-自訂屬性
-自訂枚舉
-枚舉內容
-自訂事情
-圖元變量
-自訂函數
-ECA 檔案`,
  OB41_UP_4: "數據儲存功能更新",
  OB41_UP_4_D: `1. 新增資料統計表
2. 新增定期清榜功能，可在發佈後通過「數據中心」>「管理存檔」>「定期清榜」設置
-清除的設置與戰場碼綁定`,
  OB41_UP_5: "動態導航網格",
  OB41_UP_5_D: `1. 需在程序設置中勾選「動態導航網格」來啟用功能
2.  啟用時，沒有選擇靜態導航網格屬性的物件和動態生成的物件，其動態增、減、顯示、陰影均會影響殭屍等 NPC 的尋路
3. 使用偵錯欄位可以導出當前伺服器運行的導航網格檔案來查看`,
  OB42A_UP_1_D: `1.優化編輯器基礎操作
2.更新動畫狀態機、腳本等系統`,
  OB42_UP_1: "新增資源商店",
  OB42_UP_1_D: `1. 引用包的結構：創作者自己製作的引用包會作為公有資源給其他使用者下載使用的；
2. 載入包體過程中新增引用包檔案類型，且支援自行選擇根日誌；
3. 商店和 資源庫的登入存取；
4. 資源包「製作-上傳-下載-匯入」的主流程跑通；`,
  OB42_UP_2: "支援導入骨架模型和動畫及其他相關應用程式",
  OB42_UP_2_D: `1. 支援導入骨骼模型和動畫檔案；
2. 動畫檔案支援預覽，且可在時間軸上新增自訂事件。`,
  OB42_UP_3: "地形編輯優化",
  OB42_UP_3_D: `1. 植被刷子類型增加樹木和石頭；
2. 增加植被擦快捷鍵，選取植被刷+Shift：擦除範圍內全部植被。選取植被刷+Ctrl：僅擦除目前所選植被
3. 增加筆刷範圍的顯
4. 優化了平滑工具的雕刻邏輯，增加地形平整功能的筆刷大小調整功能`,
  OB42_UP_4: "新增視覺化除錯工具",
  OB42_UP_4_D: `1. 現在實體資源於除錯期間仍能夠被檢視與修改位置
2. 支援查看實體伺服器數量與所需的儲存空間`,
  OB42_UP_5: "優化物理系統",
  OB42_UP_5_D: `1. 支持創建和編輯物理材質，使剛體具有彈性和摩擦力
2. 支持編輯全局重力
3. 支持休眠和喚醒剛體`,
  OB42_UP_6: "其他優化",
  OB42_UP_6_D: `1. 已使用的區塊現在支援全域（跨腳本檔案）搜尋。
2. 現在 ECA 檔案的剪輯引用支援全局搜尋。`,
  OB43A_UP_1: "基礎優化",
  OB43A_UP_1_D: `1.最佳化專案內之顯示功能
2.場景編輯器內增加操作提示
3.編輯器結構調整的遺留問題處理
4.其他BUG修復`,
  OB43_UP_1: "客戶邏輯",
  OB43_UP_1_D: `1. 添加了用於創建客戶相關塊和腳本邏輯的ECAC和FCGC文件；
2. 可互操作的塊將在ECA和ECAC文件中顯示，而那些無法互操作的塊將僅在其各自的文件中顯示；
3. 現在，通過自定義事件支持服務器和客戶端腳本之間的通信。`,
  OB43_UP_2: "結構優化",
  OB43_UP_2_D: `1. 更新 Craftland Studio 結構；
2. 文件管理由編輯器層級變更為文件層級；
3. 菜單欄更新並展開；
4. 工具欄/偵錯功能/偵錯設置位置變更；
5. 移除問卷反饋&帳號管理；
6. 模板功能關閉。`,
  OB43_UP_3: "新的相機功能",
  OB43_UP_3_D: "1. 新增第一人稱模型功能。必須選擇「使用最新的FPP資源」才能使用。目前僅支持SCAR。",
  OB43_UP_4: "新的物理特性",
  OB43_UP_4_D: "1. 新增角色控制器功能。",
  OB43_UP_5: "更新與編輯器優化",
  OB43_UP_5_D: `1. 允許自動更新。Craftland Studio啟動時，將自動檢查版本更新，如果有新版本，將通知用戶；
2. 在菜單中新增「檢查更新」選項，可用於檢查新版本；
3. 優化了方塊編輯器的性能，降低了在處理大量方塊時的卡頓感；
4. 優化了場景編輯器的性能以及多個選定對象的移動邏輯；
5. 在場景編輯器中新增了偵錯使用界面。`,
  OB43_UP_6: "MF0自定義角色",
  OB43_UP_6_D: `1. 支持以選定的《Free Fire》角色/預設角色（文件）進入遊戲；
2. 創建了一種新的文件類型，用於存儲所有預設角色的配置信息；
3. 預設角色允許配置角色模型和大部分所需的角色動作；
4. 為用戶提供了《Free Fire》的骨架文件。`,
  OB43_UP_7: "地圖優化",
  OB43_UP_7_D: `1. 新增“靜態”屬性，開啟靜態的物件將僅做局內渲染，並不作各種邏輯相關處理以降低性能消耗；
2. 允許對流場物件進行定制，以控制客戶端上的加載邏輯（需要啟用靜態功能）；
3. 升級了先前的「批次處理」功能為「渲染性能優化」，提供批處理和模型合併等選項。詳細內容請參閱Craftland Studio的官方資訊；
4. 減小了自定義資源的下載大小。`,
  OB43_UP_8: "新的腳本功能",
  OB43_UP_8_D: `1. 新增了腳本資源註冊功能；
2. 在腳本插件中新增了快速訪問函數定義的功能。`,
  OB44_UP_1: "客戶端邏輯",
  OB44_UP_1_D: `1.將提供更多支援客戶端邏輯的 API。
2. 在場景物件的屬性設置中，您可以選擇是否進行數據同步。`,
  OB44_UP_2: "效能工具優化",
  OB44_UP_2_D: `1.支援設定伺服器的場景載入範圍，這個設定可以將伺服器記憶體消耗降低
2.場景物件可以關閉靜態尋路功能
3.增加自動減面功能，可以對模型做不同尺寸、不同距離的減面設定`,
  OB44_UP_3: "其他優化",
  OB44_UP_3_D: `1.腳本現在支援單元測試、自動插件更新，以及直接定義自訂內容。
2. 新增了經典的《Free Fire》第一人稱視角相機。
3. 強化物理系統以提高韌性，使更多遊戲內物件受物理法則控制。
4. 優化整體用戶體驗。`,
  T_0_B_BotCanRevive: "人機能否復活",
  T_0_B_ReviveCDTime: "復活冷卻時間",
  T_37_M_WS_CONTENTERROR: "內容不合法，請修改",
  T_37_M_WS_PARANULL: "屬性值不得為空，請輸入屬性",
  T_37_WT_M_PARACHANGE: "設置失敗，房間參數已達上限",
  T_38_M_WS_CONFIG: "參數配置",
  T_38_M_WS_CREATECONFIG: "房間參數配置",
  T_38_M_WS_CREATEDEL: "從房間參數刪除",
  T_38_M_WS_CREATENAME: "房間參數名稱",
  T_38_M_WS_DELATT: "刪除屬性",
  T_38_M_WS_DELATTTIPS: "此屬性已轉換為「房間參數」，確認刪除該屬性？",
  T_38_M_WS_DISPLAYMODE: "參數顯示",
  T_38_M_WS_DOWN: "向下移動",
  T_38_M_WS_EDIT: "編輯參數",
  T_38_M_WS_MODIFY: "更改為房間參數",
  T_38_M_WS_MUTIPLE: "多選表單",
  T_38_M_WS_RANGE: "範圍選擇",
  T_38_M_WS_ROOMPAR: "自訂房間參數",
  T_38_M_WS_SINGLE: "單選表單",
  T_38_M_WS_UP: "向上移動",
  T_46_TYC_ADD_SP_ERROR: "AOI 設定錯誤：添加至觀察清單失敗。被觀察者 = {0}，觀察者 = {1}。",
  T_46_TYC_AOI_SP_PARAMS_ERROR: "AOI 設定錯誤：參數錯誤。 被觀察者 = {0}，觀察者 = {1}。",
  T_46_TYC_AOI_SUPO_INVALID_OBSERVER_ERROR: "AOI 設定錯誤：被觀察者不是有效使用者 或是 切換觀察者時變換實體。被觀察者 = {0}，觀察者 = {1}。",
  T_46_TYC_AOI_SUPO_INVALID_USER_ERROR: "AOI 設定錯誤：當切換觀察者時，玩家不是有效使用者。被觀察者 = {0}，觀察者 = {1}。",
  T_46_TYC_AOI_SUPO_PARAMS_ERROR: "AOI 設定錯誤：觀察者代理參數切換錯誤。被觀察者 = {0}，觀察者 = {1}。",
  T_46_TYC_CLEAN_SP_ERROR: "AOI 設定錯誤：清除觀察清單失敗。被觀察者 = {0}，觀察者 = {1}。",
  T_46_TYC_REMOVE_SP_ERROR: "AOI 設定錯誤：從觀察清單中移除失敗。被觀察者 = {0}，觀察者 = {1}。",
  T_46_TYC_SP_INVALID_USER_ERROR: "AOI 設定錯誤：非法觀察者。被觀察者 = {0}，觀察者 = {1}。",
  T_47_HL_CL_RECOMMEND_MORE: "查看更多",
  T_ACTIVATE_LOGIN_ACCOUNT: "已登錄 Craftland Studio 賬戶：",
  T_ACTIVATE_TITLE: "Craftland Studio 啟動",
  T_CONFIRMBOX_ACTIVATE_SUCCESS: "帳號已啟用",
  T_CONFIRMBOX_QUIT_CONTENT: "您即將關閉 Craftland Studio，確認嗎？",
  T_CONFIRMBOX_TITLE: "提示",
  T_DIALOG_CONFIRM: "啟用",
  T_ENTER_ACTIVATE_CODE: "當前 Craftland Studio 正處於測試階段，請輸入官方提供的序號",
  UI_DES: "表格佈局常用來製作背包系統，方便快速排版子級元素",
  UI_DES_1: "填滿版面佈局能快速將子級元素均分於母級元素下",
  UI_NAME: "表格佈局範例",
  UI_NAME_1: "填滿版面佈局範例"
};
export {
  _ as default
};
